
// import React, { useCallback, useEffect, useState, useMemo, useRef } from 'react';
// import * as XLSX from 'xlsx';
// import parties from '../data/party';
// import categoriesApi from '../data/categories';
// import stockes from '../data/stockhistory';
// import stockdata from '../data/stock';
// import { fetchStocknames } from '../data/Stocknames';
// import { fetchMutualnames } from '../data/Mutual';
// import Select from "react-select";
// import settingapi from '../data/setting';
// import AsyncSelect from "react-select/async";
// import OcrUploadModal from './OcrUploadModal';
// // ─────────────────────────────────────────────────────────────────────────────
// // TYPES
// // ─────────────────────────────────────────────────────────────────────────────

// interface Party {
//   id: number;
//   date: string;
//   name: string;
//   number: string;
//   contact_person_name: string;
//   contact_person_number: string;
//   categories: string[];
//   deleteparty: number;
//   total_amount?: number | string;
// }

// interface CategoryApiType {
//   id: number | string;
//   category_name: string;
// }

// interface Stock {
//   id: number | string;
//   name: string;
//   category: string;
// }

// interface StockNames {
//   id: number;
//   name: string;
//   screener: string;
//   ltp: string;
//   [key: string]: any;
// }

// interface OcrSubmitInput {
//     partyId: string | number;
//     category: string;
//     date: string;
//     rows: Array<{
//       id: string;
//       stock_name: string;
//       unit: string;
//       total_amount: string;
//       indirect_charges: string;
//       per_unit_charge: string;
//       confidence: 'high' | 'medium' | 'low';
//       raw_text?: string;
//       edited?: boolean;
//       deleted?: boolean;
//     }>;
//   }

// type StockCategoryInfo = {
//   id: number | string;
//   stockId: number | string;
//   stockName: string;
//   unit: string;
//   totalAmount: string;
//   indirectCharges: string;
//   perUnitCharge: string;
//   autoCalculated: boolean;
//   category: string;
//   error?: string;
// };

// type CategoryEntryMap = { [categoryName: string]: StockCategoryInfo[] };

// type PartyStockDBType = {
//   id: number | string;
//   date: string;
//   party_id: number | string;
//   categories: string | (StockDBCategoryItem | DirectCategoryItem)[];
// };

// type StockDBCategoryItem = {
//   id: number | string;
//   investment_type: string;
//   category: string;
//   stock_name: string;
//   unit: string;
//   total_amount: string;
//   indirect_charges: string;
//   perUnitCharge: string;
// };

// type DirectCategoryItem = {
//   investment_type: string;
//   total_amount: string | number;
//   date?: string;
//   [key: string]: any;
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // EXCEL UPLOAD TYPES
// // ─────────────────────────────────────────────────────────────────────────────

// type ExcelRow = {
//   stock_name: string;
//   unit: string | number;
//   total_amount: string | number;
//   indirect_charges?: string | number;
//   [key: string]: any;
// };

// type SheetData = {
//   sheetName: string;
//   fileName: string;
//   fileIndex: number;
//   rows: ExcelRow[];
// };

// type StockMatchStatus = 'matched' | 'fuzzy' | 'unmatched';

// type ProcessedExcelRow = ExcelRow & {
//   _rowId: string;
//   _sheetKey: string;
//   _matchStatus: StockMatchStatus;
//   _matchedName?: string;
//   _candidateMatches?: string[];
//   _userChoice?: string; // after user resolves
//   _addNew?: boolean;
//   _newStockName?: string;
// };

// type ExcelUploadStep = 'idle' | 'setup' | 'review' | 'resolving' | 'confirmed';

// // ─────────────────────────────────────────────────────────────────────────────
// // HELPERS
// // ─────────────────────────────────────────────────────────────────────────────

// const safeNumber = (val: any) => {
//   const num = parseFloat(val);
//   return isNaN(num) ? 0 : num;
// };

// let globalEntryId = 1;

// function emptyStockCategoryInfo(category = '', stockId: number | string = '', stockName = ''): StockCategoryInfo {
//   return {
//     id: globalEntryId++,
//     stockId,
//     stockName,
//     category,
//     unit: '',
//     totalAmount: '',
//     indirectCharges: '',
//     perUnitCharge: '',
//     autoCalculated: true,
//     error: undefined,
//   };
// }

// function fuzzyMatch(name: string, list: string[]): string[] {
//   const lower = name.toLowerCase().replace(/[^a-z0-9]/g, '');
//   return list
//     .filter(n => {
//       const nl = n.toLowerCase().replace(/[^a-z0-9]/g, '');
//       return nl.includes(lower) || lower.includes(nl) || levenshtein(lower, nl) <= 3;
//     })
//     .slice(0, 5);
// }

// function levenshtein(a: string, b: string): number {
//   const m = a.length, n = b.length;
//   const dp: number[][] = Array.from({ length: m + 1 }, (_, i) =>
//     Array.from({ length: n + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0))
//   );
//   for (let i = 1; i <= m; i++)
//     for (let j = 1; j <= n; j++)
//       dp[i][j] = a[i - 1] === b[j - 1] ? dp[i - 1][j - 1] : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
//   return dp[m][n];
// }

// function calculateTotalDeductedIncludingDirect(stockDbRows: PartyStockDBType[], partyId: string | number): number {
//   let total = 0;
//   stockDbRows.forEach(row => {
//     if (String(row.party_id) !== String(partyId)) return;
//     let arr: any[] = [];
//     try { arr = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[]; } catch {}
//     for (const item of arr) {
//       if (item?.investment_type === 'direct') total += safeNumber(item.total_amount);
//       else if (item?.category) { total += safeNumber(item.total_amount) + safeNumber(item.indirect_charges); }
//     }
//   });
//   return total;
// }

// function calculateTotalDeductedFromStockTable(stockDbRows: PartyStockDBType[], partyId: string | number): number {
//   let total = 0;
//   stockDbRows.forEach(row => {
//     if (String(row.party_id) !== String(partyId)) return;
//     let arr: any[] = [];
//     try { arr = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[]; } catch {}
//     for (const item of arr) {
//       if (item?.category) total += safeNumber(item.total_amount) + safeNumber(item.indirect_charges);
//     }
//   });
//   return total;
// }

// async function fetchStocksAPI(): Promise<Stock[]> {
//   return [
//     { id: 1, name: 'SBI', category: 'Equity' },
//     { id: 2, name: 'HDFC', category: 'Equity' },
//     { id: 3, name: 'RELIANCE', category: 'Equity' },
//     { id: 4, name: 'NIFTY-FUT', category: 'FNO' },
//     { id: 5, name: 'BANKNIFTY-OPT', category: 'FNO' },
//     { id: 6, name: 'ICICI MF', category: 'Mutual Funds' },
//     { id: 7, name: 'SBI MF', category: 'Mutual Funds' },
//     { id: 8, name: 'NIFTY ETF', category: 'ETF' },
//     { id: 9, name: 'GOLD ETF', category: 'ETF' },
//   ];
// }



// // ─────────────────────────────────────────────────────────────────────────────
// // COMPONENT
// // ─────────────────────────────────────────────────────────────────────────────

// interface Props {}
// interface OcrExtractedRow {
//     id: string;
//     stock_name: string;
//     unit: string;
//     total_amount: string;
//     indirect_charges: string;
//     per_unit_charge: string;
//     confidence: 'high' | 'medium' | 'low';
//     raw_text?: string;
//     edited?: boolean;
//     deleted?: boolean;
//     // NEW: per-row date from invoice
//     row_date?: string;
//   }
  
//   interface OcrInvoice {
//     invoice_no?: string;
//     date?: string;
//     rows: OcrExtractedRow[];
//   }
  
//   interface OcrResult {
//     party_name?: string;
//     category?: string;
//     doc_type?: string;
//     confidence_overall?: number;
//     // NEW: multiple invoices instead of a single date + rows
//     invoices: OcrInvoice[];
//     // fallback for single-invoice docs
//     date?: string;
//     rows?: OcrExtractedRow[];
//   }
  
//   interface OcrFile {
//     file: File;
//     id: string;
//     preview?: string;
//     status: 'pending' | 'processing' | 'done' | 'error';
//     result?: OcrResult;
//     error?: string;
//   }
  

// function Addstock(props: Props) {
//   // ── Core state ──────────────────────────────────────────────────────────────
//   const [data, setData] = useState({ partyId: '', date: '' });
//   const [investmentType, setInvestmentType] = useState<'direct' | 'structure'>('structure');
//   const [directPaymentAmount, setDirectPaymentAmount] = useState('');
//   const [categoryEntries, setCategoryEntries] = useState<CategoryEntryMap>({});
//   const [partiesList, setPartiesList] = useState<Party[]>([]);
//   const [allStocks, setAllStocks] = useState<Stock[]>([]);
//   const [categoriesFromApi, setCategoriesFromApi] = useState<CategoryApiType[]>([]);
//   const [stocksDb, setStocksDb] = useState<PartyStockDBType[]>([]);
//   const [stocksDataDb, setStocksDataDb] = useState<PartyStockDBType[]>([]);
//   const [urlParty, setUrlParty] = useState('');
//   const [stocksnames, setStocksnames] = useState<StockNames[]>([]);
//   const [mutualsnames, setMutualsnames] = useState<StockNames[]>([]);
//   const [selectedPartyTotalAmount, setSelectedPartyTotalAmount] = useState<number | null>(null);
//   const [deductedAvailable, setDeductedAvailable] = useState<number | null>(null);
//   const [totalamountspend, setTotalAmmountSpend] = useState<number>();
//   const [farmName, setFarmName] = useState<string>();
//   const exceedPromptedRef = useRef(false);

//   // ── Add-stock-name modal (Task 2) ────────────────────────────────────────────
//   const [showAddStockModal, setShowAddStockModal] = useState(false);
//   const [addStockModalCategory, setAddStockModalCategory] = useState<'stocks' | 'mutual'>('stocks');
//   const [pendingNewStockName, setPendingNewStockName] = useState('');
//   const [addStockLoading, setAddStockLoading] = useState(false);
//   // Which entry triggered the add-stock modal (for injecting back)
//   const addStockCallbackRef = useRef<((name: string) => void) | null>(null);

//   // ── Excel upload state ───────────────────────────────────────────────────────
//   const [excelUploadStep, setExcelUploadStep] = useState<ExcelUploadStep>('idle');
//   const [excelSetupPartyId, setExcelSetupPartyId] = useState('');
//   const [excelSetupCategory, setExcelSetupCategory] = useState('');
//   const [excelSetupDate, setExcelSetupDate] = useState('');
//   const [excelFiles, setExcelFiles] = useState<File[]>([]);
//   const [parsedSheets, setParsedSheets] = useState<SheetData[]>([]);
//   const [processedRows, setProcessedRows] = useState<{ [sheetKey: string]: ProcessedExcelRow[] }>({});
//   const [currentResolvingSheet, setCurrentResolvingSheet] = useState<string | null>(null);
//   const [currentResolvingRowId, setCurrentResolvingRowId] = useState<string | null>(null);
//   const [excelSubmitLoading, setExcelSubmitLoading] = useState(false);
//   const excelFileInputRef = useRef<HTMLInputElement>(null);

//   const [showOcrModal, setShowOcrModal] = useState(false);

//   // ─────────────────────────────────────────────────────────────────────────────
//   // DATA FETCHING
//   // ─────────────────────────────────────────────────────────────────────────────

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const partyId = urlParams.get('party') || '';
//     setUrlParty(partyId);
//     if (partyId) setData(prev => ({ ...prev, partyId }));
//   }, []);

//   const fetchParties = useCallback(async () => {
//     const res = await parties();
//     const cleaned = Array.isArray(res)
//       ? res.map((item: any) => ({
//           ...item,
//           categories: typeof item.categories === 'string'
//             ? (() => { try { const p = JSON.parse(item.categories); return Array.isArray(p) ? p : [item.categories]; } catch { return [item.categories]; } })()
//             : Array.isArray(item.categories) ? item.categories : [],
//           total_amount: item.total_amount !== undefined ? Number(item.total_amount) : undefined,
//         }))
//       : [];
//     setPartiesList(cleaned);
//   }, []);

//   useEffect(() => {
//     async function fetchSettingsApi() {
//       try {
//         const res = await settingapi();
//         if (Array.isArray(res)) {
//           const s = res.find((i: any) => i.meta_key === 'farm');
//           if (s?.meta_value) {
//             const obj = typeof s.meta_value === 'string' ? JSON.parse(s.meta_value) : s.meta_value;
//             if (typeof obj?.name === 'string') setFarmName(obj.name);
//           }
//         }
//       } catch {}
//     }
//     fetchSettingsApi();
//     fetchParties();
//     categoriesApi().then(r => Array.isArray(r) && setCategoriesFromApi(r));
//     fetchStocksAPI().then(s => setAllStocks(s));
//     stockes().then(r => setStocksDb(Array.isArray(r) ? r : [])).catch(() => setStocksDb([]));
//     stockdata().then(r => setStocksDataDb(Array.isArray(r) ? r : [])).catch(() => setStocksDataDb([]));
//     fetchStocknames().then(r => setStocksnames(Array.isArray(r) ? r : [])).catch(() => setStocksnames([]));
//     fetchMutualnames().then(r => setMutualsnames(Array.isArray(r) ? r : [])).catch(() => setMutualsnames([]));
//   }, [fetchParties]);

//   // ─────────────────────────────────────────────────────────────────────────────
//   // DERIVED
//   // ─────────────────────────────────────────────────────────────────────────────

//   const possibleCategories = useMemo(() => {
//     const activePartyId = data.partyId || urlParty;
//     if (!activePartyId || !partiesList.length) return [];
//     const party = partiesList.find(p => String(p.id) === String(activePartyId));
//     if (party?.categories?.length) return party.categories.map((n: string) => ({ category_name: n, id: n }));
//     return [];
//   }, [partiesList, data.partyId, urlParty]);

//   const excelSetupPossibleCategories = useMemo(() => {
//     if (!excelSetupPartyId || !partiesList.length) return [];
//     const party = partiesList.find(p => String(p.id) === String(excelSetupPartyId));
//     if (party?.categories?.length) return party.categories;
//     return [];
//   }, [partiesList, excelSetupPartyId]);

//   useEffect(() => {
//     if (data.partyId && partiesList.length) {
//       const party = partiesList.find(p => String(p.id) === String(data.partyId));
//       setSelectedPartyTotalAmount(party?.total_amount != null ? Number(party.total_amount) : null);
//     } else setSelectedPartyTotalAmount(null);
//   }, [data.partyId, partiesList]);

//   useEffect(() => {
//     if (!selectedPartyTotalAmount) { setDeductedAvailable(null); return; }
//     if (!data.partyId || !stocksDataDb.length) { setDeductedAvailable(selectedPartyTotalAmount); return; }
//     const dbDeducted = calculateTotalDeductedIncludingDirect(stocksDataDb, data.partyId);
//     let uiDeducted = 0;
//     Object.values(categoryEntries).flat().forEach(e => {
//       uiDeducted += safeNumber(e.totalAmount) + safeNumber(e.indirectCharges);
//     });
//     const result = selectedPartyTotalAmount - dbDeducted - uiDeducted;
//     setDeductedAvailable(result);
//     if (result < 0 && !exceedPromptedRef.current) {
//       setTimeout(() => {
//         const ok = window.confirm('You exceed your amount. Do you want to add it from margin money?');
//         exceedPromptedRef.current = true;
//         if (!ok) setDeductedAvailable(null);
//       }, 100);
//     }
//   }, [selectedPartyTotalAmount, investmentType, directPaymentAmount, categoryEntries, data.partyId, stocksDataDb]);

//   // ─────────────────────────────────────────────────────────────────────────────
//   // CATEGORY / ENTRY HANDLERS
//   // ─────────────────────────────────────────────────────────────────────────────

//   const isChecked = (cat: CategoryApiType) => Object.prototype.hasOwnProperty.call(categoryEntries, cat.category_name);

//   const handleCategory = (cat: CategoryApiType) => {
//     setCategoryEntries(prev => {
//       const copy = { ...prev };
//       if (copy[cat.category_name]) delete copy[cat.category_name];
//       else copy[cat.category_name] = [emptyStockCategoryInfo(cat.category_name)];
//       return copy;
//     });
//   };

//   const handleCategoryFieldChange = (cat: CategoryApiType, entryIdx: number, field: keyof StockCategoryInfo, value: string) => {
//     const category = cat.category_name;
//     setCategoryEntries(prev => {
//       const entries = [...(prev[category] || [])];
//       const entry = { ...(entries[entryIdx] || emptyStockCategoryInfo(category)) };
//       if (field === 'stockName') {
//         entry.stockName = value;
//         const s = allStocks.find(s => s.category === category && s.name.toLowerCase() === value.toLowerCase());
//         entry.stockId = s ? s.id : value;
//       } else if (field === 'stockId') {
//         entry.stockId = value;
//         const s = allStocks.find(s => s.category === category && String(s.id) === value);
//         entry.stockName = s ? s.name : value;
//       } else if (field === 'unit' || field === 'totalAmount' || field === 'indirectCharges') {
//         (entry as any)[field] = value;
//         const u = safeNumber(field === 'unit' ? value : entry.unit);
//         const t = safeNumber(field === 'totalAmount' ? value : entry.totalAmount);
//         const i = safeNumber(field === 'indirectCharges' ? value : entry.indirectCharges);
//         entry.perUnitCharge = u > 0 ? ((t + i) / u).toFixed(2) : '';
//         entry.autoCalculated = true;
//       } else if (field === 'perUnitCharge') {
//         entry.perUnitCharge = value;
//         entry.autoCalculated = false;
//       } else {
//         (entry as any)[field] = value;
//       }
//       entries[entryIdx] = entry;
//       return { ...prev, [category]: entries };
//     });
//   };

//   const handleAddEntry = (cat: CategoryApiType) => {
//     setCategoryEntries(prev => ({
//       ...prev,
//       [cat.category_name]: [...(prev[cat.category_name] || []), emptyStockCategoryInfo(cat.category_name)],
//     }));
//   };

//   const handleRemoveEntry = (cat: CategoryApiType, idx: number) => {
//     setCategoryEntries(prev => {
//       const entries = [...(prev[cat.category_name] || [])];
//       entries.splice(idx, 1);
//       const copy = { ...prev };
//       if (entries.length > 0) copy[cat.category_name] = entries;
//       else delete copy[cat.category_name];
//       return copy;
//     });
//   };

//   const handleInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
//     const { name, value } = e.target;
//     setData(prev => ({ ...prev, [name]: value }));
//     if (name === 'partyId') {
//       setInvestmentType('structure');
//       setCategoryEntries({});
//       setDirectPaymentAmount('');
//     }
//   };

//   // ─────────────────────────────────────────────────────────────────────────────
//   // TASK 2: ADD STOCK NAME INLINE
//   // ─────────────────────────────────────────────────────────────────────────────

//   const isMutualCategory = (catName: string) =>
//     catName.toLowerCase().includes('mutual');

//   const handleAddStockName = async () => {
//     if (!pendingNewStockName.trim()) { alert('Enter a stock name'); return; }
//     setAddStockLoading(true);
//     try {
//       const endpoint = addStockModalCategory === 'mutual'
//         ? `${process.env.REACT_APP_API_URL}/auth/mutualstocks`
//         : `${process.env.REACT_APP_API_URL}/auth/stocks`;
//       const res = await fetch(endpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ name: pendingNewStockName.trim() }),
//       });
//       if (!res.ok) throw new Error('Failed to add stock');
//       // Refresh stock lists
//       if (addStockModalCategory === 'mutual') {
//         fetchMutualnames().then(r => setMutualsnames(Array.isArray(r) ? r : []));
//       } else {
//         fetchStocknames().then(r => setStocksnames(Array.isArray(r) ? r : []));
//       }
//       // Inject name back into the entry that triggered this
//       if (addStockCallbackRef.current) addStockCallbackRef.current(pendingNewStockName.trim());
//       setShowAddStockModal(false);
//       setPendingNewStockName('');
//     } catch (err: any) {
//       alert('Error: ' + err.message);
//     } finally {
//       setAddStockLoading(false);
//     }
//   };

//   // ─────────────────────────────────────────────────────────────────────────────
//   // EXCEL UPLOAD: PARSE
//   // ─────────────────────────────────────────────────────────────────────────────

//   const handleExcelFilesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = Array.from(e.target.files || []);
//     setExcelFiles(prev => [...prev, ...files]);
//   };

//   const removeExcelFile = (idx: number) => {
//     setExcelFiles(prev => prev.filter((_, i) => i !== idx));
//   };

//   const parseExcelFiles = async (): Promise<SheetData[]> => {
//     const allSheets: SheetData[] = [];
//     for (let fi = 0; fi < excelFiles.length; fi++) {
//       const file = excelFiles[fi];
//       const buffer = await file.arrayBuffer();
//       const wb = XLSX.read(buffer, { type: 'array' });
//       for (const sheetName of wb.SheetNames) {
//         const ws = wb.Sheets[sheetName];
//         const raw: any[] = XLSX.utils.sheet_to_json(ws, { defval: '' });
//         // Normalize column names (lowercase, trim)
//         const rows: ExcelRow[] = raw.map(r => {
//           const norm: any = {};
//           for (const k of Object.keys(r)) {
//             norm[k.toLowerCase().trim().replace(/\s+/g, '_')] = r[k];
//           }
//           return {
//             stock_name: String(norm.stock_name || norm.stockname || norm.name || norm['stock name'] || '').trim(),
//             unit: norm.unit || norm.units || norm.qty || norm.quantity || '',
//             total_amount: norm.total_amount || norm.totalamount || norm.amount || norm.price || '',
//             indirect_charges: norm.indirect_charges || norm.indirectcharges || norm.charges || '0',
//           } as ExcelRow;
//         }).filter(r => r.stock_name);
//         if (rows.length) {
//           allSheets.push({ sheetName, fileName: file.name, fileIndex: fi, rows });
//         }
//       }
//     }
//     return allSheets;
//   };

//   const processSheets = (sheets: SheetData[], stockNameList: string[]) => {
//     const result: { [sheetKey: string]: ProcessedExcelRow[] } = {};
//     for (const sheet of sheets) {
//       const key = `${sheet.fileIndex}__${sheet.fileName}__${sheet.sheetName}`;
//       result[key] = sheet.rows.map((row, ri) => {
//         const name = row.stock_name;
//         const exact = stockNameList.find(n => n.toLowerCase() === name.toLowerCase());
//         let matchStatus: StockMatchStatus;
//         let matchedName: string | undefined;
//         let candidates: string[] = [];
//         if (exact) {
//           matchStatus = 'matched';
//           matchedName = exact;
//         } else {
//           candidates = fuzzyMatch(name, stockNameList);
//           matchStatus = candidates.length ? 'fuzzy' : 'unmatched';
//         }
//         return {
//           ...row,
//           _rowId: `${key}__${ri}`,
//           _sheetKey: key,
//           _matchStatus: matchStatus,
//           _matchedName: matchedName,
//           _candidateMatches: candidates,
//           _userChoice: matchedName,
//           _addNew: false,
//           _newStockName: '',
//         } as ProcessedExcelRow;
//       });
//     }
//     return result;
//   };

//   const handleExcelProceed = async () => {
//     if (!excelSetupPartyId) { alert('Select a party'); return; }
//     if (!excelSetupCategory) { alert('Select a category'); return; }
//     if (!excelSetupDate) { alert('Select a date'); return; }
//     if (!excelFiles.length) { alert('Upload at least one Excel file'); return; }

//     const sheets = await parseExcelFiles();
//     if (!sheets.length) { alert('No valid rows found. Check column names: stock_name, unit, total_amount'); return; }

//     const isMutual = isMutualCategory(excelSetupCategory);
//     const nameList = (isMutual ? mutualsnames : stocksnames).map(s => s.name);
//     const processed = processSheets(sheets, nameList);

//     setParsedSheets(sheets);
//     setProcessedRows(processed);
//     setExcelUploadStep('review');
//   };

//   // Rows that need resolution (fuzzy or unmatched)
//   const unresolvedRows = useMemo(() => {
//     const rows: ProcessedExcelRow[] = [];
//     for (const sheetRows of Object.values(processedRows)) {
//       for (const row of sheetRows) {
//         if (row._matchStatus !== 'matched' && !row._userChoice && !row._addNew) rows.push(row);
//       }
//     }
//     return rows;
//   }, [processedRows]);

//   const updateProcessedRow = (sheetKey: string, rowId: string, patch: Partial<ProcessedExcelRow>) => {
//     setProcessedRows(prev => ({
//       ...prev,
//       [sheetKey]: prev[sheetKey].map(r => r._rowId === rowId ? { ...r, ...patch } : r),
//     }));
//   };

//   // ─────────────────────────────────────────────────────────────────────────────
//   // EXCEL SUBMIT
//   // ─────────────────────────────────────────────────────────────────────────────

//   const handleExcelSubmit = async () => {
//     setExcelSubmitLoading(true);
//     try {
//       const isMutual = isMutualCategory(excelSetupCategory);

//       // 1. Add new stock names first
//       const rowsToAddAsNewStock: ProcessedExcelRow[] = [];
//       for (const sheetRows of Object.values(processedRows)) {
//         for (const row of sheetRows) {
//           if (row._addNew && row._newStockName?.trim()) rowsToAddAsNewStock.push(row);
//         }
//       }
//       const addedNames: Set<string> = new Set();
//       for (const row of rowsToAddAsNewStock) {
//         const nm = row._newStockName!.trim();
//         if (addedNames.has(nm)) continue;
//         addedNames.add(nm);
//         const ep = isMutual
//           ? `${process.env.REACT_APP_API_URL}/auth/mutualstocks`
//           : `${process.env.REACT_APP_API_URL}/auth/stocks`;
//         await fetch(ep, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ name: nm }),
//         });
//       }

//       // 2. Group rows by sheet and submit each sheet's rows as separate entries
//       for (const [sheetKey, sheetRows] of Object.entries(processedRows)) {
//         const validRows = sheetRows.filter(r => {
//           const finalName = r._addNew ? r._newStockName : (r._userChoice || r._matchedName || r.stock_name);
//           return finalName?.trim();
//         });
//         if (!validRows.length) continue;

//         // Build categories array for this sheet
//         const cats = validRows.map((row, i) => {
//           const finalName = (row._addNew ? row._newStockName : (row._userChoice || row._matchedName || row.stock_name)) || '';
//           const unit = String(row.unit || '0');
//           const total = String(row.total_amount || '0');
//           const indirect = String(row.indirect_charges || '0');
//           const u = safeNumber(unit), t = safeNumber(total), ind = safeNumber(indirect);
//           return {
//             id: globalEntryId++,
//             stock_name: finalName,
//             unit,
//             total_amount: total,
//             indirect_charges: indirect,
//             perUnitCharge: u > 0 ? ((t + ind) / u).toFixed(2) : '0',
//             category: excelSetupCategory,
//             investment_type: 'structure',
//             total_amount_category: total,
//           };
//         });

//         // Check for existing stocks -> PUT, new -> POST
//         const rowUpdates = new Map<any, any>();
//         const newCats: any[] = [];
//         let grandTotal = 0;

//         for (const cat of cats) {
//           grandTotal += safeNumber(cat.total_amount) + safeNumber(cat.indirect_charges);
//           const existingRow = stocksDataDb.find(row => {
//             if (String(row.party_id) !== String(excelSetupPartyId)) return false;
//             const items: any[] = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[];
//             return items.some(i => i.stock_name === cat.stock_name && i.category === excelSetupCategory);
//           });
//           if (existingRow) {
//             const arr: any[] = typeof existingRow.categories === 'string' ? JSON.parse(existingRow.categories) : [...existingRow.categories as any[]];
//             const target = arr.find(i => i.stock_name === cat.stock_name && i.category === excelSetupCategory);
//             if (target) {
//               const tu = safeNumber(target.unit) + safeNumber(cat.unit);
//               const ta = safeNumber(target.total_amount) + safeNumber(cat.total_amount);
//               const ti = safeNumber(target.indirect_charges) + safeNumber(cat.indirect_charges);
//               target.unit = tu.toString(); target.total_amount = ta.toString(); target.indirect_charges = ti.toString();
//               target.perUnitCharge = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0';
//               rowUpdates.set(existingRow.id, { arr, lastName: cat.stock_name, lastCat: excelSetupCategory, lastUnit: tu.toString(), lastTotal: ta.toString(), lastIndirect: ti.toString(), lastPrice: target.perUnitCharge });
//             }
//           } else {
//             newCats.push(cat);
//           }
//         }

//         // PUT existing
//         for (const [rowId, obj] of rowUpdates.entries()) {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//             method: 'PUT',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               id: rowId, party_id: excelSetupPartyId,
//               categories: JSON.stringify(obj.arr),
//               name: obj.lastName, category: obj.lastCat,
//               unit: obj.lastUnit, price_per_unit: obj.lastPrice,
//               total_amount: obj.lastTotal, indirect_charges: obj.lastIndirect,
//               date: excelSetupDate,
//             }),
//           });
//         }

//         // POST new
//         if (newCats.length) {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ party_id: excelSetupPartyId, date: excelSetupDate, investment_type: 'structure', categories: newCats }),
//           });
//         }

//         // buysellrecord + usermeta
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ date: excelSetupDate, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }),
//         }).catch(() => {});

//         const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${excelSetupPartyId}`);
//         const umList = await umRes.json();
//         const found = Array.isArray(umList) ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(excelSetupPartyId)) : null;
//         if (found) {
//           const newVal = (safeNumber(found.meta_value) - grandTotal).toString();
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, {
//             method: 'PUT', headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ meta_key: 'remaining', meta_value: newVal, party_id: excelSetupPartyId }),
//           });
//         }
//       }

//       alert('Excel data submitted successfully!');
//       setExcelUploadStep('idle');
//       setParsedSheets([]);
//       setProcessedRows({});
//       setExcelFiles([]);
//       setExcelSetupPartyId('');
//       setExcelSetupCategory('');
//       setExcelSetupDate('');
//       window.location.reload();
//     } catch (err: any) {
//       alert('Error: ' + err.message);
//     } finally {
//       setExcelSubmitLoading(false);
//     }
//   };

//   // ─────────────────────────────────────────────────────────────────────────────
//   // MAIN SUBMIT
//   // ─────────────────────────────────────────────────────────────────────────────

//   const getNextCategoryId = () => {
//     const ids: number[] = [];
//     stocksDataDb.forEach(row => {
//       const items = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories;
//       (items as any[]).forEach(i => i.id && ids.push(Number(i.id)));
//     });
//     return (ids.length ? Math.max(...ids) : 0) + 1;
//   };

//   const handleSubmit = async (e?: React.FormEvent) => {
//     if (e) e.preventDefault();
//     if (!data.partyId) { alert('Please select a party'); return; }
//     const party = partiesList.find(p => String(p.id) === String(data.partyId));
//     const availableTotalAmount = party?.total_amount != null ? Number(party.total_amount) : null;
//     if (availableTotalAmount == null) { alert('Could not determine total amount available.'); return; }
//     const currentInvestmentType = investmentType;
//     const selectedCategories = Object.keys(categoryEntries);
//     if (selectedCategories.length === 0) { alert('Please select at least one category'); return; }

//     const rowUpdates = new Map<any, any>();
//     let categoriesToPost: any[] = [];
//     let grandTotal = 0;
//     let datainvoiceAll: any[] = [];

//     for (const categoryName of selectedCategories) {
//       const entries = categoryEntries[categoryName];
//       for (const catInfo of entries) {
//         if (!catInfo.stockName?.trim()) continue;
//         const amt = safeNumber(catInfo.totalAmount), ind = safeNumber(catInfo.indirectCharges);
//         grandTotal += amt + ind;
//         datainvoiceAll.push({ id: catInfo.id, stock_name: catInfo.stockName, unit: catInfo.unit, total_amount: catInfo.totalAmount, indirect_charges: catInfo.indirectCharges ?? '0', perUnitCharge: catInfo.perUnitCharge, category: categoryName, investment_type: currentInvestmentType, total_amount_category: catInfo.totalAmount });
//         const existingRow = stocksDataDb.find(row => {
//           if (String(row.party_id) !== String(data.partyId)) return false;
//           const items: any[] = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[];
//           return items.some(i => i.stock_name === catInfo.stockName && i.category === categoryName);
//         });
//         if (existingRow) {
//           const arr: any[] = rowUpdates.has(existingRow.id) ? rowUpdates.get(existingRow.id).updatedCategories : (typeof existingRow.categories === 'string' ? JSON.parse(existingRow.categories) : [...existingRow.categories as any[]]);
//           const target = arr.find((i: any) => i.stock_name === catInfo.stockName && i.category === categoryName);
//           if (target) {
//             const tu = safeNumber(target.unit) + safeNumber(catInfo.unit);
//             const ta = safeNumber(target.total_amount) + amt;
//             const ti = safeNumber(target.indirect_charges) + ind;
//             const avgP = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0.00';
//             target.unit = tu.toString(); target.total_amount = ta.toString(); target.indirect_charges = ti.toString(); target.perUnitCharge = avgP; target.total_amount_category = ta.toString(); target.investment_type = currentInvestmentType;
//             rowUpdates.set(existingRow.id, { updatedCategories: arr, lastCatId: catInfo.id, lastName: catInfo.stockName, lastCategory: categoryName, lastUnit: tu.toString(), lastPrice: avgP, lastTotal: ta.toString(), lastIndirect: ti.toString() });
//           }
//         } else {
//           categoriesToPost.push({ id: catInfo.id, stock_name: catInfo.stockName, unit: catInfo.unit, total_amount: catInfo.totalAmount, indirect_charges: catInfo.indirectCharges ?? '0', perUnitCharge: catInfo.perUnitCharge, category: categoryName, investment_type: currentInvestmentType, total_amount_category: catInfo.totalAmount });
//         }
//       }
//     }

//     if (typeof setTotalAmmountSpend === 'function') setTotalAmmountSpend(grandTotal);

//     try {
//       await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ date: data.date, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }) });
//     } catch {}
//     try {
//       await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ farm: farmName, party: data.partyId, invoice_type: 'purchase', date: data.date, datainvoice: datainvoiceAll }) });
//     } catch {}

//     const handleUserMetaUpdate = async (amount: number) => {
//       try {
//         const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${data.partyId}`);
//         const umList = await umRes.json();
//         const found = Array.isArray(umList) ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(data.partyId)) : null;
//         if (found) {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ meta_key: 'remaining', meta_value: (safeNumber(found.meta_value) - amount).toString(), party_id: data.partyId }) });
//         } else {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ meta_key: 'remaining', meta_value: ((availableTotalAmount || 0) - amount).toString(), party_id: data.partyId }) });
//         }
//       } catch {}
//     };

//     if (investmentType === 'direct') {
//       const payment = safeNumber(directPaymentAmount);
//       if (payment <= 0) { alert('Please enter valid payment amount'); return; }
//       try {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ party_id: data.partyId, date: data.date, investment_type: 'direct', categories: [{ id: getNextCategoryId(), stock_name: 'DirectPayment', unit: '0', total_amount: payment.toString(), category: 'Equity', indirect_charges: '0', perUnitCharge: '0', investment_type: 'direct', total_amount_category: payment.toString() }] }) });
//         await handleUserMetaUpdate(payment);
//         alert('Direct payment submitted'); window.location.reload(); return;
//       } catch (err) { alert('Error in direct payment'); return; }
//     }

//     try {
//       for (const [rowId, obj] of rowUpdates.entries()) {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: rowId, party_id: data.partyId, categories: JSON.stringify(obj.updatedCategories), name: obj.lastName, category: obj.lastCategory, unit: obj.lastUnit, price_per_unit: obj.lastPrice, total_amount: obj.lastTotal, indirect_charges: obj.lastIndirect, investment_type: currentInvestmentType, date: data.date || new Date().toISOString().split('T')[0] }) });
//       }
//       if (categoriesToPost.length) {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ party_id: data.partyId, date: data.date, investment_type: currentInvestmentType, categories: categoriesToPost }) });
//       }
//       await handleUserMetaUpdate(grandTotal);
//       alert('Submission successful'); window.location.reload();
//     } catch { alert('An error occurred during submission.'); }
//   };

//   // ─────────────────────────────────────────────────────────────────────────────
//   // RENDER HELPERS
//   // ─────────────────────────────────────────────────────────────────────────────

//   const renderMatchBadge = (status: StockMatchStatus) => {
//     if (status === 'matched') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">✓ Matched</span>;
//     if (status === 'fuzzy') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">⚠ Fuzzy</span>;
//     return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">✗ Not Found</span>;
//   };

//   const allRowsResolved = useMemo(() => {
//     for (const sheetRows of Object.values(processedRows)) {
//       for (const row of sheetRows) {
//         if (row._matchStatus !== 'matched' && !row._userChoice && !row._addNew) return false;
//       }
//     }
//     return true;
//   }, [processedRows]);

//   // ─────────────────────────────────────────────────────────────────────────────
//   // RENDER
//   // ─────────────────────────────────────────────────────────────────────────────


//   const handleOcrSubmit = async ({ partyId, category, batches }: {
//     partyId: string;
//     category: string;
//     batches: { date: string; rows: OcrExtractedRow[] }[];
//   }): Promise<void> => {
//     if (!partyId) { alert('Please select a party'); return; }
//     if (!category) { alert('Please select a category'); return; }
  
//     const party = partiesList.find(p => String(p.id) === String(partyId));
//     const availableTotalAmount = party?.total_amount != null ? Number(party.total_amount) : null;
//     if (availableTotalAmount == null) { alert('Could not determine total amount available.'); return; }
  
//     for (const batch of batches) {
//       if (!batch.date) continue;
//       const validRows = batch.rows.filter(r => r.stock_name?.trim());
//       if (!validRows.length) continue;
  
//       const rowUpdates = new Map<any, any>();
//       const categoriesToPost: any[] = [];
//       let grandTotal = 0;
//       const datainvoiceAll: any[] = [];
  
//       for (const row of validRows) {
//         const amt = safeNumber(row.total_amount);
//         const ind = safeNumber(row.indirect_charges);
//         grandTotal += amt + ind;
  
//         datainvoiceAll.push({
//           id: row.id,
//           stock_name: row.stock_name,
//           unit: row.unit,
//           total_amount: row.total_amount,
//           indirect_charges: row.indirect_charges ?? '0',
//           perUnitCharge: row.per_unit_charge,
//           category,
//           investment_type: 'structure',
//           total_amount_category: row.total_amount,
//         });
  
//         // Check if stock already exists in DB for this party+category
//         const existingRow = stocksDataDb.find(dbRow => {
//           if (String(dbRow.party_id) !== String(partyId)) return false;
//           const items: any[] = typeof dbRow.categories === 'string'
//             ? JSON.parse(dbRow.categories)
//             : dbRow.categories as any[];
//           return items.some(i => i.stock_name === row.stock_name && i.category === category);
//         });
  
//         if (existingRow) {
//           // PUT — merge into existing
//           const arr: any[] = rowUpdates.has(existingRow.id)
//             ? rowUpdates.get(existingRow.id).updatedCategories
//             : (typeof existingRow.categories === 'string'
//               ? JSON.parse(existingRow.categories)
//               : [...existingRow.categories as any[]]);
  
//           const target = arr.find((i: any) => i.stock_name === row.stock_name && i.category === category);
//           if (target) {
//             const tu = safeNumber(target.unit) + safeNumber(row.unit);
//             const ta = safeNumber(target.total_amount) + amt;
//             const ti = safeNumber(target.indirect_charges) + ind;
//             const avgP = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0.00';
//             target.unit = tu.toString();
//             target.total_amount = ta.toString();
//             target.indirect_charges = ti.toString();
//             target.perUnitCharge = avgP;
//             target.total_amount_category = ta.toString();
//             target.investment_type = 'structure';
//             rowUpdates.set(existingRow.id, {
//               updatedCategories: arr,
//               lastName: row.stock_name,
//               lastCategory: category,
//               lastUnit: tu.toString(),
//               lastPrice: avgP,
//               lastTotal: ta.toString(),
//               lastIndirect: ti.toString(),
//             });
//           }
//         } else {
//           // POST — new entry
//           categoriesToPost.push({
//             id: row.id,
//             stock_name: row.stock_name,
//             unit: row.unit,
//             total_amount: row.total_amount,
//             indirect_charges: row.indirect_charges ?? '0',
//             perUnitCharge: row.per_unit_charge,
//             category,
//             investment_type: 'structure',
//             total_amount_category: row.total_amount,
//           });
//         }
//       }
  
//       // ── buysellrecord ──────────────────────────────────────────────────────
//       try {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ date: batch.date, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }),
//         });
//       } catch {}
  
//       // ── invoice record ─────────────────────────────────────────────────────
//       try {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             farm: farmName,
//             party: partyId,
//             invoice_type: 'purchase',
//             date: batch.date,
//             datainvoice: datainvoiceAll,
//           }),
//         });
//       } catch {}
  
//       // ── PUT existing stocks ────────────────────────────────────────────────
//       for (const [rowId, obj] of rowUpdates.entries()) {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//           method: 'PUT',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             id: rowId,
//             party_id: partyId,
//             categories: JSON.stringify(obj.updatedCategories),
//             name: obj.lastName,
//             category: obj.lastCategory,
//             unit: obj.lastUnit,
//             price_per_unit: obj.lastPrice,
//             total_amount: obj.lastTotal,
//             indirect_charges: obj.lastIndirect,
//             investment_type: 'structure',
//             date: batch.date,
//           }),
//         });
//       }
  
//       // ── POST new stocks ────────────────────────────────────────────────────
//       if (categoriesToPost.length) {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             party_id: partyId,
//             date: batch.date,
//             investment_type: 'structure',
//             categories: categoriesToPost,
//           }),
//         });
//       }
  
//       // ── usermeta (remaining balance) ───────────────────────────────────────
//       try {
//         const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${partyId}`);
//         const umList = await umRes.json();
//         const found = Array.isArray(umList)
//           ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(partyId))
//           : null;
//         if (found) {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, {
//             method: 'PUT',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               meta_key: 'remaining',
//               meta_value: (safeNumber(found.meta_value) - grandTotal).toString(),
//               party_id: partyId,
//             }),
//           });
//         } else {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               meta_key: 'remaining',
//               meta_value: ((availableTotalAmount || 0) - grandTotal).toString(),
//               party_id: partyId,
//             }),
//           });
//         }
//       } catch {}
//     }
  
//     await fetchParties();
//     setShowOcrModal(false);
//   };
//   return (
//     <>
//       <div className="p-6">
//         {/* ── Header ── */}
//         <div className="w-full flex justify-between items-center mb-6">
//           <h1 className="text-[28px] text-[#101828] font-[500]">Add New Stock</h1>
//           <div className="flex gap-3">
//           <button
//             type="button"
//             onClick={() => setShowOcrModal(true)}
//             className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] py-2 px-5 rounded-[8px] shadow hover:opacity-90 transition duration-150"
//           >
//             <svg
//               className="w-5 h-5 text-white"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2}
//               viewBox="0 0 24 24"
//             >
//               <rect
//                 x="3"
//                 y="4"
//                 width="18"
//                 height="16"
//                 rx="2"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 fill="#fff"
//                 fillOpacity=".1"
//               />
//               <path
//                 d="M8 2v4M16 2v4M3 10h18"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//               />
//               <circle
//                 cx="12"
//                 cy="14"
//                 r="3"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 fill="none"
//               />
//             </svg>
//             Scan Document
//           </button>
//    {showOcrModal ? (
//   <OcrUploadModal
//   partiesList={partiesList}
//   stocksnames={stocksnames}
//   mutualsnames={mutualsnames}
//   onSubmit={handleOcrSubmit as any}
//   onClose={() => setShowOcrModal(false)}
//   apiUrl={process.env.REACT_APP_API_URL || ''}
// />
//    ) : null}
//             <button type="button" className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#1CAC70] to-[#FF9500] py-2 rounded-[8px] px-5" onClick={() => window.location.href = '/withdraw'}>Add Withdrawal</button>
//             <button type="button" className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#FF9500] to-[#1CAC70] py-2 rounded-[8px] px-5" onClick={() => window.location.href = '/sell-stock'}>Sell Stock</button>
//           </div>
//         </div>

//         {/* ── Manual Form ── */}
//         <form className="bg-white p-5 w-full rounded-[10px] shadow-sm" onSubmit={handleSubmit} autoComplete="off">
//           <div className="flex flex-wrap w-full justify-between mt-4 gap-4">
//             {/* Party */}
//             <div className="w-[100%] md:w-[48%]">
//               <label htmlFor="partyId" className="text-sm font-medium text-gray-700">Party Name</label>
//               <select name="partyId" id="partyId" value={data.partyId || urlParty} onChange={handleInput} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" required>
//                 <option value="">Choose Party</option>
//                 {partiesList.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
//               </select>
//               {selectedPartyTotalAmount !== null && <div className="text-xs text-blue-600 mt-1">Total Available: ₹{selectedPartyTotalAmount.toLocaleString()}</div>}
//               {deductedAvailable !== null && <div className="text-xs mt-1" style={{ color: deductedAvailable < 0 ? '#D8000C' : '#007200' }}>Available After Deduction: ₹{deductedAvailable.toLocaleString()}</div>}
//             </div>
//             {/* Date */}
//             <div className="w-[100%] md:w-[48%]">
//               <label htmlFor="date" className="text-sm font-medium text-gray-700">Date Of Purchase</label>
//               <input type="date" name="date" id="date" value={data.date} onChange={handleInput} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" />
//             </div>
//             {/* Investment Type */}
//             <div className="w-[100%] md:w-[48%]">
//               <label className="text-sm font-medium text-gray-700">Investment Type</label>
//               <select value={investmentType} onChange={e => { setInvestmentType(e.target.value as any); setDirectPaymentAmount(''); setCategoryEntries({}); }} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1">
//                 <option value="direct">Direct Payment</option>
//                 <option value="structure">Structure Payment</option>
//               </select>
//             </div>
//           </div>

//           {investmentType === 'direct' && (
//             <div className="mt-4 w-full md:w-[48%]">
//               <label className="text-sm font-medium text-gray-700">Payment Amount</label>
//               <input type="number" min={0} step="any" placeholder="Enter payment amount" value={directPaymentAmount} onChange={e => setDirectPaymentAmount(e.target.value)} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" required />
//             </div>
//           )}

//           {/* Categories */}
//           {(data.partyId || urlParty) && (
//             <div className="mt-6">
//               <p className="text-sm font-semibold text-gray-700 mb-3">Categories</p>
//               <div className="flex flex-col gap-3">
//                 {possibleCategories.map(cat => {
//                   const entries = categoryEntries[cat.category_name] || [];
//                   const isMutual = isMutualCategory(cat.category_name);
//                   return (
//                     <div key={cat.id} className="flex flex-col">
//                       <label className="flex items-center gap-2 cursor-pointer text-[#344054] text-[15px] font-medium">
//                         <input type="checkbox" checked={isChecked(cat)} onChange={() => handleCategory(cat)} className="w-4 h-4 accent-[#FF9500]" />
//                         {cat.category_name}
//                       </label>
//                       {isChecked(cat) && investmentType === 'structure' && (
//                         <div className="ml-6 mt-2 flex flex-col gap-3 border-l-2 border-[#ececec] pl-4">
//                           {entries.map((entry, ei) => (
//                             <div key={entry.id} className="flex flex-wrap gap-2 items-end bg-gray-50 p-3 rounded-lg relative">
//                               {/* ID */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">ID</label>
//                                 <input type="text" value={entry.id} readOnly className="w-[52px] bg-gray-100 border border-[#D0D5DD] p-2 rounded-[8px] text-[#5E5E5E] text-[12px] outline-none" />
//                               </div>
//                               {/* Stock Name with AsyncSelect + Add button */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">Stock Name</label>
//                                 <div className="flex gap-1 items-center">
//                                   <AsyncSelect
//                                     cacheOptions
//                                     defaultOptions={false}
//                                     loadOptions={(input, cb) => {
//                                       if (!input || input.length < 1) { cb([]); return; }
//                                       const src = isMutual ? mutualsnames : stocksnames;
//                                       const filtered = src.filter(s => s.name?.toLowerCase().includes(input.toLowerCase())).slice(0, 100).map(s => ({ value: s.name, label: s.name }));
//                                       cb(filtered);
//                                     }}
//                                     value={entry.stockName ? { value: entry.stockName, label: entry.stockName } : null}
//                                     onChange={sel => handleCategoryFieldChange(cat, ei, 'stockName', sel?.value || '')}
//                                     placeholder={isMutual ? 'Search Mutual Fund...' : 'Search Stock...'}
//                                     noOptionsMessage={({ inputValue }) =>
//                                       inputValue?.length > 0
//                                         ? <span className="text-xs text-gray-500">No match — type to search or use "+" to add</span>
//                                         : <span className="text-xs text-gray-400">Type to search…</span>
//                                     }
//                                     styles={{ control: (b) => ({ ...b, borderRadius: '8px', borderColor: '#D0D5DD', minHeight: '38px', width: '210px', fontSize: '13px' }) }}
//                                   />
//                                   {/* Task 2: Add stock button */}
//                                   <button
//                                     type="button"
//                                     title="Add new stock name"
//                                     onClick={() => {
//                                       setAddStockModalCategory(isMutual ? 'mutual' : 'stocks');
//                                       setPendingNewStockName(entry.stockName || '');
//                                       addStockCallbackRef.current = (name: string) => {
//                                         handleCategoryFieldChange(cat, ei, 'stockName', name);
//                                       };
//                                       setShowAddStockModal(true);
//                                     }}
//                                     className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 transition font-bold text-lg"
//                                     style={{ flexShrink: 0 }}
//                                   >
//                                     +
//                                   </button>
//                                 </div>
//                                 {entry.stockName && !(isMutual ? mutualsnames : stocksnames).some(s => s.name.toLowerCase() === entry.stockName.toLowerCase()) && (
//                                   <span className="text-[10px] text-amber-600 mt-0.5 flex items-center gap-1">
//                                     ⚠ Not in database —
//                                     <button
//                                       type="button"
//                                       onClick={() => {
//                                         setAddStockModalCategory(isMutual ? 'mutual' : 'stocks');
//                                         setPendingNewStockName(entry.stockName);
//                                         addStockCallbackRef.current = (name: string) => handleCategoryFieldChange(cat, ei, 'stockName', name);
//                                         setShowAddStockModal(true);
//                                       }}
//                                       className="underline text-blue-600 hover:text-blue-800"
//                                     >
//                                       Add to database?
//                                     </button>
//                                   </span>
//                                 )}
//                               </div>
//                               {/* Unit */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">Unit</label>
//                                 <input type="number" min={0} step="any" placeholder="Unit" value={entry.unit} onChange={e => handleCategoryFieldChange(cat, ei, 'unit', e.target.value)} className="w-[100px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
//                               </div>
//                               {/* Total Amount */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">Total Amount</label>
//                                 <input type="number" min={0} step="any" placeholder="Amount" value={entry.totalAmount} onChange={e => handleCategoryFieldChange(cat, ei, 'totalAmount', e.target.value)} className="w-[120px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
//                               </div>
//                               {/* Indirect Charges */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">Indirect Charges</label>
//                                 <input type="number" min={0} step="any" placeholder="Charges" value={entry.indirectCharges} onChange={e => handleCategoryFieldChange(cat, ei, 'indirectCharges', e.target.value)} className="w-[110px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
//                               </div>
//                               {/* Per Unit Charge */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">Per Unit Charge</label>
//                                 <input type="number" min={0} step="any" placeholder="Per unit" value={entry.perUnitCharge} onChange={e => handleCategoryFieldChange(cat, ei, 'perUnitCharge', e.target.value)} readOnly={entry.autoCalculated && !!entry.unit} className={`w-[110px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none ${entry.autoCalculated && !!entry.unit ? 'bg-gray-100' : ''}`} required />
//                                 {entry.autoCalculated && !!entry.unit && <span className="text-[10px] text-green-500">Auto-calc</span>}
//                               </div>
//                               {/* Remove */}
//                               <button type="button" onClick={() => handleRemoveEntry(cat, ei)} className="text-red-400 hover:text-red-600 border border-red-200 bg-red-50 rounded px-2 py-1 text-xs h-[34px]">Remove</button>
//                             </div>
//                           ))}
//                           <button type="button" onClick={() => handleAddEntry(cat)} className="text-sm text-blue-500 font-medium px-3 py-1 border border-blue-200 rounded bg-blue-50 w-fit hover:bg-blue-100 transition">+ Add row for {cat.category_name}</button>
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}

//           <button type="submit" className="mt-6 text-[16px] font-[500] text-white bg-gradient-to-r from-[#1CAC70] to-[#FF9500] py-2 rounded-[8px] px-8 hover:opacity-90 transition">Submit</button>
//         </form>
//       </div>

//       {/* ══════════════════════════════════════════════════════════════════════════
//           EXCEL UPLOAD MODAL — STEP: SETUP
//       ══════════════════════════════════════════════════════════════════════════ */}
//       {excelUploadStep === 'setup' && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
//             {/* Header */}
//             <div className="bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] px-6 py-5">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <h2 className="text-xl font-bold text-white">Upload Excel Data</h2>
//                   <p className="text-indigo-200 text-sm mt-0.5">Step 1 of 2 — Configure import settings</p>
//                 </div>
//                 <button onClick={() => { setExcelUploadStep('idle'); setExcelFiles([]); }} className="text-white/70 hover:text-white text-2xl">×</button>
//               </div>
//             </div>

//             <div className="p-6 flex flex-col gap-4">
//               {/* Party */}
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 block mb-1">Party Name <span className="text-red-500">*</span></label>
//                 <select value={excelSetupPartyId} onChange={e => { setExcelSetupPartyId(e.target.value); setExcelSetupCategory(''); }} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400">
//                   <option value="">Choose Party</option>
//                   {partiesList.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
//                 </select>
//               </div>
//               {/* Category */}
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 block mb-1">Category <span className="text-red-500">*</span></label>
//                 <select value={excelSetupCategory} onChange={e => setExcelSetupCategory(e.target.value)} disabled={!excelSetupPartyId} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400 disabled:bg-gray-100">
//                   <option value="">Select Category</option>
//                   {excelSetupPossibleCategories.map(c => <option key={c} value={c}>{c}</option>)}
//                 </select>
//               </div>
//               {/* Date */}
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 block mb-1">Purchase Date <span className="text-red-500">*</span></label>
//                 <input type="date" value={excelSetupDate} onChange={e => setExcelSetupDate(e.target.value)} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400" />
//               </div>

//               {/* File Upload */}
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 block mb-2">Excel Files <span className="text-red-500">*</span></label>
//                 <div
//                   className="border-2 border-dashed border-indigo-200 rounded-xl p-6 text-center cursor-pointer hover:border-indigo-400 hover:bg-indigo-50/50 transition"
//                   onClick={() => excelFileInputRef.current?.click()}
//                 >
//                   <div className="text-3xl mb-2">📊</div>
//                   <p className="text-sm text-gray-600 font-medium">Click to browse or drop Excel files here</p>
//                   <p className="text-xs text-gray-400 mt-1">Supports .xlsx, .xls — multiple files allowed, all sheets imported</p>
//                   <p className="text-xs text-indigo-500 mt-1 font-medium">Required columns: <code className="bg-indigo-50 px-1 rounded">stock_name</code>, <code className="bg-indigo-50 px-1 rounded">unit</code>, <code className="bg-indigo-50 px-1 rounded">total_amount</code></p>
//                 </div>
//                 <input ref={excelFileInputRef} type="file" accept=".xlsx,.xls" multiple className="hidden" onChange={handleExcelFilesChange} />
//                 {excelFiles.length > 0 && (
//                   <div className="mt-3 flex flex-col gap-1.5">
//                     {excelFiles.map((f, i) => (
//                       <div key={i} className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
//                         <div className="flex items-center gap-2">
//                           <span className="text-green-500">📄</span>
//                           <span className="text-sm text-gray-700 font-medium">{f.name}</span>
//                           <span className="text-xs text-gray-400">({(f.size / 1024).toFixed(1)} KB)</span>
//                         </div>
//                         <button type="button" onClick={() => removeExcelFile(i)} className="text-red-400 hover:text-red-600 text-lg leading-none">×</button>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               <div className="flex gap-3 mt-2">
//                 <button type="button" onClick={() => { setExcelUploadStep('idle'); setExcelFiles([]); }} className="flex-1 border border-gray-300 text-gray-700 rounded-lg py-2.5 font-medium hover:bg-gray-50 transition">Cancel</button>
//                 <button type="button" onClick={handleExcelProceed} className="flex-1 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white rounded-lg py-2.5 font-medium hover:opacity-90 transition">Preview & Review →</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
     

//       {/* ══════════════════════════════════════════════════════════════════════════
//           EXCEL UPLOAD MODAL — STEP: REVIEW
//       ══════════════════════════════════════════════════════════════════════════ */}
//       {excelUploadStep === 'review' && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl mx-4 flex flex-col" style={{ maxHeight: '90vh' }}>
//             {/* Header */}
//             <div className="bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] px-6 py-5 rounded-t-2xl flex-shrink-0">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <h2 className="text-xl font-bold text-white">Review Import Data</h2>
//                   <p className="text-indigo-200 text-sm mt-0.5">Step 2 of 2 — Verify stock matches and resolve conflicts</p>
//                 </div>
//                 <button onClick={() => setExcelUploadStep('setup')} className="text-white/70 hover:text-white text-2xl">×</button>
//               </div>
//               {/* Summary bar */}
//               <div className="flex gap-4 mt-3">
//                 {(() => {
//                   let matched = 0, fuzzy = 0, unmatched = 0;
//                   Object.values(processedRows).flat().forEach(r => {
//                     if (r._matchStatus === 'matched') matched++;
//                     else if (r._matchStatus === 'fuzzy') fuzzy++;
//                     else unmatched++;
//                   });
//                   const total = matched + fuzzy + unmatched;
//                   return (
//                     <>
//                       <div className="bg-white/20 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{total}</span> total rows</div>
//                       <div className="bg-green-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{matched}</span> matched</div>
//                       {fuzzy > 0 && <div className="bg-yellow-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{fuzzy}</span> fuzzy</div>}
//                       {unmatched > 0 && <div className="bg-red-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{unmatched}</span> not found</div>}
//                     </>
//                   );
//                 })()}
//               </div>
//             </div>

//             {/* Content */}
//             <div className="overflow-y-auto flex-1 p-6">
//               {Object.entries(processedRows).map(([sheetKey, rows]) => {
//                 const parts = sheetKey.split('__');
//                 const fileName = parts[1], sheetName = parts[2];
//                 return (
//                   <div key={sheetKey} className="mb-8">
//                     <div className="flex items-center gap-2 mb-3">
//                       <div className="bg-indigo-100 text-indigo-700 rounded-lg px-3 py-1 text-sm font-semibold">📄 {fileName}</div>
//                       <div className="bg-gray-100 text-gray-600 rounded-lg px-3 py-1 text-sm">Sheet: {sheetName}</div>
//                       <div className="text-xs text-gray-400">{rows.length} rows</div>
//                     </div>
//                     <div className="border border-gray-200 rounded-xl overflow-hidden">
//                       <table className="w-full text-sm">
//                         <thead className="bg-gray-50">
//                           <tr>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">#</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Excel Stock Name</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Status</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Final Name</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Unit</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Amount</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {rows.map((row, ri) => (
//                             <tr key={row._rowId} className={`border-t border-gray-100 ${row._matchStatus === 'matched' ? 'bg-green-50/30' : row._matchStatus === 'fuzzy' ? 'bg-yellow-50/30' : 'bg-red-50/30'}`}>
//                               <td className="px-4 py-3 text-gray-500">{ri + 1}</td>
//                               <td className="px-4 py-3 font-medium text-gray-800">{row.stock_name}</td>
//                               <td className="px-4 py-3">{renderMatchBadge(row._matchStatus)}</td>
//                               <td className="px-4 py-3">
//                                 {row._addNew
//                                   ? <input type="text" placeholder="New stock name" value={row._newStockName || ''} onChange={e => updateProcessedRow(sheetKey, row._rowId, { _newStockName: e.target.value })} className="border border-blue-300 rounded-lg px-2 py-1 text-xs w-40 focus:outline-none focus:border-blue-500" />
//                                   : row._matchStatus === 'matched'
//                                     ? <span className="text-green-700 font-medium">{row._matchedName}</span>
//                                     : <select value={row._userChoice || ''} onChange={e => updateProcessedRow(sheetKey, row._rowId, { _userChoice: e.target.value })} className="border border-gray-300 rounded-lg px-2 py-1 text-xs w-44 focus:outline-none focus:border-indigo-400">
//                                         <option value="">— select match —</option>
//                                         {row._candidateMatches?.map(c => <option key={c} value={c}>{c}</option>)}
//                                       </select>
//                                 }
//                               </td>
//                               <td className="px-4 py-3 text-gray-700">{row.unit}</td>
//                               <td className="px-4 py-3 text-gray-700">₹{safeNumber(row.total_amount).toLocaleString()}</td>
//                               <td className="px-4 py-3">
//                                 {row._matchStatus !== 'matched' && (
//                                   row._addNew
//                                     ? <button type="button" onClick={() => updateProcessedRow(sheetKey, row._rowId, { _addNew: false, _newStockName: '', _userChoice: '' })} className="text-xs text-gray-500 hover:text-gray-700 underline">Cancel</button>
//                                     : <button type="button" onClick={() => updateProcessedRow(sheetKey, row._rowId, { _addNew: true, _userChoice: '', _newStockName: row.stock_name })} className="text-xs bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 rounded px-2 py-1 transition">+ Add New</button>
//                                 )}
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             {/* Footer */}
//             <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 rounded-b-2xl flex-shrink-0 flex items-center justify-between">
//               <div className="text-sm text-gray-500">
//                 {!allRowsResolved
//                   ? <span className="text-amber-600 font-medium">⚠ Some rows need attention (select a match or add new)</span>
//                   : <span className="text-green-600 font-medium">✓ All rows resolved — ready to import</span>
//                 }
//               </div>
//               <div className="flex gap-3">
//                 <button type="button" onClick={() => setExcelUploadStep('setup')} className="border border-gray-300 text-gray-700 rounded-lg px-5 py-2 text-sm font-medium hover:bg-gray-100 transition">← Back</button>
//                 <button
//                   type="button"
//                   disabled={!allRowsResolved || excelSubmitLoading}
//                   onClick={handleExcelSubmit}
//                   className="bg-gradient-to-r from-[#1CAC70] to-[#059669] text-white rounded-lg px-6 py-2 text-sm font-medium hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   {excelSubmitLoading ? 'Importing...' : `Import ${Object.values(processedRows).flat().length} Rows`}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══════════════════════════════════════════════════════════════════════════
//           ADD STOCK NAME MODAL (Task 2)
//       ══════════════════════════════════════════════════════════════════════════ */}
//       {showAddStockModal && (
//         <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 backdrop-blur-sm">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden">
//             <div className="bg-gradient-to-r from-[#3B82F6] to-[#6366F1] px-6 py-4">
//               <div className="flex justify-between items-center">
//                 <h3 className="text-lg font-bold text-white">Add New Stock Name</h3>
//                 <button onClick={() => { setShowAddStockModal(false); setPendingNewStockName(''); }} className="text-white/70 hover:text-white text-xl">×</button>
//               </div>
//               <p className="text-blue-200 text-xs mt-1">This will add the stock to the {addStockModalCategory === 'mutual' ? 'Mutual Funds' : 'Equity'} database</p>
//             </div>
//             <div className="p-6 flex flex-col gap-4">
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 block mb-1">Stock Name</label>
//                 <input
//                   type="text"
//                   placeholder={addStockModalCategory === 'mutual' ? 'e.g. Axis Bluechip Fund' : 'e.g. INFY'}
//                   value={pendingNewStockName}
//                   onChange={e => setPendingNewStockName(e.target.value)}
//                   className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-blue-400"
//                   autoFocus
//                   onKeyDown={e => e.key === 'Enter' && handleAddStockName()}
//                 />
//               </div>
//               <div className="bg-blue-50 rounded-lg p-3 text-xs text-blue-700">
//                 <strong>Adding to:</strong> {addStockModalCategory === 'mutual' ? 'Mutual Funds database (mutualfunds_stock_name)' : 'Equity/Stock database (stocknames)'}
//               </div>
//               <div className="flex gap-3">
//                 <button type="button" onClick={() => { setShowAddStockModal(false); setPendingNewStockName(''); }} className="flex-1 border border-gray-300 text-gray-700 rounded-lg py-2 font-medium hover:bg-gray-50 transition">Cancel</button>
//                 <button type="button" onClick={handleAddStockName} disabled={addStockLoading || !pendingNewStockName.trim()} className="flex-1 bg-gradient-to-r from-[#3B82F6] to-[#6366F1] text-white rounded-lg py-2 font-medium hover:opacity-90 transition disabled:opacity-50">
//                   {addStockLoading ? 'Adding...' : 'Add Stock'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// // export default Addstock;
// import React, { useCallback, useEffect, useState, useMemo, useRef } from 'react';
// import * as XLSX from 'xlsx';
// import parties from '../data/party';
// import categoriesApi from '../data/categories';
// import stockes from '../data/stockhistory';
// import stockdata from '../data/stock';
// import { fetchStocknames } from '../data/Stocknames';
// import { fetchMutualnames } from '../data/Mutual';
// import Select from "react-select";
// import settingapi from '../data/setting';
// import AsyncSelect from "react-select/async";
// import OcrUploadModal from './OcrUploadModal';
// // ─────────────────────────────────────────────────────────────────────────────
// // TYPES
// // ─────────────────────────────────────────────────────────────────────────────

// interface Party {
//   id: number;
//   date: string;
//   name: string;
//   number: string;
//   contact_person_name: string;
//   contact_person_number: string;
//   categories: string[];
//   deleteparty: number;
//   total_amount?: number | string;
// }

// interface CategoryApiType {
//   id: number | string;
//   category_name: string;
// }

// interface Stock {
//   id: number | string;
//   name: string;
//   category: string;
// }

// interface StockNames {
//   id: number;
//   name: string;
//   screener: string;
//   ltp: string;
//   [key: string]: any;
// }

// interface OcrSubmitInput {
//     partyId: string | number;
//     category: string;
//     date: string;
//     rows: Array<{
//       id: string;
//       stock_name: string;
//       unit: string;
//       total_amount: string;
//       indirect_charges: string;
//       per_unit_charge: string;
//       confidence: 'high' | 'medium' | 'low';
//       raw_text?: string;
//       edited?: boolean;
//       deleted?: boolean;
//     }>;
//   }

// type StockCategoryInfo = {
//   id: number | string;
//   stockId: number | string;
//   stockName: string;
//   unit: string;
//   totalAmount: string;
//   indirectCharges: string;
//   perUnitCharge: string;
//   autoCalculated: boolean;
//   category: string;
//   error?: string;
// };

// type CategoryEntryMap = { [categoryName: string]: StockCategoryInfo[] };

// type PartyStockDBType = {
//   id: number | string;
//   date: string;
//   party_id: number | string;
//   categories: string | (StockDBCategoryItem | DirectCategoryItem)[];
// };

// type StockDBCategoryItem = {
//   id: number | string;
//   investment_type: string;
//   category: string;
//   stock_name: string;
//   unit: string;
//   total_amount: string;
//   indirect_charges: string;
//   perUnitCharge: string;
// };

// type DirectCategoryItem = {
//   investment_type: string;
//   total_amount: string | number;
//   date?: string;
//   [key: string]: any;
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // EXCEL / XML UPLOAD TYPES
// // ─────────────────────────────────────────────────────────────────────────────

// type ExcelRow = {
//   stock_name: string;
//   unit: string | number;
//   total_amount: string | number;
//   indirect_charges?: string | number;
//   [key: string]: any;
// };

// type SheetData = {
//   sheetName: string;
//   fileName: string;
//   fileIndex: number;
//   rows: ExcelRow[];
// };

// type StockMatchStatus = 'matched' | 'fuzzy' | 'unmatched';

// type ProcessedExcelRow = ExcelRow & {
//   _rowId: string;
//   _sheetKey: string;
//   _matchStatus: StockMatchStatus;
//   _matchedName?: string;
//   _candidateMatches?: string[];
//   _userChoice?: string; // after user resolves
//   _addNew?: boolean;
//   _newStockName?: string;
// };

// type ExcelUploadStep = 'idle' | 'setup' | 'review' | 'resolving' | 'confirmed';

// // ─────────────────────────────────────────────────────────────────────────────
// // HELPERS
// // ─────────────────────────────────────────────────────────────────────────────

// const safeNumber = (val: any) => {
//   const num = parseFloat(val);
//   return isNaN(num) ? 0 : num;
// };

// let globalEntryId = 1;

// function emptyStockCategoryInfo(category = '', stockId: number | string = '', stockName = ''): StockCategoryInfo {
//   return {
//     id: globalEntryId++,
//     stockId,
//     stockName,
//     category,
//     unit: '',
//     totalAmount: '',
//     indirectCharges: '',
//     perUnitCharge: '',
//     autoCalculated: true,
//     error: undefined,
//   };
// }

// function fuzzyMatch(name: string, list: string[]): string[] {
//   const lower = name.toLowerCase().replace(/[^a-z0-9]/g, '');
//   return list
//     .filter(n => {
//       const nl = n.toLowerCase().replace(/[^a-z0-9]/g, '');
//       return nl.includes(lower) || lower.includes(nl) || levenshtein(lower, nl) <= 3;
//     })
//     .slice(0, 5);
// }

// function levenshtein(a: string, b: string): number {
//   const m = a.length, n = b.length;
//   const dp: number[][] = Array.from({ length: m + 1 }, (_, i) =>
//     Array.from({ length: n + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0))
//   );
//   for (let i = 1; i <= m; i++)
//     for (let j = 1; j <= n; j++)
//       dp[i][j] = a[i - 1] === b[j - 1] ? dp[i - 1][j - 1] : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
//   return dp[m][n];
// }

// function calculateTotalDeductedIncludingDirect(stockDbRows: PartyStockDBType[], partyId: string | number): number {
//   let total = 0;
//   stockDbRows.forEach(row => {
//     if (String(row.party_id) !== String(partyId)) return;
//     let arr: any[] = [];
//     try { arr = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[]; } catch {}
//     for (const item of arr) {
//       if (item?.investment_type === 'direct') total += safeNumber(item.total_amount);
//       else if (item?.category) { total += safeNumber(item.total_amount) + safeNumber(item.indirect_charges); }
//     }
//   });
//   return total;
// }

// function calculateTotalDeductedFromStockTable(stockDbRows: PartyStockDBType[], partyId: string | number): number {
//   let total = 0;
//   stockDbRows.forEach(row => {
//     if (String(row.party_id) !== String(partyId)) return;
//     let arr: any[] = [];
//     try { arr = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[]; } catch {}
//     for (const item of arr) {
//       if (item?.category) total += safeNumber(item.total_amount) + safeNumber(item.indirect_charges);
//     }
//   });
//   return total;
// }

// async function fetchStocksAPI(): Promise<Stock[]> {
//   return [
//     { id: 1, name: 'SBI', category: 'Equity' },
//     { id: 2, name: 'HDFC', category: 'Equity' },
//     { id: 3, name: 'RELIANCE', category: 'Equity' },
//     { id: 4, name: 'NIFTY-FUT', category: 'FNO' },
//     { id: 5, name: 'BANKNIFTY-OPT', category: 'FNO' },
//     { id: 6, name: 'ICICI MF', category: 'Mutual Funds' },
//     { id: 7, name: 'SBI MF', category: 'Mutual Funds' },
//     { id: 8, name: 'NIFTY ETF', category: 'ETF' },
//     { id: 9, name: 'GOLD ETF', category: 'ETF' },
//   ];
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // XML PARSING
// // ─────────────────────────────────────────────────────────────────────────────

// // Aliases tried (case-insensitive, punctuation-stripped) for each logical field,
// // as either a child element's tag name OR an attribute on the row element.
// const XML_FIELD_ALIASES: { [key: string]: string[] } = {
//   stock_name: ['stock_name', 'stockname', 'name', 'stock', 'security', 'scrip', 'symbol'],
//   unit: ['unit', 'units', 'qty', 'quantity'],
//   total_amount: ['total_amount', 'totalamount', 'amount', 'price', 'value', 'totalvalue'],
//   indirect_charges: ['indirect_charges', 'indirectcharges', 'charges', 'charge', 'brokerage'],
// };

// function normalizeTag(tag: string): string {
//   return tag.toLowerCase().replace(/[^a-z0-9]/g, '');
// }

// function getXmlField(el: Element, aliases: string[]): string {
//   // 1. try attributes on the row element itself
//   for (const a of aliases) {
//     for (const attr of Array.from(el.attributes)) {
//       if (normalizeTag(attr.name) === normalizeTag(a)) return attr.value.trim();
//     }
//   }
//   // 2. try direct child elements
//   for (const child of Array.from(el.children)) {
//     const tag = normalizeTag(child.tagName);
//     if (aliases.some(a => normalizeTag(a) === tag)) {
//       return (child.textContent || '').trim();
//     }
//   }
//   return '';
// }

// // Finds the "row" elements in an arbitrary XML document. Tries common row tag
// // names first; if none found, falls back to whichever tag repeats most often
// // under the document root (a reasonable heuristic for unknown schemas).
// function findXmlRowElements(doc: Document): Element[] {
//   const rowTagCandidates = ['row', 'stock', 'item', 'entry', 'record', 'transaction', 'holding'];
//   for (const tag of rowTagCandidates) {
//     const found = Array.from(doc.getElementsByTagName(tag));
//     if (found.length) return found;
//   }
//   const root = doc.documentElement;
//   if (!root) return [];
//   const counts: { [tag: string]: Element[] } = {};
//   const walk = (el: Element) => {
//     for (const child of Array.from(el.children)) {
//       (counts[child.tagName] = counts[child.tagName] || []).push(child);
//       walk(child);
//     }
//   };
//   walk(root);
//   let best: Element[] = [];
//   for (const arr of Object.values(counts)) {
//     if (arr.length > best.length) best = arr;
//   }
//   return best.length > 1 ? best : [];
// }

// function parseXmlRows(xmlText: string): ExcelRow[] {
//   const parser = new DOMParser();
//   const doc = parser.parseFromString(xmlText, 'application/xml');
//   if (doc.querySelector('parsererror')) return [];

//   const rowElements = findXmlRowElements(doc);

//   return rowElements
//     .map(el => ({
//       stock_name: getXmlField(el, XML_FIELD_ALIASES.stock_name),
//       unit: getXmlField(el, XML_FIELD_ALIASES.unit),
//       total_amount: getXmlField(el, XML_FIELD_ALIASES.total_amount),
//       indirect_charges: getXmlField(el, XML_FIELD_ALIASES.indirect_charges) || '0',
//     } as ExcelRow))
//     .filter(r => r.stock_name);
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // COMPONENT
// // ─────────────────────────────────────────────────────────────────────────────

// interface Props {}
// interface OcrExtractedRow {
//     id: string;
//     stock_name: string;
//     unit: string;
//     total_amount: string;
//     indirect_charges: string;
//     per_unit_charge: string;
//     confidence: 'high' | 'medium' | 'low';
//     raw_text?: string;
//     edited?: boolean;
//     deleted?: boolean;
//     // NEW: per-row date from invoice
//     row_date?: string;
//   }
  
//   interface OcrInvoice {
//     invoice_no?: string;
//     date?: string;
//     rows: OcrExtractedRow[];
//   }
  
//   interface OcrResult {
//     party_name?: string;
//     category?: string;
//     doc_type?: string;
//     confidence_overall?: number;
//     // NEW: multiple invoices instead of a single date + rows
//     invoices: OcrInvoice[];
//     // fallback for single-invoice docs
//     date?: string;
//     rows?: OcrExtractedRow[];
//   }
  
//   interface OcrFile {
//     file: File;
//     id: string;
//     preview?: string;
//     status: 'pending' | 'processing' | 'done' | 'error';
//     result?: OcrResult;
//     error?: string;
//   }
  

// function Addstock(props: Props) {
//   // ── Core state ──────────────────────────────────────────────────────────────
//   const [data, setData] = useState({ partyId: '', date: '' });
//   const [investmentType, setInvestmentType] = useState<'direct' | 'structure'>('structure');
//   const [directPaymentAmount, setDirectPaymentAmount] = useState('');
//   const [categoryEntries, setCategoryEntries] = useState<CategoryEntryMap>({});
//   const [partiesList, setPartiesList] = useState<Party[]>([]);
//   const [allStocks, setAllStocks] = useState<Stock[]>([]);
//   const [categoriesFromApi, setCategoriesFromApi] = useState<CategoryApiType[]>([]);
//   const [stocksDb, setStocksDb] = useState<PartyStockDBType[]>([]);
//   const [stocksDataDb, setStocksDataDb] = useState<PartyStockDBType[]>([]);
//   const [urlParty, setUrlParty] = useState('');
//   const [stocksnames, setStocksnames] = useState<StockNames[]>([]);
//   const [mutualsnames, setMutualsnames] = useState<StockNames[]>([]);
//   const [selectedPartyTotalAmount, setSelectedPartyTotalAmount] = useState<number | null>(null);
//   const [deductedAvailable, setDeductedAvailable] = useState<number | null>(null);
//   const [totalamountspend, setTotalAmmountSpend] = useState<number>();
//   const [farmName, setFarmName] = useState<string>();
//   const exceedPromptedRef = useRef(false);

//   // ── Add-stock-name modal (Task 2) ────────────────────────────────────────────
//   const [showAddStockModal, setShowAddStockModal] = useState(false);
//   const [addStockModalCategory, setAddStockModalCategory] = useState<'stocks' | 'mutual'>('stocks');
//   const [pendingNewStockName, setPendingNewStockName] = useState('');
//   const [addStockLoading, setAddStockLoading] = useState(false);
//   // Which entry triggered the add-stock modal (for injecting back)
//   const addStockCallbackRef = useRef<((name: string) => void) | null>(null);

//   // ── Excel / XML upload state ─────────────────────────────────────────────────
//   // NOTE: this single pipeline now accepts .xlsx, .xls, AND .xml files. The
//   // setup step (party/category/date) and review/resolve/submit steps are
//   // shared across both formats — only file parsing branches by extension.
//   const [excelUploadStep, setExcelUploadStep] = useState<ExcelUploadStep>('idle');
//   const [excelSetupPartyId, setExcelSetupPartyId] = useState('');
//   const [excelSetupCategory, setExcelSetupCategory] = useState('');
//   const [excelSetupDate, setExcelSetupDate] = useState('');
//   const [excelFiles, setExcelFiles] = useState<File[]>([]);
//   const [parsedSheets, setParsedSheets] = useState<SheetData[]>([]);
//   const [processedRows, setProcessedRows] = useState<{ [sheetKey: string]: ProcessedExcelRow[] }>({});
//   const [currentResolvingSheet, setCurrentResolvingSheet] = useState<string | null>(null);
//   const [currentResolvingRowId, setCurrentResolvingRowId] = useState<string | null>(null);
//   const [excelSubmitLoading, setExcelSubmitLoading] = useState(false);
//   const excelFileInputRef = useRef<HTMLInputElement>(null);

//   const [showOcrModal, setShowOcrModal] = useState(false);

//   // ─────────────────────────────────────────────────────────────────────────────
//   // DATA FETCHING
//   // ─────────────────────────────────────────────────────────────────────────────

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const partyId = urlParams.get('party') || '';
//     setUrlParty(partyId);
//     if (partyId) setData(prev => ({ ...prev, partyId }));
//   }, []);

//   const fetchParties = useCallback(async () => {
//     const res = await parties();
//     const cleaned = Array.isArray(res)
//       ? res.map((item: any) => ({
//           ...item,
//           categories: typeof item.categories === 'string'
//             ? (() => { try { const p = JSON.parse(item.categories); return Array.isArray(p) ? p : [item.categories]; } catch { return [item.categories]; } })()
//             : Array.isArray(item.categories) ? item.categories : [],
//           total_amount: item.total_amount !== undefined ? Number(item.total_amount) : undefined,
//         }))
//       : [];
//     setPartiesList(cleaned);
//   }, []);

//   useEffect(() => {
//     async function fetchSettingsApi() {
//       try {
//         const res = await settingapi();
//         if (Array.isArray(res)) {
//           const s = res.find((i: any) => i.meta_key === 'farm');
//           if (s?.meta_value) {
//             const obj = typeof s.meta_value === 'string' ? JSON.parse(s.meta_value) : s.meta_value;
//             if (typeof obj?.name === 'string') setFarmName(obj.name);
//           }
//         }
//       } catch {}
//     }
//     fetchSettingsApi();
//     fetchParties();
//     categoriesApi().then(r => Array.isArray(r) && setCategoriesFromApi(r));
//     fetchStocksAPI().then(s => setAllStocks(s));
//     stockes().then(r => setStocksDb(Array.isArray(r) ? r : [])).catch(() => setStocksDb([]));
//     stockdata().then(r => setStocksDataDb(Array.isArray(r) ? r : [])).catch(() => setStocksDataDb([]));
//     fetchStocknames().then(r => setStocksnames(Array.isArray(r) ? r : [])).catch(() => setStocksnames([]));
//     fetchMutualnames().then(r => setMutualsnames(Array.isArray(r) ? r : [])).catch(() => setMutualsnames([]));
//   }, [fetchParties]);

//   // ─────────────────────────────────────────────────────────────────────────────
//   // DERIVED
//   // ─────────────────────────────────────────────────────────────────────────────

//   const possibleCategories = useMemo(() => {
//     const activePartyId = data.partyId || urlParty;
//     if (!activePartyId || !partiesList.length) return [];
//     const party = partiesList.find(p => String(p.id) === String(activePartyId));
//     if (party?.categories?.length) return party.categories.map((n: string) => ({ category_name: n, id: n }));
//     return [];
//   }, [partiesList, data.partyId, urlParty]);

//   const excelSetupPossibleCategories = useMemo(() => {
//     if (!excelSetupPartyId || !partiesList.length) return [];
//     const party = partiesList.find(p => String(p.id) === String(excelSetupPartyId));
//     if (party?.categories?.length) return party.categories;
//     return [];
//   }, [partiesList, excelSetupPartyId]);

//   useEffect(() => {
//     if (data.partyId && partiesList.length) {
//       const party = partiesList.find(p => String(p.id) === String(data.partyId));
//       setSelectedPartyTotalAmount(party?.total_amount != null ? Number(party.total_amount) : null);
//     } else setSelectedPartyTotalAmount(null);
//   }, [data.partyId, partiesList]);

//   useEffect(() => {
//     if (!selectedPartyTotalAmount) { setDeductedAvailable(null); return; }
//     if (!data.partyId || !stocksDataDb.length) { setDeductedAvailable(selectedPartyTotalAmount); return; }
//     const dbDeducted = calculateTotalDeductedIncludingDirect(stocksDataDb, data.partyId);
//     let uiDeducted = 0;
//     Object.values(categoryEntries).flat().forEach(e => {
//       uiDeducted += safeNumber(e.totalAmount) + safeNumber(e.indirectCharges);
//     });
//     const result = selectedPartyTotalAmount - dbDeducted - uiDeducted;
//     setDeductedAvailable(result);
//     if (result < 0 && !exceedPromptedRef.current) {
//       setTimeout(() => {
//         const ok = window.confirm('You exceed your amount. Do you want to add it from margin money?');
//         exceedPromptedRef.current = true;
//         if (!ok) setDeductedAvailable(null);
//       }, 100);
//     }
//   }, [selectedPartyTotalAmount, investmentType, directPaymentAmount, categoryEntries, data.partyId, stocksDataDb]);

//   // ─────────────────────────────────────────────────────────────────────────────
//   // CATEGORY / ENTRY HANDLERS
//   // ─────────────────────────────────────────────────────────────────────────────

//   const isChecked = (cat: CategoryApiType) => Object.prototype.hasOwnProperty.call(categoryEntries, cat.category_name);

//   const handleCategory = (cat: CategoryApiType) => {
//     setCategoryEntries(prev => {
//       const copy = { ...prev };
//       if (copy[cat.category_name]) delete copy[cat.category_name];
//       else copy[cat.category_name] = [emptyStockCategoryInfo(cat.category_name)];
//       return copy;
//     });
//   };

//   const handleCategoryFieldChange = (cat: CategoryApiType, entryIdx: number, field: keyof StockCategoryInfo, value: string) => {
//     const category = cat.category_name;
//     setCategoryEntries(prev => {
//       const entries = [...(prev[category] || [])];
//       const entry = { ...(entries[entryIdx] || emptyStockCategoryInfo(category)) };
//       if (field === 'stockName') {
//         entry.stockName = value;
//         const s = allStocks.find(s => s.category === category && s.name.toLowerCase() === value.toLowerCase());
//         entry.stockId = s ? s.id : value;
//       } else if (field === 'stockId') {
//         entry.stockId = value;
//         const s = allStocks.find(s => s.category === category && String(s.id) === value);
//         entry.stockName = s ? s.name : value;
//       } else if (field === 'unit' || field === 'totalAmount' || field === 'indirectCharges') {
//         (entry as any)[field] = value;
//         const u = safeNumber(field === 'unit' ? value : entry.unit);
//         const t = safeNumber(field === 'totalAmount' ? value : entry.totalAmount);
//         const i = safeNumber(field === 'indirectCharges' ? value : entry.indirectCharges);
//         entry.perUnitCharge = u > 0 ? ((t + i) / u).toFixed(2) : '';
//         entry.autoCalculated = true;
//       } else if (field === 'perUnitCharge') {
//         entry.perUnitCharge = value;
//         entry.autoCalculated = false;
//       } else {
//         (entry as any)[field] = value;
//       }
//       entries[entryIdx] = entry;
//       return { ...prev, [category]: entries };
//     });
//   };

//   const handleAddEntry = (cat: CategoryApiType) => {
//     setCategoryEntries(prev => ({
//       ...prev,
//       [cat.category_name]: [...(prev[cat.category_name] || []), emptyStockCategoryInfo(cat.category_name)],
//     }));
//   };

//   const handleRemoveEntry = (cat: CategoryApiType, idx: number) => {
//     setCategoryEntries(prev => {
//       const entries = [...(prev[cat.category_name] || [])];
//       entries.splice(idx, 1);
//       const copy = { ...prev };
//       if (entries.length > 0) copy[cat.category_name] = entries;
//       else delete copy[cat.category_name];
//       return copy;
//     });
//   };

//   const handleInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
//     const { name, value } = e.target;
//     setData(prev => ({ ...prev, [name]: value }));
//     if (name === 'partyId') {
//       setInvestmentType('structure');
//       setCategoryEntries({});
//       setDirectPaymentAmount('');
//     }
//   };

//   // ─────────────────────────────────────────────────────────────────────────────
//   // TASK 2: ADD STOCK NAME INLINE
//   // ─────────────────────────────────────────────────────────────────────────────

//   const isMutualCategory = (catName: string) =>
//     catName.toLowerCase().includes('mutual');

//   const handleAddStockName = async () => {
//     if (!pendingNewStockName.trim()) { alert('Enter a stock name'); return; }
//     setAddStockLoading(true);
//     try {
//       const endpoint = addStockModalCategory === 'mutual'
//         ? `${process.env.REACT_APP_API_URL}/auth/mutualstocks`
//         : `${process.env.REACT_APP_API_URL}/auth/stocks`;
//       const res = await fetch(endpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ name: pendingNewStockName.trim() }),
//       });
//       if (!res.ok) throw new Error('Failed to add stock');
//       // Refresh stock lists
//       if (addStockModalCategory === 'mutual') {
//         fetchMutualnames().then(r => setMutualsnames(Array.isArray(r) ? r : []));
//       } else {
//         fetchStocknames().then(r => setStocksnames(Array.isArray(r) ? r : []));
//       }
//       // Inject name back into the entry that triggered this
//       if (addStockCallbackRef.current) addStockCallbackRef.current(pendingNewStockName.trim());
//       setShowAddStockModal(false);
//       setPendingNewStockName('');
//     } catch (err: any) {
//       alert('Error: ' + err.message);
//     } finally {
//       setAddStockLoading(false);
//     }
//   };

//   // ─────────────────────────────────────────────────────────────────────────────
//   // EXCEL / XML UPLOAD: PARSE
//   // ─────────────────────────────────────────────────────────────────────────────

//   const handleExcelFilesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = Array.from(e.target.files || []);
//     setExcelFiles(prev => [...prev, ...files]);
//   };

//   const removeExcelFile = (idx: number) => {
//     setExcelFiles(prev => prev.filter((_, i) => i !== idx));
//   };

//   // Parses every uploaded file into the shared SheetData[] shape, branching by
//   // extension: .xml goes through parseXmlRows (DOMParser-based), everything
//   // else is treated as a spreadsheet via the xlsx library. Both paths funnel
//   // into the same downstream review/match/submit pipeline.
//   const parseImportFiles = async (): Promise<SheetData[]> => {
//     const allSheets: SheetData[] = [];
//     for (let fi = 0; fi < excelFiles.length; fi++) {
//       const file = excelFiles[fi];
//       const isXml = file.name.toLowerCase().endsWith('.xml');

//       if (isXml) {
//         try {
//           const text = await file.text();
//           const rows = parseXmlRows(text);
//           if (rows.length) {
//             allSheets.push({ sheetName: 'XML Data', fileName: file.name, fileIndex: fi, rows });
//           }
//         } catch {
//           // swallow — surfaced to user via "no valid rows found" check below
//         }
//         continue;
//       }

//       const buffer = await file.arrayBuffer();
//       const wb = XLSX.read(buffer, { type: 'array' });
//       for (const sheetName of wb.SheetNames) {
//         const ws = wb.Sheets[sheetName];
//         const raw: any[] = XLSX.utils.sheet_to_json(ws, { defval: '' });
//         // Normalize column names (lowercase, trim)
//         const rows: ExcelRow[] = raw.map(r => {
//           const norm: any = {};
//           for (const k of Object.keys(r)) {
//             norm[k.toLowerCase().trim().replace(/\s+/g, '_')] = r[k];
//           }
//           return {
//             stock_name: String(norm.stock_name || norm.stockname || norm.name || norm['stock name'] || '').trim(),
//             unit: norm.unit || norm.units || norm.qty || norm.quantity || '',
//             total_amount: norm.total_amount || norm.totalamount || norm.amount || norm.price || '',
//             indirect_charges: norm.indirect_charges || norm.indirectcharges || norm.charges || '0',
//           } as ExcelRow;
//         }).filter(r => r.stock_name);
//         if (rows.length) {
//           allSheets.push({ sheetName, fileName: file.name, fileIndex: fi, rows });
//         }
//       }
//     }
//     return allSheets;
//   };

//   const processSheets = (sheets: SheetData[], stockNameList: string[]) => {
//     const result: { [sheetKey: string]: ProcessedExcelRow[] } = {};
//     for (const sheet of sheets) {
//       const key = `${sheet.fileIndex}__${sheet.fileName}__${sheet.sheetName}`;
//       result[key] = sheet.rows.map((row, ri) => {
//         const name = row.stock_name;
//         const exact = stockNameList.find(n => n.toLowerCase() === name.toLowerCase());
//         let matchStatus: StockMatchStatus;
//         let matchedName: string | undefined;
//         let candidates: string[] = [];
//         if (exact) {
//           matchStatus = 'matched';
//           matchedName = exact;
//         } else {
//           candidates = fuzzyMatch(name, stockNameList);
//           matchStatus = candidates.length ? 'fuzzy' : 'unmatched';
//         }
//         return {
//           ...row,
//           _rowId: `${key}__${ri}`,
//           _sheetKey: key,
//           _matchStatus: matchStatus,
//           _matchedName: matchedName,
//           _candidateMatches: candidates,
//           _userChoice: matchedName,
//           _addNew: false,
//           _newStockName: '',
//         } as ProcessedExcelRow;
//       });
//     }
//     return result;
//   };

//   const handleExcelProceed = async () => {
//     if (!excelSetupPartyId) { alert('Select a party'); return; }
//     if (!excelSetupCategory) { alert('Select a category'); return; }
//     if (!excelSetupDate) { alert('Select a date'); return; }
//     if (!excelFiles.length) { alert('Upload at least one Excel or XML file'); return; }

//     const sheets = await parseImportFiles();
//     if (!sheets.length) { alert('No valid rows found. For Excel, check column names: stock_name, unit, total_amount. For XML, check that repeated row elements contain a stock name field.'); return; }

//     const isMutual = isMutualCategory(excelSetupCategory);
//     const nameList = (isMutual ? mutualsnames : stocksnames).map(s => s.name);
//     const processed = processSheets(sheets, nameList);

//     setParsedSheets(sheets);
//     setProcessedRows(processed);
//     setExcelUploadStep('review');
//   };

//   // Rows that need resolution (fuzzy or unmatched)
//   const unresolvedRows = useMemo(() => {
//     const rows: ProcessedExcelRow[] = [];
//     for (const sheetRows of Object.values(processedRows)) {
//       for (const row of sheetRows) {
//         if (row._matchStatus !== 'matched' && !row._userChoice && !row._addNew) rows.push(row);
//       }
//     }
//     return rows;
//   }, [processedRows]);

//   const updateProcessedRow = (sheetKey: string, rowId: string, patch: Partial<ProcessedExcelRow>) => {
//     setProcessedRows(prev => ({
//       ...prev,
//       [sheetKey]: prev[sheetKey].map(r => r._rowId === rowId ? { ...r, ...patch } : r),
//     }));
//   };

//   // ─────────────────────────────────────────────────────────────────────────────
//   // EXCEL / XML SUBMIT
//   // ─────────────────────────────────────────────────────────────────────────────

//   const handleExcelSubmit = async () => {
//     setExcelSubmitLoading(true);
//     try {
//       const isMutual = isMutualCategory(excelSetupCategory);

//       // 1. Add new stock names first
//       const rowsToAddAsNewStock: ProcessedExcelRow[] = [];
//       for (const sheetRows of Object.values(processedRows)) {
//         for (const row of sheetRows) {
//           if (row._addNew && row._newStockName?.trim()) rowsToAddAsNewStock.push(row);
//         }
//       }
//       const addedNames: Set<string> = new Set();
//       for (const row of rowsToAddAsNewStock) {
//         const nm = row._newStockName!.trim();
//         if (addedNames.has(nm)) continue;
//         addedNames.add(nm);
//         const ep = isMutual
//           ? `${process.env.REACT_APP_API_URL}/auth/mutualstocks`
//           : `${process.env.REACT_APP_API_URL}/auth/stocks`;
//         await fetch(ep, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ name: nm }),
//         });
//       }

//       // 2. Group rows by sheet and submit each sheet's rows as separate entries
//       for (const [sheetKey, sheetRows] of Object.entries(processedRows)) {
//         const validRows = sheetRows.filter(r => {
//           const finalName = r._addNew ? r._newStockName : (r._userChoice || r._matchedName || r.stock_name);
//           return finalName?.trim();
//         });
//         if (!validRows.length) continue;

//         // Build categories array for this sheet
//         const cats = validRows.map((row, i) => {
//           const finalName = (row._addNew ? row._newStockName : (row._userChoice || row._matchedName || row.stock_name)) || '';
//           const unit = String(row.unit || '0');
//           const total = String(row.total_amount || '0');
//           const indirect = String(row.indirect_charges || '0');
//           const u = safeNumber(unit), t = safeNumber(total), ind = safeNumber(indirect);
//           return {
//             id: globalEntryId++,
//             stock_name: finalName,
//             unit,
//             total_amount: total,
//             indirect_charges: indirect,
//             perUnitCharge: u > 0 ? ((t + ind) / u).toFixed(2) : '0',
//             category: excelSetupCategory,
//             investment_type: 'structure',
//             total_amount_category: total,
//           };
//         });

//         // Check for existing stocks -> PUT, new -> POST
//         const rowUpdates = new Map<any, any>();
//         const newCats: any[] = [];
//         let grandTotal = 0;

//         for (const cat of cats) {
//           grandTotal += safeNumber(cat.total_amount) + safeNumber(cat.indirect_charges);
//           const existingRow = stocksDataDb.find(row => {
//             if (String(row.party_id) !== String(excelSetupPartyId)) return false;
//             const items: any[] = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[];
//             return items.some(i => i.stock_name === cat.stock_name && i.category === excelSetupCategory);
//           });
//           if (existingRow) {
//             const arr: any[] = typeof existingRow.categories === 'string' ? JSON.parse(existingRow.categories) : [...existingRow.categories as any[]];
//             const target = arr.find(i => i.stock_name === cat.stock_name && i.category === excelSetupCategory);
//             if (target) {
//               const tu = safeNumber(target.unit) + safeNumber(cat.unit);
//               const ta = safeNumber(target.total_amount) + safeNumber(cat.total_amount);
//               const ti = safeNumber(target.indirect_charges) + safeNumber(cat.indirect_charges);
//               target.unit = tu.toString(); target.total_amount = ta.toString(); target.indirect_charges = ti.toString();
//               target.perUnitCharge = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0';
//               rowUpdates.set(existingRow.id, { arr, lastName: cat.stock_name, lastCat: excelSetupCategory, lastUnit: tu.toString(), lastTotal: ta.toString(), lastIndirect: ti.toString(), lastPrice: target.perUnitCharge });
//             }
//           } else {
//             newCats.push(cat);
//           }
//         }

//         // PUT existing
//         for (const [rowId, obj] of rowUpdates.entries()) {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//             method: 'PUT',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               id: rowId, party_id: excelSetupPartyId,
//               categories: JSON.stringify(obj.arr),
//               name: obj.lastName, category: obj.lastCat,
//               unit: obj.lastUnit, price_per_unit: obj.lastPrice,
//               total_amount: obj.lastTotal, indirect_charges: obj.lastIndirect,
//               date: excelSetupDate,
//             }),
//           });
//         }

//         // POST new
//         if (newCats.length) {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ party_id: excelSetupPartyId, date: excelSetupDate, investment_type: 'structure', categories: newCats }),
//           });
//         }

//         // buysellrecord + usermeta
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ date: excelSetupDate, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }),
//         }).catch(() => {});

//         const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${excelSetupPartyId}`);
//         const umList = await umRes.json();
//         const found = Array.isArray(umList) ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(excelSetupPartyId)) : null;
//         if (found) {
//           const newVal = (safeNumber(found.meta_value) - grandTotal).toString();
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, {
//             method: 'PUT', headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ meta_key: 'remaining', meta_value: newVal, party_id: excelSetupPartyId }),
//           });
//         }
//       }

//       alert('Data submitted successfully!');
//       setExcelUploadStep('idle');
//       setParsedSheets([]);
//       setProcessedRows({});
//       setExcelFiles([]);
//       setExcelSetupPartyId('');
//       setExcelSetupCategory('');
//       setExcelSetupDate('');
//       window.location.reload();
//     } catch (err: any) {
//       alert('Error: ' + err.message);
//     } finally {
//       setExcelSubmitLoading(false);
//     }
//   };

//   // ─────────────────────────────────────────────────────────────────────────────
//   // MAIN SUBMIT
//   // ─────────────────────────────────────────────────────────────────────────────

//   const getNextCategoryId = () => {
//     const ids: number[] = [];
//     stocksDataDb.forEach(row => {
//       const items = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories;
//       (items as any[]).forEach(i => i.id && ids.push(Number(i.id)));
//     });
//     return (ids.length ? Math.max(...ids) : 0) + 1;
//   };

//   const handleSubmit = async (e?: React.FormEvent) => {
//     if (e) e.preventDefault();
//     if (!data.partyId) { alert('Please select a party'); return; }
//     const party = partiesList.find(p => String(p.id) === String(data.partyId));
//     const availableTotalAmount = party?.total_amount != null ? Number(party.total_amount) : null;
//     if (availableTotalAmount == null) { alert('Could not determine total amount available.'); return; }
//     const currentInvestmentType = investmentType;
//     const selectedCategories = Object.keys(categoryEntries);
//     if (selectedCategories.length === 0) { alert('Please select at least one category'); return; }

//     const rowUpdates = new Map<any, any>();
//     let categoriesToPost: any[] = [];
//     let grandTotal = 0;
//     let datainvoiceAll: any[] = [];

//     for (const categoryName of selectedCategories) {
//       const entries = categoryEntries[categoryName];
//       for (const catInfo of entries) {
//         if (!catInfo.stockName?.trim()) continue;
//         const amt = safeNumber(catInfo.totalAmount), ind = safeNumber(catInfo.indirectCharges);
//         grandTotal += amt + ind;
//         datainvoiceAll.push({ id: catInfo.id, stock_name: catInfo.stockName, unit: catInfo.unit, total_amount: catInfo.totalAmount, indirect_charges: catInfo.indirectCharges ?? '0', perUnitCharge: catInfo.perUnitCharge, category: categoryName, investment_type: currentInvestmentType, total_amount_category: catInfo.totalAmount });
//         const existingRow = stocksDataDb.find(row => {
//           if (String(row.party_id) !== String(data.partyId)) return false;
//           const items: any[] = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[];
//           return items.some(i => i.stock_name === catInfo.stockName && i.category === categoryName);
//         });
//         if (existingRow) {
//           const arr: any[] = rowUpdates.has(existingRow.id) ? rowUpdates.get(existingRow.id).updatedCategories : (typeof existingRow.categories === 'string' ? JSON.parse(existingRow.categories) : [...existingRow.categories as any[]]);
//           const target = arr.find((i: any) => i.stock_name === catInfo.stockName && i.category === categoryName);
//           if (target) {
//             const tu = safeNumber(target.unit) + safeNumber(catInfo.unit);
//             const ta = safeNumber(target.total_amount) + amt;
//             const ti = safeNumber(target.indirect_charges) + ind;
//             const avgP = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0.00';
//             target.unit = tu.toString(); target.total_amount = ta.toString(); target.indirect_charges = ti.toString(); target.perUnitCharge = avgP; target.total_amount_category = ta.toString(); target.investment_type = currentInvestmentType;
//             rowUpdates.set(existingRow.id, { updatedCategories: arr, lastCatId: catInfo.id, lastName: catInfo.stockName, lastCategory: categoryName, lastUnit: tu.toString(), lastPrice: avgP, lastTotal: ta.toString(), lastIndirect: ti.toString() });
//           }
//         } else {
//           categoriesToPost.push({ id: catInfo.id, stock_name: catInfo.stockName, unit: catInfo.unit, total_amount: catInfo.totalAmount, indirect_charges: catInfo.indirectCharges ?? '0', perUnitCharge: catInfo.perUnitCharge, category: categoryName, investment_type: currentInvestmentType, total_amount_category: catInfo.totalAmount });
//         }
//       }
//     }

//     if (typeof setTotalAmmountSpend === 'function') setTotalAmmountSpend(grandTotal);

//     try {
//       await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ date: data.date, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }) });
//     } catch {}
//     try {
//       await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ farm: farmName, party: data.partyId, invoice_type: 'purchase', date: data.date, datainvoice: datainvoiceAll }) });
//     } catch {}

//     const handleUserMetaUpdate = async (amount: number) => {
//       try {
//         const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${data.partyId}`);
//         const umList = await umRes.json();
//         const found = Array.isArray(umList) ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(data.partyId)) : null;
//         if (found) {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ meta_key: 'remaining', meta_value: (safeNumber(found.meta_value) - amount).toString(), party_id: data.partyId }) });
//         } else {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ meta_key: 'remaining', meta_value: ((availableTotalAmount || 0) - amount).toString(), party_id: data.partyId }) });
//         }
//       } catch {}
//     };

//     if (investmentType === 'direct') {
//       const payment = safeNumber(directPaymentAmount);
//       if (payment <= 0) { alert('Please enter valid payment amount'); return; }
//       try {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ party_id: data.partyId, date: data.date, investment_type: 'direct', categories: [{ id: getNextCategoryId(), stock_name: 'DirectPayment', unit: '0', total_amount: payment.toString(), category: 'Equity', indirect_charges: '0', perUnitCharge: '0', investment_type: 'direct', total_amount_category: payment.toString() }] }) });
//         await handleUserMetaUpdate(payment);
//         alert('Direct payment submitted'); window.location.reload(); return;
//       } catch (err) { alert('Error in direct payment'); return; }
//     }

//     try {
//       for (const [rowId, obj] of rowUpdates.entries()) {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: rowId, party_id: data.partyId, categories: JSON.stringify(obj.updatedCategories), name: obj.lastName, category: obj.lastCategory, unit: obj.lastUnit, price_per_unit: obj.lastPrice, total_amount: obj.lastTotal, indirect_charges: obj.lastIndirect, investment_type: currentInvestmentType, date: data.date || new Date().toISOString().split('T')[0] }) });
//       }
//       if (categoriesToPost.length) {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ party_id: data.partyId, date: data.date, investment_type: currentInvestmentType, categories: categoriesToPost }) });
//       }
//       await handleUserMetaUpdate(grandTotal);
//       alert('Submission successful'); window.location.reload();
//     } catch { alert('An error occurred during submission.'); }
//   };

//   // ─────────────────────────────────────────────────────────────────────────────
//   // RENDER HELPERS
//   // ─────────────────────────────────────────────────────────────────────────────

//   const renderMatchBadge = (status: StockMatchStatus) => {
//     if (status === 'matched') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">✓ Matched</span>;
//     if (status === 'fuzzy') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">⚠ Fuzzy</span>;
//     return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">✗ Not Found</span>;
//   };

//   const allRowsResolved = useMemo(() => {
//     for (const sheetRows of Object.values(processedRows)) {
//       for (const row of sheetRows) {
//         if (row._matchStatus !== 'matched' && !row._userChoice && !row._addNew) return false;
//       }
//     }
//     return true;
//   }, [processedRows]);

//   // ─────────────────────────────────────────────────────────────────────────────
//   // RENDER
//   // ─────────────────────────────────────────────────────────────────────────────


//   const handleOcrSubmit = async ({ partyId, category, batches }: {
//     partyId: string;
//     category: string;
//     batches: { date: string; rows: OcrExtractedRow[] }[];
//   }): Promise<void> => {
//     if (!partyId) { alert('Please select a party'); return; }
//     if (!category) { alert('Please select a category'); return; }
  
//     const party = partiesList.find(p => String(p.id) === String(partyId));
//     const availableTotalAmount = party?.total_amount != null ? Number(party.total_amount) : null;
//     if (availableTotalAmount == null) { alert('Could not determine total amount available.'); return; }
  
//     for (const batch of batches) {
//       if (!batch.date) continue;
//       const validRows = batch.rows.filter(r => r.stock_name?.trim());
//       if (!validRows.length) continue;
  
//       const rowUpdates = new Map<any, any>();
//       const categoriesToPost: any[] = [];
//       let grandTotal = 0;
//       const datainvoiceAll: any[] = [];
  
//       for (const row of validRows) {
//         const amt = safeNumber(row.total_amount);
//         const ind = safeNumber(row.indirect_charges);
//         grandTotal += amt + ind;
  
//         datainvoiceAll.push({
//           id: row.id,
//           stock_name: row.stock_name,
//           unit: row.unit,
//           total_amount: row.total_amount,
//           indirect_charges: row.indirect_charges ?? '0',
//           perUnitCharge: row.per_unit_charge,
//           category,
//           investment_type: 'structure',
//           total_amount_category: row.total_amount,
//         });
  
//         // Check if stock already exists in DB for this party+category
//         const existingRow = stocksDataDb.find(dbRow => {
//           if (String(dbRow.party_id) !== String(partyId)) return false;
//           const items: any[] = typeof dbRow.categories === 'string'
//             ? JSON.parse(dbRow.categories)
//             : dbRow.categories as any[];
//           return items.some(i => i.stock_name === row.stock_name && i.category === category);
//         });
  
//         if (existingRow) {
//           // PUT — merge into existing
//           const arr: any[] = rowUpdates.has(existingRow.id)
//             ? rowUpdates.get(existingRow.id).updatedCategories
//             : (typeof existingRow.categories === 'string'
//               ? JSON.parse(existingRow.categories)
//               : [...existingRow.categories as any[]]);
  
//           const target = arr.find((i: any) => i.stock_name === row.stock_name && i.category === category);
//           if (target) {
//             const tu = safeNumber(target.unit) + safeNumber(row.unit);
//             const ta = safeNumber(target.total_amount) + amt;
//             const ti = safeNumber(target.indirect_charges) + ind;
//             const avgP = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0.00';
//             target.unit = tu.toString();
//             target.total_amount = ta.toString();
//             target.indirect_charges = ti.toString();
//             target.perUnitCharge = avgP;
//             target.total_amount_category = ta.toString();
//             target.investment_type = 'structure';
//             rowUpdates.set(existingRow.id, {
//               updatedCategories: arr,
//               lastName: row.stock_name,
//               lastCategory: category,
//               lastUnit: tu.toString(),
//               lastPrice: avgP,
//               lastTotal: ta.toString(),
//               lastIndirect: ti.toString(),
//             });
//           }
//         } else {
//           // POST — new entry
//           categoriesToPost.push({
//             id: row.id,
//             stock_name: row.stock_name,
//             unit: row.unit,
//             total_amount: row.total_amount,
//             indirect_charges: row.indirect_charges ?? '0',
//             perUnitCharge: row.per_unit_charge,
//             category,
//             investment_type: 'structure',
//             total_amount_category: row.total_amount,
//           });
//         }
//       }
  
//       // ── buysellrecord ──────────────────────────────────────────────────────
//       try {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ date: batch.date, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }),
//         });
//       } catch {}
  
//       // ── invoice record ─────────────────────────────────────────────────────
//       try {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             farm: farmName,
//             party: partyId,
//             invoice_type: 'purchase',
//             date: batch.date,
//             datainvoice: datainvoiceAll,
//           }),
//         });
//       } catch {}
  
//       // ── PUT existing stocks ────────────────────────────────────────────────
//       for (const [rowId, obj] of rowUpdates.entries()) {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//           method: 'PUT',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             id: rowId,
//             party_id: partyId,
//             categories: JSON.stringify(obj.updatedCategories),
//             name: obj.lastName,
//             category: obj.lastCategory,
//             unit: obj.lastUnit,
//             price_per_unit: obj.lastPrice,
//             total_amount: obj.lastTotal,
//             indirect_charges: obj.lastIndirect,
//             investment_type: 'structure',
//             date: batch.date,
//           }),
//         });
//       }
  
//       // ── POST new stocks ────────────────────────────────────────────────────
//       if (categoriesToPost.length) {
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             party_id: partyId,
//             date: batch.date,
//             investment_type: 'structure',
//             categories: categoriesToPost,
//           }),
//         });
//       }
  
//       // ── usermeta (remaining balance) ───────────────────────────────────────
//       try {
//         const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${partyId}`);
//         const umList = await umRes.json();
//         const found = Array.isArray(umList)
//           ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(partyId))
//           : null;
//         if (found) {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, {
//             method: 'PUT',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               meta_key: 'remaining',
//               meta_value: (safeNumber(found.meta_value) - grandTotal).toString(),
//               party_id: partyId,
//             }),
//           });
//         } else {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               meta_key: 'remaining',
//               meta_value: ((availableTotalAmount || 0) - grandTotal).toString(),
//               party_id: partyId,
//             }),
//           });
//         }
//       } catch {}
//     }
  
//     await fetchParties();
//     setShowOcrModal(false);
//   };
//   return (
//     <>
//       <div className="p-6">
//         {/* ── Header ── */}
//         <div className="w-full flex justify-between items-center mb-6">
//           <h1 className="text-[28px] text-[#101828] font-[500]">Add New Stock</h1>
//           <div className="flex gap-3">
//           <button
//             type="button"
//             onClick={() => setShowOcrModal(true)}
//             className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] py-2 px-5 rounded-[8px] shadow hover:opacity-90 transition duration-150"
//           >
//             <svg
//               className="w-5 h-5 text-white"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2}
//               viewBox="0 0 24 24"
//             >
//               <rect
//                 x="3"
//                 y="4"
//                 width="18"
//                 height="16"
//                 rx="2"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 fill="#fff"
//                 fillOpacity=".1"
//               />
//               <path
//                 d="M8 2v4M16 2v4M3 10h18"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//               />
//               <circle
//                 cx="12"
//                 cy="14"
//                 r="3"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 fill="none"
//               />
//             </svg>
//             Scan Document
//           </button>
//           {/* Import from Excel or XML */}
//           <button
//             type="button"
//             onClick={() => setExcelUploadStep('setup')}
//             className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#0EA5E9] to-[#6366F1] py-2 px-5 rounded-[8px] shadow hover:opacity-90 transition duration-150"
//           >
//             <svg
//               className="w-5 h-5 text-white"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2}
//               viewBox="0 0 24 24"
//             >
//               <path d="M12 3v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//               <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//               <path d="M4 19h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//             </svg>
//             Import Excel / XML
//           </button>
//    {showOcrModal ? (
//   <OcrUploadModal
//   partiesList={partiesList}
//   stocksnames={stocksnames}
//   mutualsnames={mutualsnames}
//   onSubmit={handleOcrSubmit as any}
//   onClose={() => setShowOcrModal(false)}
//   apiUrl={process.env.REACT_APP_API_URL || ''}
// />
//    ) : null}
//             <button type="button" className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#1CAC70] to-[#FF9500] py-2 rounded-[8px] px-5" onClick={() => window.location.href = '/withdraw'}>Add Withdrawal</button>
//             <button type="button" className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#FF9500] to-[#1CAC70] py-2 rounded-[8px] px-5" onClick={() => window.location.href = '/sell-stock'}>Sell Stock</button>
//           </div>
//         </div>

//         {/* ── Manual Form ── */}
//         <form className="bg-white p-5 w-full rounded-[10px] shadow-sm" onSubmit={handleSubmit} autoComplete="off">
//           <div className="flex flex-wrap w-full justify-between mt-4 gap-4">
//             {/* Party */}
//             <div className="w-[100%] md:w-[48%]">
//               <label htmlFor="partyId" className="text-sm font-medium text-gray-700">Party Name</label>
//               <select name="partyId" id="partyId" value={data.partyId || urlParty} onChange={handleInput} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" required>
//                 <option value="">Choose Party</option>
//                 {partiesList.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
//               </select>
//               {selectedPartyTotalAmount !== null && <div className="text-xs text-blue-600 mt-1">Total Available: ₹{selectedPartyTotalAmount.toLocaleString()}</div>}
//               {deductedAvailable !== null && <div className="text-xs mt-1" style={{ color: deductedAvailable < 0 ? '#D8000C' : '#007200' }}>Available After Deduction: ₹{deductedAvailable.toLocaleString()}</div>}
//             </div>
//             {/* Date */}
//             <div className="w-[100%] md:w-[48%]">
//               <label htmlFor="date" className="text-sm font-medium text-gray-700">Date Of Purchase</label>
//               <input type="date" name="date" id="date" value={data.date} onChange={handleInput} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" />
//             </div>
//             {/* Investment Type */}
//             <div className="w-[100%] md:w-[48%]">
//               <label className="text-sm font-medium text-gray-700">Investment Type</label>
//               <select value={investmentType} onChange={e => { setInvestmentType(e.target.value as any); setDirectPaymentAmount(''); setCategoryEntries({}); }} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1">
//                 <option value="direct">Direct Payment</option>
//                 <option value="structure">Structure Payment</option>
//               </select>
//             </div>
//           </div>

//           {investmentType === 'direct' && (
//             <div className="mt-4 w-full md:w-[48%]">
//               <label className="text-sm font-medium text-gray-700">Payment Amount</label>
//               <input type="number" min={0} step="any" placeholder="Enter payment amount" value={directPaymentAmount} onChange={e => setDirectPaymentAmount(e.target.value)} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" required />
//             </div>
//           )}

//           {/* Categories */}
//           {(data.partyId || urlParty) && (
//             <div className="mt-6">
//               <p className="text-sm font-semibold text-gray-700 mb-3">Categories</p>
//               <div className="flex flex-col gap-3">
//                 {possibleCategories.map(cat => {
//                   const entries = categoryEntries[cat.category_name] || [];
//                   const isMutual = isMutualCategory(cat.category_name);
//                   return (
//                     <div key={cat.id} className="flex flex-col">
//                       <label className="flex items-center gap-2 cursor-pointer text-[#344054] text-[15px] font-medium">
//                         <input type="checkbox" checked={isChecked(cat)} onChange={() => handleCategory(cat)} className="w-4 h-4 accent-[#FF9500]" />
//                         {cat.category_name}
//                       </label>
//                       {isChecked(cat) && investmentType === 'structure' && (
//                         <div className="ml-6 mt-2 flex flex-col gap-3 border-l-2 border-[#ececec] pl-4">
//                           {entries.map((entry, ei) => (
//                             <div key={entry.id} className="flex flex-wrap gap-2 items-end bg-gray-50 p-3 rounded-lg relative">
//                               {/* ID */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">ID</label>
//                                 <input type="text" value={entry.id} readOnly className="w-[52px] bg-gray-100 border border-[#D0D5DD] p-2 rounded-[8px] text-[#5E5E5E] text-[12px] outline-none" />
//                               </div>
//                               {/* Stock Name with AsyncSelect + Add button */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">Stock Name</label>
//                                 <div className="flex gap-1 items-center">
//                                   <AsyncSelect
//                                     cacheOptions
//                                     defaultOptions={false}
//                                     loadOptions={(input, cb) => {
//                                       if (!input || input.length < 1) { cb([]); return; }
//                                       const src = isMutual ? mutualsnames : stocksnames;
//                                       const filtered = src.filter(s => s.name?.toLowerCase().includes(input.toLowerCase())).slice(0, 100).map(s => ({ value: s.name, label: s.name }));
//                                       cb(filtered);
//                                     }}
//                                     value={entry.stockName ? { value: entry.stockName, label: entry.stockName } : null}
//                                     onChange={sel => handleCategoryFieldChange(cat, ei, 'stockName', sel?.value || '')}
//                                     placeholder={isMutual ? 'Search Mutual Fund...' : 'Search Stock...'}
//                                     noOptionsMessage={({ inputValue }) =>
//                                       inputValue?.length > 0
//                                         ? <span className="text-xs text-gray-500">No match — type to search or use "+" to add</span>
//                                         : <span className="text-xs text-gray-400">Type to search…</span>
//                                     }
//                                     styles={{ control: (b) => ({ ...b, borderRadius: '8px', borderColor: '#D0D5DD', minHeight: '38px', width: '210px', fontSize: '13px' }) }}
//                                   />
//                                   {/* Task 2: Add stock button */}
//                                   <button
//                                     type="button"
//                                     title="Add new stock name"
//                                     onClick={() => {
//                                       setAddStockModalCategory(isMutual ? 'mutual' : 'stocks');
//                                       setPendingNewStockName(entry.stockName || '');
//                                       addStockCallbackRef.current = (name: string) => {
//                                         handleCategoryFieldChange(cat, ei, 'stockName', name);
//                                       };
//                                       setShowAddStockModal(true);
//                                     }}
//                                     className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 transition font-bold text-lg"
//                                     style={{ flexShrink: 0 }}
//                                   >
//                                     +
//                                   </button>
//                                 </div>
//                                 {entry.stockName && !(isMutual ? mutualsnames : stocksnames).some(s => s.name.toLowerCase() === entry.stockName.toLowerCase()) && (
//                                   <span className="text-[10px] text-amber-600 mt-0.5 flex items-center gap-1">
//                                     ⚠ Not in database —
//                                     <button
//                                       type="button"
//                                       onClick={() => {
//                                         setAddStockModalCategory(isMutual ? 'mutual' : 'stocks');
//                                         setPendingNewStockName(entry.stockName);
//                                         addStockCallbackRef.current = (name: string) => handleCategoryFieldChange(cat, ei, 'stockName', name);
//                                         setShowAddStockModal(true);
//                                       }}
//                                       className="underline text-blue-600 hover:text-blue-800"
//                                     >
//                                       Add to database?
//                                     </button>
//                                   </span>
//                                 )}
//                               </div>
//                               {/* Unit */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">Unit</label>
//                                 <input type="number" min={0} step="any" placeholder="Unit" value={entry.unit} onChange={e => handleCategoryFieldChange(cat, ei, 'unit', e.target.value)} className="w-[100px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
//                               </div>
//                               {/* Total Amount */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">Total Amount</label>
//                                 <input type="number" min={0} step="any" placeholder="Amount" value={entry.totalAmount} onChange={e => handleCategoryFieldChange(cat, ei, 'totalAmount', e.target.value)} className="w-[120px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
//                               </div>
//                               {/* Indirect Charges */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">Indirect Charges</label>
//                                 <input type="number" min={0} step="any" placeholder="Charges" value={entry.indirectCharges} onChange={e => handleCategoryFieldChange(cat, ei, 'indirectCharges', e.target.value)} className="w-[110px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
//                               </div>
//                               {/* Per Unit Charge */}
//                               <div className="flex flex-col">
//                                 <label className="text-[11px] text-gray-500">Per Unit Charge</label>
//                                 <input type="number" min={0} step="any" placeholder="Per unit" value={entry.perUnitCharge} onChange={e => handleCategoryFieldChange(cat, ei, 'perUnitCharge', e.target.value)} readOnly={entry.autoCalculated && !!entry.unit} className={`w-[110px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none ${entry.autoCalculated && !!entry.unit ? 'bg-gray-100' : ''}`} required />
//                                 {entry.autoCalculated && !!entry.unit && <span className="text-[10px] text-green-500">Auto-calc</span>}
//                               </div>
//                               {/* Remove */}
//                               <button type="button" onClick={() => handleRemoveEntry(cat, ei)} className="text-red-400 hover:text-red-600 border border-red-200 bg-red-50 rounded px-2 py-1 text-xs h-[34px]">Remove</button>
//                             </div>
//                           ))}
//                           <button type="button" onClick={() => handleAddEntry(cat)} className="text-sm text-blue-500 font-medium px-3 py-1 border border-blue-200 rounded bg-blue-50 w-fit hover:bg-blue-100 transition">+ Add row for {cat.category_name}</button>
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}

//           <button type="submit" className="mt-6 text-[16px] font-[500] text-white bg-gradient-to-r from-[#1CAC70] to-[#FF9500] py-2 rounded-[8px] px-8 hover:opacity-90 transition">Submit</button>
//         </form>
//       </div>

//       {/* ══════════════════════════════════════════════════════════════════════════
//           EXCEL / XML UPLOAD MODAL — STEP: SETUP
//       ══════════════════════════════════════════════════════════════════════════ */}
//       {excelUploadStep === 'setup' && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
//             {/* Header */}
//             <div className="bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] px-6 py-5">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <h2 className="text-xl font-bold text-white">Upload Excel or XML Data</h2>
//                   <p className="text-indigo-200 text-sm mt-0.5">Step 1 of 2 — Configure import settings</p>
//                 </div>
//                 <button onClick={() => { setExcelUploadStep('idle'); setExcelFiles([]); }} className="text-white/70 hover:text-white text-2xl">×</button>
//               </div>
//             </div>

//             <div className="p-6 flex flex-col gap-4">
//               {/* Party */}
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 block mb-1">Party Name <span className="text-red-500">*</span></label>
//                 <select value={excelSetupPartyId} onChange={e => { setExcelSetupPartyId(e.target.value); setExcelSetupCategory(''); }} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400">
//                   <option value="">Choose Party</option>
//                   {partiesList.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
//                 </select>
//               </div>
//               {/* Category */}
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 block mb-1">Category <span className="text-red-500">*</span></label>
//                 <select value={excelSetupCategory} onChange={e => setExcelSetupCategory(e.target.value)} disabled={!excelSetupPartyId} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400 disabled:bg-gray-100">
//                   <option value="">Select Category</option>
//                   {excelSetupPossibleCategories.map(c => <option key={c} value={c}>{c}</option>)}
//                 </select>
//               </div>
//               {/* Date */}
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 block mb-1">Purchase Date <span className="text-red-500">*</span></label>
//                 <input type="date" value={excelSetupDate} onChange={e => setExcelSetupDate(e.target.value)} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400" />
//               </div>

//               {/* File Upload */}
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 block mb-2">Excel or XML Files <span className="text-red-500">*</span></label>
//                 <div
//                   className="border-2 border-dashed border-indigo-200 rounded-xl p-6 text-center cursor-pointer hover:border-indigo-400 hover:bg-indigo-50/50 transition"
//                   onClick={() => excelFileInputRef.current?.click()}
//                 >
//                   <div className="text-3xl mb-2">📊</div>
//                   <p className="text-sm text-gray-600 font-medium">Click to browse or drop files here</p>
//                   <p className="text-xs text-gray-400 mt-1">Supports .xlsx, .xls, and .xml — multiple files allowed, all sheets/rows imported</p>
//                   <p className="text-xs text-indigo-500 mt-1 font-medium">Excel columns / XML fields: <code className="bg-indigo-50 px-1 rounded">stock_name</code>, <code className="bg-indigo-50 px-1 rounded">unit</code>, <code className="bg-indigo-50 px-1 rounded">total_amount</code></p>
//                 </div>
//                 <input ref={excelFileInputRef} type="file" accept=".xlsx,.xls,.xml" multiple className="hidden" onChange={handleExcelFilesChange} />
//                 {excelFiles.length > 0 && (
//                   <div className="mt-3 flex flex-col gap-1.5">
//                     {excelFiles.map((f, i) => (
//                       <div key={i} className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
//                         <div className="flex items-center gap-2">
//                           <span className="text-green-500">{f.name.toLowerCase().endsWith('.xml') ? '🗂️' : '📄'}</span>
//                           <span className="text-sm text-gray-700 font-medium">{f.name}</span>
//                           <span className="text-xs text-gray-400">({(f.size / 1024).toFixed(1)} KB)</span>
//                         </div>
//                         <button type="button" onClick={() => removeExcelFile(i)} className="text-red-400 hover:text-red-600 text-lg leading-none">×</button>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               <div className="flex gap-3 mt-2">
//                 <button type="button" onClick={() => { setExcelUploadStep('idle'); setExcelFiles([]); }} className="flex-1 border border-gray-300 text-gray-700 rounded-lg py-2.5 font-medium hover:bg-gray-50 transition">Cancel</button>
//                 <button type="button" onClick={handleExcelProceed} className="flex-1 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white rounded-lg py-2.5 font-medium hover:opacity-90 transition">Preview & Review →</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
     

//       {/* ══════════════════════════════════════════════════════════════════════════
//           EXCEL / XML UPLOAD MODAL — STEP: REVIEW
//       ══════════════════════════════════════════════════════════════════════════ */}
//       {excelUploadStep === 'review' && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl mx-4 flex flex-col" style={{ maxHeight: '90vh' }}>
//             {/* Header */}
//             <div className="bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] px-6 py-5 rounded-t-2xl flex-shrink-0">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <h2 className="text-xl font-bold text-white">Review Import Data</h2>
//                   <p className="text-indigo-200 text-sm mt-0.5">Step 2 of 2 — Verify stock matches and resolve conflicts</p>
//                 </div>
//                 <button onClick={() => setExcelUploadStep('setup')} className="text-white/70 hover:text-white text-2xl">×</button>
//               </div>
//               {/* Summary bar */}
//               <div className="flex gap-4 mt-3">
//                 {(() => {
//                   let matched = 0, fuzzy = 0, unmatched = 0;
//                   Object.values(processedRows).flat().forEach(r => {
//                     if (r._matchStatus === 'matched') matched++;
//                     else if (r._matchStatus === 'fuzzy') fuzzy++;
//                     else unmatched++;
//                   });
//                   const total = matched + fuzzy + unmatched;
//                   return (
//                     <>
//                       <div className="bg-white/20 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{total}</span> total rows</div>
//                       <div className="bg-green-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{matched}</span> matched</div>
//                       {fuzzy > 0 && <div className="bg-yellow-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{fuzzy}</span> fuzzy</div>}
//                       {unmatched > 0 && <div className="bg-red-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{unmatched}</span> not found</div>}
//                     </>
//                   );
//                 })()}
//               </div>
//             </div>

//             {/* Content */}
//             <div className="overflow-y-auto flex-1 p-6">
//               {Object.entries(processedRows).map(([sheetKey, rows]) => {
//                 const parts = sheetKey.split('__');
//                 const fileName = parts[1], sheetName = parts[2];
//                 return (
//                   <div key={sheetKey} className="mb-8">
//                     <div className="flex items-center gap-2 mb-3">
//                       <div className="bg-indigo-100 text-indigo-700 rounded-lg px-3 py-1 text-sm font-semibold">
//                         {fileName?.toLowerCase().endsWith('.xml') ? '🗂️' : '📄'} {fileName}
//                       </div>
//                       <div className="bg-gray-100 text-gray-600 rounded-lg px-3 py-1 text-sm">Sheet: {sheetName}</div>
//                       <div className="text-xs text-gray-400">{rows.length} rows</div>
//                     </div>
//                     <div className="border border-gray-200 rounded-xl overflow-hidden">
//                       <table className="w-full text-sm">
//                         <thead className="bg-gray-50">
//                           <tr>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">#</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Source Stock Name</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Status</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Final Name</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Unit</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Amount</th>
//                             <th className="text-left px-4 py-3 text-gray-600 font-medium">Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {rows.map((row, ri) => (
//                             <tr key={row._rowId} className={`border-t border-gray-100 ${row._matchStatus === 'matched' ? 'bg-green-50/30' : row._matchStatus === 'fuzzy' ? 'bg-yellow-50/30' : 'bg-red-50/30'}`}>
//                               <td className="px-4 py-3 text-gray-500">{ri + 1}</td>
//                               <td className="px-4 py-3 font-medium text-gray-800">
//                                 <input
//                                   type="text"
//                                   value={row.stock_name}
//                                   onChange={e => updateProcessedRow(sheetKey, row._rowId, { stock_name: e.target.value })}
//                                   className="border border-gray-200 rounded px-2 py-1 text-xs w-36 focus:outline-none focus:border-indigo-400 bg-transparent"
//                                 />
//                               </td>
//                               <td className="px-4 py-3">{renderMatchBadge(row._matchStatus)}</td>
//                               <td className="px-4 py-3">
//                                 {row._addNew
//                                   ? <input type="text" placeholder="New stock name" value={row._newStockName || ''} onChange={e => updateProcessedRow(sheetKey, row._rowId, { _newStockName: e.target.value })} className="border border-blue-300 rounded-lg px-2 py-1 text-xs w-40 focus:outline-none focus:border-blue-500" />
//                                   : row._matchStatus === 'matched'
//                                     ? <span className="text-green-700 font-medium">{row._matchedName}</span>
//                                     : <select value={row._userChoice || ''} onChange={e => updateProcessedRow(sheetKey, row._rowId, { _userChoice: e.target.value })} className="border border-gray-300 rounded-lg px-2 py-1 text-xs w-44 focus:outline-none focus:border-indigo-400">
//                                         <option value="">— select match —</option>
//                                         {row._candidateMatches?.map(c => <option key={c} value={c}>{c}</option>)}
//                                       </select>
//                                 }
//                               </td>
//                               <td className="px-4 py-3">
//                                 <input
//                                   type="number"
//                                   value={row.unit}
//                                   onChange={e => updateProcessedRow(sheetKey, row._rowId, { unit: e.target.value })}
//                                   className="border border-gray-200 rounded px-2 py-1 text-xs w-20 focus:outline-none focus:border-indigo-400"
//                                 />
//                               </td>
//                               <td className="px-4 py-3">
//                                 <input
//                                   type="number"
//                                   value={row.total_amount}
//                                   onChange={e => updateProcessedRow(sheetKey, row._rowId, { total_amount: e.target.value })}
//                                   className="border border-gray-200 rounded px-2 py-1 text-xs w-24 focus:outline-none focus:border-indigo-400"
//                                 />
//                               </td>
//                               <td className="px-4 py-3">
//                                 {row._matchStatus !== 'matched' && (
//                                   row._addNew
//                                     ? <button type="button" onClick={() => updateProcessedRow(sheetKey, row._rowId, { _addNew: false, _newStockName: '', _userChoice: '' })} className="text-xs text-gray-500 hover:text-gray-700 underline">Cancel</button>
//                                     : <button type="button" onClick={() => updateProcessedRow(sheetKey, row._rowId, { _addNew: true, _userChoice: '', _newStockName: row.stock_name })} className="text-xs bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 rounded px-2 py-1 transition">+ Add New</button>
//                                 )}
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             {/* Footer */}
//             <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 rounded-b-2xl flex-shrink-0 flex items-center justify-between">
//               <div className="text-sm text-gray-500">
//                 {!allRowsResolved
//                   ? <span className="text-amber-600 font-medium">⚠ Some rows need attention (select a match or add new)</span>
//                   : <span className="text-green-600 font-medium">✓ All rows resolved — ready to import</span>
//                 }
//               </div>
//               <div className="flex gap-3">
//                 <button type="button" onClick={() => setExcelUploadStep('setup')} className="border border-gray-300 text-gray-700 rounded-lg px-5 py-2 text-sm font-medium hover:bg-gray-100 transition">← Back</button>
//                 <button
//                   type="button"
//                   disabled={!allRowsResolved || excelSubmitLoading}
//                   onClick={handleExcelSubmit}
//                   className="bg-gradient-to-r from-[#1CAC70] to-[#059669] text-white rounded-lg px-6 py-2 text-sm font-medium hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   {excelSubmitLoading ? 'Importing...' : `Import ${Object.values(processedRows).flat().length} Rows`}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══════════════════════════════════════════════════════════════════════════
//           ADD STOCK NAME MODAL (Task 2)
//       ══════════════════════════════════════════════════════════════════════════ */}
//       {showAddStockModal && (
//         <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 backdrop-blur-sm">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden">
//             <div className="bg-gradient-to-r from-[#3B82F6] to-[#6366F1] px-6 py-4">
//               <div className="flex justify-between items-center">
//                 <h3 className="text-lg font-bold text-white">Add New Stock Name</h3>
//                 <button onClick={() => { setShowAddStockModal(false); setPendingNewStockName(''); }} className="text-white/70 hover:text-white text-xl">×</button>
//               </div>
//               <p className="text-blue-200 text-xs mt-1">This will add the stock to the {addStockModalCategory === 'mutual' ? 'Mutual Funds' : 'Equity'} database</p>
//             </div>
//             <div className="p-6 flex flex-col gap-4">
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 block mb-1">Stock Name</label>
//                 <input
//                   type="text"
//                   placeholder={addStockModalCategory === 'mutual' ? 'e.g. Axis Bluechip Fund' : 'e.g. INFY'}
//                   value={pendingNewStockName}
//                   onChange={e => setPendingNewStockName(e.target.value)}
//                   className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-blue-400"
//                   autoFocus
//                   onKeyDown={e => e.key === 'Enter' && handleAddStockName()}
//                 />
//               </div>
//               <div className="bg-blue-50 rounded-lg p-3 text-xs text-blue-700">
//                 <strong>Adding to:</strong> {addStockModalCategory === 'mutual' ? 'Mutual Funds database (mutualfunds_stock_name)' : 'Equity/Stock database (stocknames)'}
//               </div>
//               <div className="flex gap-3">
//                 <button type="button" onClick={() => { setShowAddStockModal(false); setPendingNewStockName(''); }} className="flex-1 border border-gray-300 text-gray-700 rounded-lg py-2 font-medium hover:bg-gray-50 transition">Cancel</button>
//                 <button type="button" onClick={handleAddStockName} disabled={addStockLoading || !pendingNewStockName.trim()} className="flex-1 bg-gradient-to-r from-[#3B82F6] to-[#6366F1] text-white rounded-lg py-2 font-medium hover:opacity-90 transition disabled:opacity-50">
//                   {addStockLoading ? 'Adding...' : 'Add Stock'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default Addstock;

// export default Addstock;
import React, { useCallback, useEffect, useState, useMemo, useRef } from 'react';
import * as XLSX from 'xlsx';
import parties from '../data/party';
import categoriesApi from '../data/categories';
import stockes from '../data/stockhistory';
import stockdata from '../data/stock';
import { fetchStocknames } from '../data/Stocknames';
import { fetchMutualnames } from '../data/Mutual';
import Select from "react-select";
import settingapi from '../data/setting';
import AsyncSelect from "react-select/async";
import OcrUploadModal from './OcrUploadModal';
// ─────────────────────────────────────────────────────────────────────────────
// TYPES
// ─────────────────────────────────────────────────────────────────────────────

interface Party {
  id: number;
  date: string;
  name: string;
  number: string;
  contact_person_name: string;
  contact_person_number: string;
  categories: string[];
  deleteparty: number;
  total_amount?: number | string;
}

interface CategoryApiType {
  id: number | string;
  category_name: string;
}

interface Stock {
  id: number | string;
  name: string;
  category: string;
}

interface StockNames {
  id: number;
  name: string;
  screener: string;
  ltp: string;
  [key: string]: any;
}

interface OcrSubmitInput {
    partyId: string | number;
    category: string;
    date: string;
    rows: Array<{
      id: string;
      stock_name: string;
      unit: string;
      total_amount: string;
      indirect_charges: string;
      per_unit_charge: string;
      confidence: 'high' | 'medium' | 'low';
      raw_text?: string;
      edited?: boolean;
      deleted?: boolean;
    }>;
  }

type StockCategoryInfo = {
  id: number | string;
  stockId: number | string;
  stockName: string;
  unit: string;
  totalAmount: string;
  indirectCharges: string;
  perUnitCharge: string;
  autoCalculated: boolean;
  category: string;
  error?: string;
};

type CategoryEntryMap = { [categoryName: string]: StockCategoryInfo[] };

type PartyStockDBType = {
  id: number | string;
  date: string;
  party_id: number | string;
  categories: string | (StockDBCategoryItem | DirectCategoryItem)[];
};

type StockDBCategoryItem = {
  id: number | string;
  investment_type: string;
  category: string;
  stock_name: string;
  unit: string;
  total_amount: string;
  indirect_charges: string;
  perUnitCharge: string;
};

type DirectCategoryItem = {
  investment_type: string;
  total_amount: string | number;
  date?: string;
  [key: string]: any;
};

// ─────────────────────────────────────────────────────────────────────────────
// EXCEL / XML UPLOAD TYPES
// ─────────────────────────────────────────────────────────────────────────────

type ExcelRow = {
  stock_name: string;
  unit: string | number;
  total_amount: string | number;
  indirect_charges?: string | number;
  date?: string;
  [key: string]: any;
};

type SheetData = {
  sheetName: string;
  fileName: string;
  fileIndex: number;
  rows: ExcelRow[];
};

type StockMatchStatus = 'matched' | 'fuzzy' | 'unmatched';

type ProcessedExcelRow = ExcelRow & {
  _rowId: string;
  _sheetKey: string;
  _matchStatus: StockMatchStatus;
  _matchedName?: string;
  _candidateMatches?: string[];
  _userChoice?: string; // after user resolves
  _addNew?: boolean;
  _newStockName?: string;
};

type ExcelUploadStep = 'idle' | 'setup' | 'review' | 'resolving' | 'confirmed';

// ─────────────────────────────────────────────────────────────────────────────
// HELPERS
// ─────────────────────────────────────────────────────────────────────────────

const safeNumber = (val: any) => {
  const num = parseFloat(val);
  return isNaN(num) ? 0 : num;
};

let globalEntryId = 1;

function emptyStockCategoryInfo(category = '', stockId: number | string = '', stockName = ''): StockCategoryInfo {
  return {
    id: globalEntryId++,
    stockId,
    stockName,
    category,
    unit: '',
    totalAmount: '',
    indirectCharges: '',
    perUnitCharge: '',
    autoCalculated: true,
    error: undefined,
  };
}

// Replace your existing fuzzyMatch and levenshtein with these optimized versions

// Pre-normalize the stock list ONCE instead of per-row
function buildNormalizedIndex(list: string[]): Map<string, string> {
  const map = new Map<string, string>();
  for (const name of list) {
    map.set(name.toLowerCase().replace(/[^a-z0-9]/g, ''), name);
  }
  return map;
}

function fuzzyMatchFast(
  name: string,
  normalizedIndex: Map<string, string>,
  originalList: string[]
): { matched?: string; candidates: string[]; status: StockMatchStatus } {
  const lower = name.toLowerCase().replace(/[^a-z0-9]/g, '');

  // 1. Exact match first (O(1))
  const exactOriginal = normalizedIndex.get(lower);
  if (exactOriginal) {
    return { matched: exactOriginal, candidates: [], status: 'matched' };
  }

  // 2. Substring match (faster than levenshtein)
  const candidates: string[] = [];
  for (const [normName, origName] of normalizedIndex.entries()) {
    if (normName.includes(lower) || lower.includes(normName)) {
      candidates.push(origName);
      if (candidates.length >= 5) break; // early exit
    }
  }

  if (candidates.length > 0) {
    return { matched: undefined, candidates, status: 'fuzzy' };
  }

  // 3. Levenshtein ONLY if no substring match (expensive - limit scope)
  const levenCandidates: string[] = [];
  for (const [normName, origName] of normalizedIndex.entries()) {
    // Skip if length difference is too large (quick pre-filter)
    if (Math.abs(normName.length - lower.length) > 4) continue;
    if (levenshtein(lower, normName) <= 3) {
      levenCandidates.push(origName);
      if (levenCandidates.length >= 5) break;
    }
  }

  return levenCandidates.length > 0
    ? { matched: undefined, candidates: levenCandidates, status: 'fuzzy' }
    : { matched: undefined, candidates: [], status: 'unmatched' };
}


function levenshtein(a: string, b: string): number {
  const m = a.length, n = b.length;
  const dp: number[][] = Array.from({ length: m + 1 }, (_, i) =>
    Array.from({ length: n + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0))
  );
  for (let i = 1; i <= m; i++)
    for (let j = 1; j <= n; j++)
      dp[i][j] = a[i - 1] === b[j - 1] ? dp[i - 1][j - 1] : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
  return dp[m][n];
}

function calculateTotalDeductedIncludingDirect(stockDbRows: PartyStockDBType[], partyId: string | number): number {
  let total = 0;
  stockDbRows.forEach(row => {
    if (String(row.party_id) !== String(partyId)) return;
    let arr: any[] = [];
    try { arr = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[]; } catch {}
    for (const item of arr) {
      if (item?.investment_type === 'direct') total += safeNumber(item.total_amount);
      else if (item?.category) { total += safeNumber(item.total_amount) + safeNumber(item.indirect_charges); }
    }
  });
  return total;
}

function calculateTotalDeductedFromStockTable(stockDbRows: PartyStockDBType[], partyId: string | number): number {
  let total = 0;
  stockDbRows.forEach(row => {
    if (String(row.party_id) !== String(partyId)) return;
    let arr: any[] = [];
    try { arr = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[]; } catch {}
    for (const item of arr) {
      if (item?.category) total += safeNumber(item.total_amount) + safeNumber(item.indirect_charges);
    }
  });
  return total;
}

async function fetchStocksAPI(): Promise<Stock[]> {
  return [
    { id: 1, name: 'SBI', category: 'Equity' },
    { id: 2, name: 'HDFC', category: 'Equity' },
    { id: 3, name: 'RELIANCE', category: 'Equity' },
    { id: 4, name: 'NIFTY-FUT', category: 'FNO' },
    { id: 5, name: 'BANKNIFTY-OPT', category: 'FNO' },
    { id: 6, name: 'ICICI MF', category: 'Mutual Funds' },
    { id: 7, name: 'SBI MF', category: 'Mutual Funds' },
    { id: 8, name: 'NIFTY ETF', category: 'ETF' },
    { id: 9, name: 'GOLD ETF', category: 'ETF' },
  ];
}

// ─────────────────────────────────────────────────────────────────────────────
// XML PARSING
// ─────────────────────────────────────────────────────────────────────────────

// Aliases tried (case-insensitive, punctuation-stripped) for each logical field,
// as either a child element's tag name OR an attribute on the row element.
const XML_FIELD_ALIASES: { [key: string]: string[] } = {
  stock_name: ['stock_name', 'stockname', 'name', 'stock', 'security', 'scrip', 'symbol'],
  unit: ['unit', 'units', 'qty', 'quantity'],
  total_amount: ['total_amount', 'totalamount', 'amount', 'price', 'value', 'totalvalue'],
  indirect_charges: ['indirect_charges', 'indirectcharges', 'charges', 'charge', 'brokerage'],
};

function normalizeTag(tag: string): string {
  return tag.toLowerCase().replace(/[^a-z0-9]/g, '');
}

function getXmlField(el: Element, aliases: string[]): string {
  // 1. try attributes on the row element itself
  for (const a of aliases) {
    for (const attr of Array.from(el.attributes)) {
      if (normalizeTag(attr.name) === normalizeTag(a)) return attr.value.trim();
    }
  }
  // 2. try direct child elements
  for (const child of Array.from(el.children)) {
    const tag = normalizeTag(child.tagName);
    if (aliases.some(a => normalizeTag(a) === tag)) {
      return (child.textContent || '').trim();
    }
  }
  return '';
}

// Finds the "row" elements in an arbitrary XML document. Tries common row tag
// names first; if none found, falls back to whichever tag repeats most often
// under the document root (a reasonable heuristic for unknown schemas).
function findXmlRowElements(doc: Document): Element[] {
  const rowTagCandidates = ['row', 'stock', 'item', 'entry', 'record', 'transaction', 'holding'];
  for (const tag of rowTagCandidates) {
    const found = Array.from(doc.getElementsByTagName(tag));
    if (found.length) return found;
  }
  const root = doc.documentElement;
  if (!root) return [];
  const counts: { [tag: string]: Element[] } = {};
  const walk = (el: Element) => {
    for (const child of Array.from(el.children)) {
      (counts[child.tagName] = counts[child.tagName] || []).push(child);
      walk(child);
    }
  };
  walk(root);
  let best: Element[] = [];
  for (const arr of Object.values(counts)) {
    if (arr.length > best.length) best = arr;
  }
  return best.length > 1 ? best : [];
}

// ── Tally-style Mutual Fund ledger export ───────────────────────────────────
// Real-world exports (e.g. from Tally/back-office software) look like:
//   <ENVELOPE>
//    <DSPACCNAME><DSPDISPNAME>Fund Name</DSPDISPNAME></DSPACCNAME>
//    <DSPSTKINFO><DSPSTKCL><DSPCLQTY>.. NOS</DSPCLQTY><DSPCLRATE>..</DSPCLRATE><DSPCLAMTA>-..</DSPCLAMTA></DSPSTKCL></DSPSTKINFO>  (running total — SKIP)
//    <SSBATCHNAME><SSBATCH>DD.MM.YY</SSBATCH></SSBATCHNAME>   (date of the NEXT transaction)
//    <DSPSTKINFO>...</DSPSTKINFO>                              (an actual transaction)
//    ... repeats ...
//    <DSPACCNAME>Next Fund Name</DSPACCNAME>
//    ... repeats ...
//   </ENVELOPE>
// The fund name applies to every transaction until the next DSPACCNAME. The
// FIRST DSPSTKINFO right after a DSPACCNAME is a closing/running balance
// (its amount equals the sum of all real transactions below it) and must be
// excluded from the imported rows. Every real transaction is a DSPSTKINFO
// immediately preceded by an SSBATCHNAME giving its date.
function isTallyMfXml(doc: Document): boolean {
  return !!doc.querySelector('DSPACCNAME') && !!doc.querySelector('DSPSTKINFO');
}

function convertTallyDate(raw: string): string {
  // "DD.MM.YY" -> "YYYY-MM-DD". Assumes 20YY (safe for these ledger exports).
  const m = raw.trim().match(/^(\d{1,2})\.(\d{1,2})\.(\d{2,4})$/);
  if (!m) return '';
  const [, dd, mm, yyRaw] = m;
  const yyyy = yyRaw.length === 4 ? yyRaw : `20${yyRaw}`;
  return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
}

function parseTallyMfXml(doc: Document): ExcelRow[] {
  const root = doc.documentElement;
  if (!root) return [];
  const rows: ExcelRow[] = [];

  let currentFundName = '';
  let pendingDate = '';
  let seenFirstStkInfoForFund = false;

  for (const child of Array.from(root.children)) {
    const tag = child.tagName.toUpperCase();

    if (tag === 'DSPACCNAME') {
      currentFundName = (child.querySelector('DSPDISPNAME')?.textContent || '').trim();
      seenFirstStkInfoForFund = false;
      pendingDate = '';
      continue;
    }

    if (tag === 'SSBATCHNAME') {
      pendingDate = convertTallyDate(child.querySelector('SSBATCH')?.textContent || '');
      continue;
    }

    if (tag === 'DSPSTKINFO') {
      const stkcl = child.querySelector('DSPSTKCL');
      if (!stkcl) continue;

      // The first DSPSTKINFO after a DSPACCNAME is a running/closing total,
      // not a transaction — skip it and don't consume a pending date.
      if (!seenFirstStkInfoForFund) {
        seenFirstStkInfoForFund = true;
        continue;
      }

      const qtyRaw = (stkcl.querySelector('DSPCLQTY')?.textContent || '').trim();
      const amtRaw = (stkcl.querySelector('DSPCLAMTA')?.textContent || '').trim();
      const qty = parseFloat(qtyRaw.replace(/[^0-9.\-]/g, '')) || 0;
      const amt = Math.abs(safeNumber(amtRaw));

      if (currentFundName) {
        rows.push({
          stock_name: currentFundName,
          unit: qty,
          total_amount: amt,
          indirect_charges: '0',
          date: pendingDate,
        });
      }
      pendingDate = ''; // each date belongs to exactly one transaction
    }
  }

  return rows;
}

// Reads a File's bytes and decodes them with the correct text encoding.
// XML exports from back-office/Tally-style tools are frequently UTF-16
// (with a byte-order-mark), and `File.text()` always assumes UTF-8 — so on
// a UTF-16 file it silently returns garbled/null-filled text and parsing
// fails with no useful signal. We sniff the BOM ourselves and pick the
// right decoder instead of trusting `file.text()`.
async function readFileAsText(file: File): Promise<string> {
  const buf = await file.arrayBuffer();
  const bytes = new Uint8Array(buf);

  // UTF-16 LE BOM: FF FE
  if (bytes.length >= 2 && bytes[0] === 0xff && bytes[1] === 0xfe) {
    return new TextDecoder('utf-16le').decode(buf);
  }
  // UTF-16 BE BOM: FE FF
  if (bytes.length >= 2 && bytes[0] === 0xfe && bytes[1] === 0xff) {
    return new TextDecoder('utf-16be').decode(buf);
  }
  // UTF-8 BOM: EF BB BF (TextDecoder strips it automatically)
  if (bytes.length >= 3 && bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf) {
    return new TextDecoder('utf-8').decode(buf);
  }
  // No BOM: heuristic — lots of embedded NUL bytes in the first chunk means
  // this is very likely UTF-16 without a BOM (rare, but seen from some
  // Windows/Tally exports). Otherwise assume plain UTF-8.
  const sampleLen = Math.min(bytes.length, 200);
  let nulCount = 0;
  for (let i = 0; i < sampleLen; i++) if (bytes[i] === 0x00) nulCount++;
  if (sampleLen > 0 && nulCount / sampleLen > 0.25) {
    return new TextDecoder('utf-16le').decode(buf);
  }
  return new TextDecoder('utf-8').decode(buf);
}

function parseXmlRows(xmlText: string): ExcelRow[] {
  const parser = new DOMParser();
  const doc = parser.parseFromString(xmlText, 'application/xml');
  if (doc.querySelector('parsererror')) return [];

  // Try the known Tally-style mutual fund ledger schema first.
  if (isTallyMfXml(doc)) {
    const tallyRows = parseTallyMfXml(doc);
    if (tallyRows.length) return tallyRows;
  }

  // Fall back to the generic "repeated row element" heuristic for any other
  // XML schema (row/item/entry/etc. elements carrying all fields directly).
  const rowElements = findXmlRowElements(doc);

  return rowElements
    .map(el => ({
      stock_name: getXmlField(el, XML_FIELD_ALIASES.stock_name),
      unit: getXmlField(el, XML_FIELD_ALIASES.unit),
      total_amount: getXmlField(el, XML_FIELD_ALIASES.total_amount),
      indirect_charges: getXmlField(el, XML_FIELD_ALIASES.indirect_charges) || '0',
    } as ExcelRow))
    .filter(r => r.stock_name);
}

// ─────────────────────────────────────────────────────────────────────────────
// COMPONENT
// ─────────────────────────────────────────────────────────────────────────────

interface Props {}
interface OcrExtractedRow {
    id: string;
    stock_name: string;
    unit: string;
    total_amount: string;
    indirect_charges: string;
    per_unit_charge: string;
    confidence: 'high' | 'medium' | 'low';
    raw_text?: string;
    edited?: boolean;
    deleted?: boolean;
    // NEW: per-row date from invoice
    row_date?: string;
  }
  
  interface OcrInvoice {
    invoice_no?: string;
    date?: string;
    rows: OcrExtractedRow[];
  }
  
  interface OcrResult {
    party_name?: string;
    category?: string;
    doc_type?: string;
    confidence_overall?: number;
    // NEW: multiple invoices instead of a single date + rows
    invoices: OcrInvoice[];
    // fallback for single-invoice docs
    date?: string;
    rows?: OcrExtractedRow[];
  }
  
  interface OcrFile {
    file: File;
    id: string;
    preview?: string;
    status: 'pending' | 'processing' | 'done' | 'error';
    result?: OcrResult;
    error?: string;
  }
  

function Addstock(props: Props) {
  // ── Core state ──────────────────────────────────────────────────────────────
  const [data, setData] = useState({ partyId: '', date: '' });
  const [investmentType, setInvestmentType] = useState<'direct' | 'structure'>('structure');
  const [directPaymentAmount, setDirectPaymentAmount] = useState('');
  const [categoryEntries, setCategoryEntries] = useState<CategoryEntryMap>({});
  const [partiesList, setPartiesList] = useState<Party[]>([]);
  const [allStocks, setAllStocks] = useState<Stock[]>([]);
  const [categoriesFromApi, setCategoriesFromApi] = useState<CategoryApiType[]>([]);
  const [stocksDb, setStocksDb] = useState<PartyStockDBType[]>([]);
  const [stocksDataDb, setStocksDataDb] = useState<PartyStockDBType[]>([]);
  const [urlParty, setUrlParty] = useState('');
  const [stocksnames, setStocksnames] = useState<StockNames[]>([]);
  const [mutualsnames, setMutualsnames] = useState<StockNames[]>([]);
  const [selectedPartyTotalAmount, setSelectedPartyTotalAmount] = useState<number | null>(null);
  const [deductedAvailable, setDeductedAvailable] = useState<number | null>(null);
  const [totalamountspend, setTotalAmmountSpend] = useState<number>();
  const [farmName, setFarmName] = useState<string>();
  const exceedPromptedRef = useRef(false);

  // ── Add-stock-name modal (Task 2) ────────────────────────────────────────────
  const [showAddStockModal, setShowAddStockModal] = useState(false);
  const [addStockModalCategory, setAddStockModalCategory] = useState<'stocks' | 'mutual'>('stocks');
  const [pendingNewStockName, setPendingNewStockName] = useState('');
  const [addStockLoading, setAddStockLoading] = useState(false);
  // Which entry triggered the add-stock modal (for injecting back)
  const addStockCallbackRef = useRef<((name: string) => void) | null>(null);

  // ── Excel / XML upload state ─────────────────────────────────────────────────
  // NOTE: this single pipeline now accepts .xlsx, .xls, AND .xml files. The
  // setup step (party/category/date) and review/resolve/submit steps are
  // shared across both formats — only file parsing branches by extension.
  const [excelUploadStep, setExcelUploadStep] = useState<ExcelUploadStep>('idle');
  const [excelSetupPartyId, setExcelSetupPartyId] = useState('');
  const [excelSetupCategory, setExcelSetupCategory] = useState('');
  const [excelSetupDate, setExcelSetupDate] = useState('');
  const [excelFiles, setExcelFiles] = useState<File[]>([]);
  const [parsedSheets, setParsedSheets] = useState<SheetData[]>([]);
  const [processedRows, setProcessedRows] = useState<{ [sheetKey: string]: ProcessedExcelRow[] }>({});
  const [currentResolvingSheet, setCurrentResolvingSheet] = useState<string | null>(null);
  const [currentResolvingRowId, setCurrentResolvingRowId] = useState<string | null>(null);
  const [excelSubmitLoading, setExcelSubmitLoading] = useState(false);
  const [excelParsing, setExcelParsing] = useState(false);
  const [excelSetupError, setExcelSetupError] = useState<string | null>(null);
  const excelFileInputRef = useRef<HTMLInputElement>(null);

  const [showOcrModal, setShowOcrModal] = useState(false);

  // Whether any uploaded file is XML — XML carries its own per-row dates, so
  // we don't force the user to pick a single date for the whole import.
  const hasXmlFile = excelFiles.some(f => f.name.toLowerCase().endsWith('.xml'));

  // ─────────────────────────────────────────────────────────────────────────────
  // DATA FETCHING
  // ─────────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const partyId = urlParams.get('party') || '';
    setUrlParty(partyId);
    if (partyId) setData(prev => ({ ...prev, partyId }));
  }, []);

  const fetchParties = useCallback(async () => {
    const res = await parties();
    const cleaned = Array.isArray(res)
      ? res.map((item: any) => ({
          ...item,
          categories: typeof item.categories === 'string'
            ? (() => { try { const p = JSON.parse(item.categories); return Array.isArray(p) ? p : [item.categories]; } catch { return [item.categories]; } })()
            : Array.isArray(item.categories) ? item.categories : [],
          total_amount: item.total_amount !== undefined ? Number(item.total_amount) : undefined,
        }))
      : [];
    setPartiesList(cleaned);
  }, []);

  useEffect(() => {
    async function fetchSettingsApi() {
      try {
        const res = await settingapi();
        if (Array.isArray(res)) {
          const s = res.find((i: any) => i.meta_key === 'farm');
          if (s?.meta_value) {
            const obj = typeof s.meta_value === 'string' ? JSON.parse(s.meta_value) : s.meta_value;
            if (typeof obj?.name === 'string') setFarmName(obj.name);
          }
        }
      } catch {}
    }
    fetchSettingsApi();
    fetchParties();
    categoriesApi().then(r => Array.isArray(r) && setCategoriesFromApi(r));
    fetchStocksAPI().then(s => setAllStocks(s));
    stockes().then(r => setStocksDb(Array.isArray(r) ? r : [])).catch(() => setStocksDb([]));
    stockdata().then(r => setStocksDataDb(Array.isArray(r) ? r : [])).catch(() => setStocksDataDb([]));
    fetchStocknames().then(r => setStocksnames(Array.isArray(r) ? r : [])).catch(() => setStocksnames([]));
    fetchMutualnames().then(r => setMutualsnames(Array.isArray(r) ? r : [])).catch(() => setMutualsnames([]));
  }, [fetchParties]);

  // ─────────────────────────────────────────────────────────────────────────────
  // DERIVED
  // ─────────────────────────────────────────────────────────────────────────────

  const possibleCategories = useMemo(() => {
    const activePartyId = data.partyId || urlParty;
    if (!activePartyId || !partiesList.length) return [];
    const party = partiesList.find(p => String(p.id) === String(activePartyId));
    if (party?.categories?.length) return party.categories.map((n: string) => ({ category_name: n, id: n }));
    return [];
  }, [partiesList, data.partyId, urlParty]);

  const excelSetupPossibleCategories = useMemo(() => {
    if (!excelSetupPartyId || !partiesList.length) return [];
    const party = partiesList.find(p => String(p.id) === String(excelSetupPartyId));
    if (party?.categories?.length) return party.categories;
    return [];
  }, [partiesList, excelSetupPartyId]);

  useEffect(() => {
    if (data.partyId && partiesList.length) {
      const party = partiesList.find(p => String(p.id) === String(data.partyId));
      setSelectedPartyTotalAmount(party?.total_amount != null ? Number(party.total_amount) : null);
    } else setSelectedPartyTotalAmount(null);
  }, [data.partyId, partiesList]);

  useEffect(() => {
    if (!selectedPartyTotalAmount) { setDeductedAvailable(null); return; }
    if (!data.partyId || !stocksDataDb.length) { setDeductedAvailable(selectedPartyTotalAmount); return; }
    const dbDeducted = calculateTotalDeductedIncludingDirect(stocksDataDb, data.partyId);
    let uiDeducted = 0;
    Object.values(categoryEntries).flat().forEach(e => {
      uiDeducted += safeNumber(e.totalAmount) + safeNumber(e.indirectCharges);
    });
    const result = selectedPartyTotalAmount - dbDeducted - uiDeducted;
    setDeductedAvailable(result);
    if (result < 0 && !exceedPromptedRef.current) {
      setTimeout(() => {
        const ok = window.confirm('You exceed your amount. Do you want to add it from margin money?');
        exceedPromptedRef.current = true;
        if (!ok) setDeductedAvailable(null);
      }, 100);
    }
  }, [selectedPartyTotalAmount, investmentType, directPaymentAmount, categoryEntries, data.partyId, stocksDataDb]);

  // ─────────────────────────────────────────────────────────────────────────────
  // CATEGORY / ENTRY HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  const isChecked = (cat: CategoryApiType) => Object.prototype.hasOwnProperty.call(categoryEntries, cat.category_name);

  const handleCategory = (cat: CategoryApiType) => {
    setCategoryEntries(prev => {
      const copy = { ...prev };
      if (copy[cat.category_name]) delete copy[cat.category_name];
      else copy[cat.category_name] = [emptyStockCategoryInfo(cat.category_name)];
      return copy;
    });
  };

  const handleCategoryFieldChange = (cat: CategoryApiType, entryIdx: number, field: keyof StockCategoryInfo, value: string) => {
    const category = cat.category_name;
    setCategoryEntries(prev => {
      const entries = [...(prev[category] || [])];
      const entry = { ...(entries[entryIdx] || emptyStockCategoryInfo(category)) };
      if (field === 'stockName') {
        entry.stockName = value;
        const s = allStocks.find(s => s.category === category && s.name.toLowerCase() === value.toLowerCase());
        entry.stockId = s ? s.id : value;
      } else if (field === 'stockId') {
        entry.stockId = value;
        const s = allStocks.find(s => s.category === category && String(s.id) === value);
        entry.stockName = s ? s.name : value;
      } else if (field === 'unit' || field === 'totalAmount' || field === 'indirectCharges') {
        (entry as any)[field] = value;
        const u = safeNumber(field === 'unit' ? value : entry.unit);
        const t = safeNumber(field === 'totalAmount' ? value : entry.totalAmount);
        const i = safeNumber(field === 'indirectCharges' ? value : entry.indirectCharges);
        entry.perUnitCharge = u > 0 ? ((t + i) / u).toFixed(2) : '';
        entry.autoCalculated = true;
      } else if (field === 'perUnitCharge') {
        entry.perUnitCharge = value;
        entry.autoCalculated = false;
      } else {
        (entry as any)[field] = value;
      }
      entries[entryIdx] = entry;
      return { ...prev, [category]: entries };
    });
  };

  const handleAddEntry = (cat: CategoryApiType) => {
    setCategoryEntries(prev => ({
      ...prev,
      [cat.category_name]: [...(prev[cat.category_name] || []), emptyStockCategoryInfo(cat.category_name)],
    }));
  };

  const handleRemoveEntry = (cat: CategoryApiType, idx: number) => {
    setCategoryEntries(prev => {
      const entries = [...(prev[cat.category_name] || [])];
      entries.splice(idx, 1);
      const copy = { ...prev };
      if (entries.length > 0) copy[cat.category_name] = entries;
      else delete copy[cat.category_name];
      return copy;
    });
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
    if (name === 'partyId') {
      setInvestmentType('structure');
      setCategoryEntries({});
      setDirectPaymentAmount('');
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // TASK 2: ADD STOCK NAME INLINE
  // ─────────────────────────────────────────────────────────────────────────────

  const isMutualCategory = (catName: string) =>
    catName.toLowerCase().includes('mutual');

  const handleAddStockName = async () => {
    if (!pendingNewStockName.trim()) { alert('Enter a stock name'); return; }
    setAddStockLoading(true);
    try {
      const endpoint = addStockModalCategory === 'mutual'
        ? `${process.env.REACT_APP_API_URL}/auth/mutualstocks`
        : `${process.env.REACT_APP_API_URL}/auth/stocks`;
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: pendingNewStockName.trim() }),
      });
      if (!res.ok) throw new Error('Failed to add stock');
      // Refresh stock lists
      if (addStockModalCategory === 'mutual') {
        fetchMutualnames().then(r => setMutualsnames(Array.isArray(r) ? r : []));
      } else {
        fetchStocknames().then(r => setStocksnames(Array.isArray(r) ? r : []));
      }
      // Inject name back into the entry that triggered this
      if (addStockCallbackRef.current) addStockCallbackRef.current(pendingNewStockName.trim());
      setShowAddStockModal(false);
      setPendingNewStockName('');
    } catch (err: any) {
      alert('Error: ' + err.message);
    } finally {
      setAddStockLoading(false);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // EXCEL / XML UPLOAD: PARSE
  // ─────────────────────────────────────────────────────────────────────────────

  const handleExcelFilesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    setExcelFiles(prev => [...prev, ...files]);
    setExcelSetupError(null);
  };

  const removeExcelFile = (idx: number) => {
    setExcelFiles(prev => prev.filter((_, i) => i !== idx));
  };

  // Parses every uploaded file into the shared SheetData[] shape, branching by
  // extension: .xml goes through parseXmlRows (DOMParser-based), everything
  // else is treated as a spreadsheet via the xlsx library. Both paths funnel
  // into the same downstream review/match/submit pipeline.
  const parseImportFiles = async (): Promise<{ sheets: SheetData[]; warnings: string[] }> => {
    const allSheets: SheetData[] = [];
    const fileParseWarnings: string[] = [];
    for (let fi = 0; fi < excelFiles.length; fi++) {
      const file = excelFiles[fi];
      const isXml = file.name.toLowerCase().endsWith('.xml');

      if (isXml) {
        try {
          const text = await readFileAsText(file);
          const rows = parseXmlRows(text);
          if (rows.length) {
            allSheets.push({ sheetName: 'XML Data', fileName: file.name, fileIndex: fi, rows });
          } else {
            fileParseWarnings.push(`${file.name}: parsed but found 0 usable rows — check the file structure.`);
          }
        } catch (err: any) {
          fileParseWarnings.push(`${file.name}: failed to read/parse (${err?.message || 'unknown error'}).`);
        }
        continue;
      }

      try {
        const buffer = await file.arrayBuffer();
        const wb = XLSX.read(buffer, { type: 'array' });
        let fileHadRows = false;
        for (const sheetName of wb.SheetNames) {
          const ws = wb.Sheets[sheetName];
          const raw: any[] = XLSX.utils.sheet_to_json(ws, { defval: '' });
          // Normalize column names (lowercase, trim)
          const rows: ExcelRow[] = raw.map(r => {
            const norm: any = {};
            for (const k of Object.keys(r)) {
              norm[k.toLowerCase().trim().replace(/\s+/g, '_')] = r[k];
            }
            return {
              stock_name: String(norm.stock_name || norm.stockname || norm.name || norm['stock name'] || '').trim(),
              unit: norm.unit || norm.units || norm.qty || norm.quantity || '',
              total_amount: norm.total_amount || norm.totalamount || norm.amount || norm.price || '',
              indirect_charges: norm.indirect_charges || norm.indirectcharges || norm.charges || '0',
            } as ExcelRow;
          }).filter(r => r.stock_name);
          if (rows.length) {
            allSheets.push({ sheetName, fileName: file.name, fileIndex: fi, rows });
            fileHadRows = true;
          }
        }
        if (!fileHadRows) {
          fileParseWarnings.push(`${file.name}: no rows with a stock_name column found in any sheet.`);
        }
      } catch (err: any) {
        fileParseWarnings.push(`${file.name}: failed to read/parse (${err?.message || 'unknown error'}).`);
      }
    }
    return { sheets: allSheets, warnings: fileParseWarnings };
  };
// Replace processSheets with this async chunked version
const processSheets = async (
  sheets: SheetData[],
  stockNameList: string[]
): Promise<{ [sheetKey: string]: ProcessedExcelRow[] }> => {
  const result: { [sheetKey: string]: ProcessedExcelRow[] } = {};

  // Build index ONCE
  const normalizedIndex = buildNormalizedIndex(stockNameList);

  for (const sheet of sheets) {
    const key = `${sheet.fileIndex}__${sheet.fileName}__${sheet.sheetName}`;
    const processedRows: ProcessedExcelRow[] = [];

    // Process in chunks to avoid blocking UI
    const CHUNK_SIZE = 50;
    for (let i = 0; i < sheet.rows.length; i += CHUNK_SIZE) {
      const chunk = sheet.rows.slice(i, i + CHUNK_SIZE);

      for (const [ri, row] of chunk.entries()) {
        const actualIndex = i + ri;
        const { matched, candidates, status } = fuzzyMatchFast(
          row.stock_name,
          normalizedIndex,
          stockNameList
        );

        processedRows.push({
          ...row,
          _rowId: `${key}__${actualIndex}`,
          _sheetKey: key,
          _matchStatus: status,
          _matchedName: matched,
          _candidateMatches: candidates,
          _userChoice: matched,
          _addNew: false,
          _newStockName: '',
        } as ProcessedExcelRow);
      }

      // Yield to browser every chunk to keep UI responsive
      await new Promise(resolve => setTimeout(resolve, 0));
    }

    result[key] = processedRows;
  }

  return result;
};


// Update handleExcelProceed to use async processSheets
const handleExcelProceed = async () => {
  setExcelSetupError(null);
  if (!excelSetupPartyId) { setExcelSetupError('Select a party.'); return; }
  if (!excelSetupCategory) { setExcelSetupError('Select a category.'); return; }
  if (!excelFiles.length) { setExcelSetupError('Upload at least one Excel or XML file.'); return; }

  setExcelParsing(true);
  try {
    const { sheets, warnings } = await parseImportFiles();

    if (!sheets.length) {
      setExcelSetupError(
        warnings.length
          ? warnings.join(' ')
          : 'No valid rows found. Check column names: stock_name, unit, total_amount.'
      );
      return;
    }

    const allRowsHaveOwnDate = sheets.every(s => s.rows.every(r => !!r.date));
    if (!allRowsHaveOwnDate && !excelSetupDate) {
      setExcelSetupError('Select a purchase date.');
      return;
    }

    const isMutual = isMutualCategory(excelSetupCategory);
    const nameList = (isMutual ? mutualsnames : stocksnames).map(s => s.name);

    // Now async — won't freeze UI
    const processed = await processSheets(sheets, nameList);

    // Fill setup date for rows missing their own date
    for (const key of Object.keys(processed)) {
      processed[key] = processed[key].map(r => ({
        ...r,
        date: r.date || excelSetupDate,
      }));
    }

    setParsedSheets(sheets);
    setProcessedRows(processed);
    setExcelUploadStep('review');

    if (warnings.length) {
      setExcelSetupError(warnings.join(' '));
    }
  } catch (err: any) {
    setExcelSetupError('Error parsing files: ' + (err?.message || String(err)));
  } finally {
    setExcelParsing(false);
  }
};


  // Rows that need resolution (fuzzy or unmatched)
  const unresolvedRows = useMemo(() => {
    const rows: ProcessedExcelRow[] = [];
    for (const sheetRows of Object.values(processedRows)) {
      for (const row of sheetRows) {
        if (row._matchStatus !== 'matched' && !row._userChoice && !row._addNew) rows.push(row);
      }
    }
    return rows;
  }, [processedRows]);

  const updateProcessedRow = (sheetKey: string, rowId: string, patch: Partial<ProcessedExcelRow>) => {
    setProcessedRows(prev => ({
      ...prev,
      [sheetKey]: prev[sheetKey].map(r => r._rowId === rowId ? { ...r, ...patch } : r),
    }));
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // EXCEL / XML SUBMIT
  // ─────────────────────────────────────────────────────────────────────────────

  const handleExcelSubmit = async () => {
    setExcelSubmitLoading(true);
    try {
      const isMutual = isMutualCategory(excelSetupCategory);
      const party = partiesList.find(p => String(p.id) === String(excelSetupPartyId));
      const availableTotalAmount = party?.total_amount != null ? Number(party.total_amount) : null;

      // 1. Add new stock names first
      const rowsToAddAsNewStock: ProcessedExcelRow[] = [];
      for (const sheetRows of Object.values(processedRows)) {
        for (const row of sheetRows) {
          if (row._addNew && row._newStockName?.trim()) rowsToAddAsNewStock.push(row);
        }
      }
      const addedNames: Set<string> = new Set();
      for (const row of rowsToAddAsNewStock) {
        const nm = row._newStockName!.trim();
        if (addedNames.has(nm)) continue;
        addedNames.add(nm);
        const ep = isMutual
          ? `${process.env.REACT_APP_API_URL}/auth/mutualstocks`
          : `${process.env.REACT_APP_API_URL}/auth/stocks`;
        await fetch(ep, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: nm }),
        });
      }

      // 2. Flatten every valid row across every sheet, then group by its own
      //    date — each XML transaction (or spreadsheet row) can carry a
      //    different date, so each date group is submitted as its own
      //    invoice/buysellrecord batch, mirroring the OCR import flow.
      const allValidRows: ProcessedExcelRow[] = [];
      for (const sheetRows of Object.values(processedRows)) {
        for (const row of sheetRows) {
          const finalName = row._addNew ? row._newStockName : (row._userChoice || row._matchedName || row.stock_name);
          if (finalName?.trim()) allValidRows.push(row);
        }
      }

      const rowsByDate = new Map<string, ProcessedExcelRow[]>();
      for (const row of allValidRows) {
        const d = row.date || excelSetupDate;
        if (!rowsByDate.has(d)) rowsByDate.set(d, []);
        rowsByDate.get(d)!.push(row);
      }

      for (const [batchDate, rows] of rowsByDate.entries()) {
        if (!batchDate) continue;

        const cats = rows.map(row => {
          const finalName = (row._addNew ? row._newStockName : (row._userChoice || row._matchedName || row.stock_name)) || '';
          const unit = String(row.unit || '0');
          const total = String(row.total_amount || '0');
          const indirect = String(row.indirect_charges || '0');
          const u = safeNumber(unit), t = safeNumber(total), ind = safeNumber(indirect);
          return {
            id: globalEntryId++,
            stock_name: finalName,
            unit,
            total_amount: total,
            indirect_charges: indirect,
            perUnitCharge: u > 0 ? ((t + ind) / u).toFixed(2) : '0',
            category: excelSetupCategory,
            investment_type: 'structure',
            total_amount_category: total,
          };
        });

        // Check for existing stocks -> PUT, new -> POST
        const rowUpdates = new Map<any, any>();
        const newCats: any[] = [];
        let grandTotal = 0;

        for (const cat of cats) {
          grandTotal += safeNumber(cat.total_amount) + safeNumber(cat.indirect_charges);
          const existingRow = stocksDataDb.find(row => {
            if (String(row.party_id) !== String(excelSetupPartyId)) return false;
            const items: any[] = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[];
            return items.some(i => i.stock_name === cat.stock_name && i.category === excelSetupCategory);
          });
          if (existingRow) {
            const arr: any[] = rowUpdates.has(existingRow.id) ? rowUpdates.get(existingRow.id).arr : (typeof existingRow.categories === 'string' ? JSON.parse(existingRow.categories) : [...existingRow.categories as any[]]);
            const target = arr.find(i => i.stock_name === cat.stock_name && i.category === excelSetupCategory);
            if (target) {
              const tu = safeNumber(target.unit) + safeNumber(cat.unit);
              const ta = safeNumber(target.total_amount) + safeNumber(cat.total_amount);
              const ti = safeNumber(target.indirect_charges) + safeNumber(cat.indirect_charges);
              target.unit = tu.toString(); target.total_amount = ta.toString(); target.indirect_charges = ti.toString();
              target.perUnitCharge = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0';
              rowUpdates.set(existingRow.id, { arr, lastName: cat.stock_name, lastCat: excelSetupCategory, lastUnit: tu.toString(), lastTotal: ta.toString(), lastIndirect: ti.toString(), lastPrice: target.perUnitCharge });
            }
          } else {
            newCats.push(cat);
          }
        }

        // PUT existing
        for (const [rowId, obj] of rowUpdates.entries()) {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: rowId, party_id: excelSetupPartyId,
              categories: JSON.stringify(obj.arr),
              name: obj.lastName, category: obj.lastCat,
              unit: obj.lastUnit, price_per_unit: obj.lastPrice,
              total_amount: obj.lastTotal, indirect_charges: obj.lastIndirect,
              date: batchDate,
            }),
          });
        }

        // POST new
        if (newCats.length) {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ party_id: excelSetupPartyId, date: batchDate, investment_type: 'structure', categories: newCats }),
          });
        }

        // invoice record for this date's batch
        try {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ farm: farmName, party: excelSetupPartyId, invoice_type: 'purchase', date: batchDate, datainvoice: cats }),
          });
        } catch {}

        // buysellrecord + usermeta
        await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ date: batchDate, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }),
        }).catch(() => {});

        const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${excelSetupPartyId}`);
        const umList = await umRes.json();
        const found = Array.isArray(umList) ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(excelSetupPartyId)) : null;
        if (found) {
          const newVal = (safeNumber(found.meta_value) - grandTotal).toString();
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, {
            method: 'PUT', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ meta_key: 'remaining', meta_value: newVal, party_id: excelSetupPartyId }),
          });
        } else if (availableTotalAmount != null) {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ meta_key: 'remaining', meta_value: (availableTotalAmount - grandTotal).toString(), party_id: excelSetupPartyId }),
          });
        }
      }

      alert('Data submitted successfully!');
      setExcelUploadStep('idle');
      setParsedSheets([]);
      setProcessedRows({});
      setExcelFiles([]);
      setExcelSetupPartyId('');
      setExcelSetupCategory('');
      setExcelSetupDate('');
      window.location.reload();
    } catch (err: any) {
      alert('Error: ' + err.message);
    } finally {
      setExcelSubmitLoading(false);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // MAIN SUBMIT
  // ─────────────────────────────────────────────────────────────────────────────

  const getNextCategoryId = () => {
    const ids: number[] = [];
    stocksDataDb.forEach(row => {
      const items = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories;
      (items as any[]).forEach(i => i.id && ids.push(Number(i.id)));
    });
    return (ids.length ? Math.max(...ids) : 0) + 1;
  };

  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    if (!data.partyId) { alert('Please select a party'); return; }
    const party = partiesList.find(p => String(p.id) === String(data.partyId));
    const availableTotalAmount = party?.total_amount != null ? Number(party.total_amount) : null;
    if (availableTotalAmount == null) { alert('Could not determine total amount available.'); return; }
    const currentInvestmentType = investmentType;
    const selectedCategories = Object.keys(categoryEntries);
    if (selectedCategories.length === 0) { alert('Please select at least one category'); return; }

    const rowUpdates = new Map<any, any>();
    let categoriesToPost: any[] = [];
    let grandTotal = 0;
    let datainvoiceAll: any[] = [];

    for (const categoryName of selectedCategories) {
      const entries = categoryEntries[categoryName];
      for (const catInfo of entries) {
        if (!catInfo.stockName?.trim()) continue;
        const amt = safeNumber(catInfo.totalAmount), ind = safeNumber(catInfo.indirectCharges);
        grandTotal += amt + ind;
        datainvoiceAll.push({ id: catInfo.id, stock_name: catInfo.stockName, unit: catInfo.unit, total_amount: catInfo.totalAmount, indirect_charges: catInfo.indirectCharges ?? '0', perUnitCharge: catInfo.perUnitCharge, category: categoryName, investment_type: currentInvestmentType, total_amount_category: catInfo.totalAmount });
        const existingRow = stocksDataDb.find(row => {
          if (String(row.party_id) !== String(data.partyId)) return false;
          const items: any[] = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[];
          return items.some(i => i.stock_name === catInfo.stockName && i.category === categoryName);
        });
        if (existingRow) {
          const arr: any[] = rowUpdates.has(existingRow.id) ? rowUpdates.get(existingRow.id).updatedCategories : (typeof existingRow.categories === 'string' ? JSON.parse(existingRow.categories) : [...existingRow.categories as any[]]);
          const target = arr.find((i: any) => i.stock_name === catInfo.stockName && i.category === categoryName);
          if (target) {
            const tu = safeNumber(target.unit) + safeNumber(catInfo.unit);
            const ta = safeNumber(target.total_amount) + amt;
            const ti = safeNumber(target.indirect_charges) + ind;
            const avgP = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0.00';
            target.unit = tu.toString(); target.total_amount = ta.toString(); target.indirect_charges = ti.toString(); target.perUnitCharge = avgP; target.total_amount_category = ta.toString(); target.investment_type = currentInvestmentType;
            rowUpdates.set(existingRow.id, { updatedCategories: arr, lastCatId: catInfo.id, lastName: catInfo.stockName, lastCategory: categoryName, lastUnit: tu.toString(), lastPrice: avgP, lastTotal: ta.toString(), lastIndirect: ti.toString() });
          }
        } else {
          categoriesToPost.push({ id: catInfo.id, stock_name: catInfo.stockName, unit: catInfo.unit, total_amount: catInfo.totalAmount, indirect_charges: catInfo.indirectCharges ?? '0', perUnitCharge: catInfo.perUnitCharge, category: categoryName, investment_type: currentInvestmentType, total_amount_category: catInfo.totalAmount });
        }
      }
    }

    if (typeof setTotalAmmountSpend === 'function') setTotalAmmountSpend(grandTotal);

    try {
      await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ date: data.date, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }) });
    } catch {}
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ farm: farmName, party: data.partyId, invoice_type: 'purchase', date: data.date, datainvoice: datainvoiceAll }) });
    } catch {}

    const handleUserMetaUpdate = async (amount: number) => {
      try {
        const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${data.partyId}`);
        const umList = await umRes.json();
        const found = Array.isArray(umList) ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(data.partyId)) : null;
        if (found) {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ meta_key: 'remaining', meta_value: (safeNumber(found.meta_value) - amount).toString(), party_id: data.partyId }) });
        } else {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ meta_key: 'remaining', meta_value: ((availableTotalAmount || 0) - amount).toString(), party_id: data.partyId }) });
        }
      } catch {}
    };

    if (investmentType === 'direct') {
      const payment = safeNumber(directPaymentAmount);
      if (payment <= 0) { alert('Please enter valid payment amount'); return; }
      try {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ party_id: data.partyId, date: data.date, investment_type: 'direct', categories: [{ id: getNextCategoryId(), stock_name: 'DirectPayment', unit: '0', total_amount: payment.toString(), category: 'Equity', indirect_charges: '0', perUnitCharge: '0', investment_type: 'direct', total_amount_category: payment.toString() }] }) });
        await handleUserMetaUpdate(payment);
        alert('Direct payment submitted'); window.location.reload(); return;
      } catch (err) { alert('Error in direct payment'); return; }
    }

    try {
      for (const [rowId, obj] of rowUpdates.entries()) {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: rowId, party_id: data.partyId, categories: JSON.stringify(obj.updatedCategories), name: obj.lastName, category: obj.lastCategory, unit: obj.lastUnit, price_per_unit: obj.lastPrice, total_amount: obj.lastTotal, indirect_charges: obj.lastIndirect, investment_type: currentInvestmentType, date: data.date || new Date().toISOString().split('T')[0] }) });
      }
      if (categoriesToPost.length) {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ party_id: data.partyId, date: data.date, investment_type: currentInvestmentType, categories: categoriesToPost }) });
      }
      await handleUserMetaUpdate(grandTotal);
      alert('Submission successful'); window.location.reload();
    } catch { alert('An error occurred during submission.'); }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // RENDER HELPERS
  // ─────────────────────────────────────────────────────────────────────────────

  const renderMatchBadge = (status: StockMatchStatus) => {
    if (status === 'matched') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">✓ Matched</span>;
    if (status === 'fuzzy') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">⚠ Fuzzy</span>;
    return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">✗ Not Found</span>;
  };

  const allRowsResolved = useMemo(() => {
    for (const sheetRows of Object.values(processedRows)) {
      for (const row of sheetRows) {
        if (row._matchStatus !== 'matched' && !row._userChoice && !row._addNew) return false;
        if (!row.date) return false;
      }
    }
    return true;
  }, [processedRows]);

  // ─────────────────────────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────────────────────────


  const handleOcrSubmit = async ({ partyId, category, batches }: {
    partyId: string;
    category: string;
    batches: { date: string; rows: OcrExtractedRow[] }[];
  }): Promise<void> => {
    if (!partyId) { alert('Please select a party'); return; }
    if (!category) { alert('Please select a category'); return; }
  
    const party = partiesList.find(p => String(p.id) === String(partyId));
    const availableTotalAmount = party?.total_amount != null ? Number(party.total_amount) : null;
    if (availableTotalAmount == null) { alert('Could not determine total amount available.'); return; }
  
    for (const batch of batches) {
      if (!batch.date) continue;
      const validRows = batch.rows.filter(r => r.stock_name?.trim());
      if (!validRows.length) continue;
  
      const rowUpdates = new Map<any, any>();
      const categoriesToPost: any[] = [];
      let grandTotal = 0;
      const datainvoiceAll: any[] = [];
  
      for (const row of validRows) {
        const amt = safeNumber(row.total_amount);
        const ind = safeNumber(row.indirect_charges);
        grandTotal += amt + ind;
  
        datainvoiceAll.push({
          id: row.id,
          stock_name: row.stock_name,
          unit: row.unit,
          total_amount: row.total_amount,
          indirect_charges: row.indirect_charges ?? '0',
          perUnitCharge: row.per_unit_charge,
          category,
          investment_type: 'structure',
          total_amount_category: row.total_amount,
        });
  
        // Check if stock already exists in DB for this party+category
        const existingRow = stocksDataDb.find(dbRow => {
          if (String(dbRow.party_id) !== String(partyId)) return false;
          const items: any[] = typeof dbRow.categories === 'string'
            ? JSON.parse(dbRow.categories)
            : dbRow.categories as any[];
          return items.some(i => i.stock_name === row.stock_name && i.category === category);
        });
  
        if (existingRow) {
          // PUT — merge into existing
          const arr: any[] = rowUpdates.has(existingRow.id)
            ? rowUpdates.get(existingRow.id).updatedCategories
            : (typeof existingRow.categories === 'string'
              ? JSON.parse(existingRow.categories)
              : [...existingRow.categories as any[]]);
  
          const target = arr.find((i: any) => i.stock_name === row.stock_name && i.category === category);
          if (target) {
            const tu = safeNumber(target.unit) + safeNumber(row.unit);
            const ta = safeNumber(target.total_amount) + amt;
            const ti = safeNumber(target.indirect_charges) + ind;
            const avgP = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0.00';
            target.unit = tu.toString();
            target.total_amount = ta.toString();
            target.indirect_charges = ti.toString();
            target.perUnitCharge = avgP;
            target.total_amount_category = ta.toString();
            target.investment_type = 'structure';
            rowUpdates.set(existingRow.id, {
              updatedCategories: arr,
              lastName: row.stock_name,
              lastCategory: category,
              lastUnit: tu.toString(),
              lastPrice: avgP,
              lastTotal: ta.toString(),
              lastIndirect: ti.toString(),
            });
          }
        } else {
          // POST — new entry
          categoriesToPost.push({
            id: row.id,
            stock_name: row.stock_name,
            unit: row.unit,
            total_amount: row.total_amount,
            indirect_charges: row.indirect_charges ?? '0',
            perUnitCharge: row.per_unit_charge,
            category,
            investment_type: 'structure',
            total_amount_category: row.total_amount,
          });
        }
      }
  
      // ── buysellrecord ──────────────────────────────────────────────────────
      try {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ date: batch.date, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }),
        });
      } catch {}
  
      // ── invoice record ─────────────────────────────────────────────────────
      try {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            farm: farmName,
            party: partyId,
            invoice_type: 'purchase',
            date: batch.date,
            datainvoice: datainvoiceAll,
          }),
        });
      } catch {}
  
      // ── PUT existing stocks ────────────────────────────────────────────────
      for (const [rowId, obj] of rowUpdates.entries()) {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rowId,
            party_id: partyId,
            categories: JSON.stringify(obj.updatedCategories),
            name: obj.lastName,
            category: obj.lastCategory,
            unit: obj.lastUnit,
            price_per_unit: obj.lastPrice,
            total_amount: obj.lastTotal,
            indirect_charges: obj.lastIndirect,
            investment_type: 'structure',
            date: batch.date,
          }),
        });
      }
  
      // ── POST new stocks ────────────────────────────────────────────────────
      if (categoriesToPost.length) {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            party_id: partyId,
            date: batch.date,
            investment_type: 'structure',
            categories: categoriesToPost,
          }),
        });
      }
  
      // ── usermeta (remaining balance) ───────────────────────────────────────
      try {
        const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${partyId}`);
        const umList = await umRes.json();
        const found = Array.isArray(umList)
          ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(partyId))
          : null;
        if (found) {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              meta_key: 'remaining',
              meta_value: (safeNumber(found.meta_value) - grandTotal).toString(),
              party_id: partyId,
            }),
          });
        } else {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              meta_key: 'remaining',
              meta_value: ((availableTotalAmount || 0) - grandTotal).toString(),
              party_id: partyId,
            }),
          });
        }
      } catch {}
    }
  
    await fetchParties();
    setShowOcrModal(false);
  };
  return (
    <>
      <div className="p-6">
        {/* ── Header ── */}
        <div className="w-full flex justify-between items-center mb-6">
          <h1 className="text-[28px] text-[#101828] font-[500]">Add New Stock</h1>
          <div className="flex gap-3">
          <button
            type="button"
            onClick={() => setShowOcrModal(true)}
            className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] py-2 px-5 rounded-[8px] shadow hover:opacity-90 transition duration-150"
          >
            <svg
              className="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="16"
                rx="2"
                stroke="currentColor"
                strokeWidth="2"
                fill="#fff"
                fillOpacity=".1"
              />
              <path
                d="M8 2v4M16 2v4M3 10h18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <circle
                cx="12"
                cy="14"
                r="3"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            </svg>
            Scan Document
          </button>
          {/* Import from Excel or XML */}
          <button
            type="button"
            onClick={() => setExcelUploadStep('setup')}
            className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#0EA5E9] to-[#6366F1] py-2 px-5 rounded-[8px] shadow hover:opacity-90 transition duration-150"
          >
            <svg
              className="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <path d="M12 3v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M4 19h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            Import Excel / XML
          </button>
   {showOcrModal ? (
  <OcrUploadModal
  partiesList={partiesList}
  stocksnames={stocksnames}
  mutualsnames={mutualsnames}
  onSubmit={handleOcrSubmit as any}
  onClose={() => setShowOcrModal(false)}
  apiUrl={process.env.REACT_APP_API_URL || ''}
/>
   ) : null}
            <button type="button" className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#1CAC70] to-[#FF9500] py-2 rounded-[8px] px-5" onClick={() => window.location.href = '/withdraw'}>Add Withdrawal</button>
            <button type="button" className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#FF9500] to-[#1CAC70] py-2 rounded-[8px] px-5" onClick={() => window.location.href = '/sell-stock'}>Sell Stock</button>
          </div>
        </div>

        {/* ── Manual Form ── */}
        <form className="bg-white p-5 w-full rounded-[10px] shadow-sm" onSubmit={handleSubmit} autoComplete="off">
          <div className="flex flex-wrap w-full justify-between mt-4 gap-4">
            {/* Party */}
            <div className="w-[100%] md:w-[48%]">
              <label htmlFor="partyId" className="text-sm font-medium text-gray-700">Party Name</label>
              <select name="partyId" id="partyId" value={data.partyId || urlParty} onChange={handleInput} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" required>
                <option value="">Choose Party</option>
                {partiesList.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
              </select>
              {selectedPartyTotalAmount !== null && <div className="text-xs text-blue-600 mt-1">Total Available: ₹{selectedPartyTotalAmount.toLocaleString()}</div>}
              {deductedAvailable !== null && <div className="text-xs mt-1" style={{ color: deductedAvailable < 0 ? '#D8000C' : '#007200' }}>Available After Deduction: ₹{deductedAvailable.toLocaleString()}</div>}
            </div>
            {/* Date */}
            <div className="w-[100%] md:w-[48%]">
              <label htmlFor="date" className="text-sm font-medium text-gray-700">Date Of Purchase</label>
              <input type="date" name="date" id="date" value={data.date} onChange={handleInput} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" />
            </div>
            {/* Investment Type */}
            <div className="w-[100%] md:w-[48%]">
              <label className="text-sm font-medium text-gray-700">Investment Type</label>
              <select value={investmentType} onChange={e => { setInvestmentType(e.target.value as any); setDirectPaymentAmount(''); setCategoryEntries({}); }} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1">
                <option value="direct">Direct Payment</option>
                <option value="structure">Structure Payment</option>
              </select>
            </div>
          </div>

          {investmentType === 'direct' && (
            <div className="mt-4 w-full md:w-[48%]">
              <label className="text-sm font-medium text-gray-700">Payment Amount</label>
              <input type="number" min={0} step="any" placeholder="Enter payment amount" value={directPaymentAmount} onChange={e => setDirectPaymentAmount(e.target.value)} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" required />
            </div>
          )}

          {/* Categories */}
          {(data.partyId || urlParty) && (
            <div className="mt-6">
              <p className="text-sm font-semibold text-gray-700 mb-3">Categories</p>
              <div className="flex flex-col gap-3">
                {possibleCategories.map(cat => {
                  const entries = categoryEntries[cat.category_name] || [];
                  const isMutual = isMutualCategory(cat.category_name);
                  return (
                    <div key={cat.id} className="flex flex-col">
                      <label className="flex items-center gap-2 cursor-pointer text-[#344054] text-[15px] font-medium">
                        <input type="checkbox" checked={isChecked(cat)} onChange={() => handleCategory(cat)} className="w-4 h-4 accent-[#FF9500]" />
                        {cat.category_name}
                      </label>
                      {isChecked(cat) && investmentType === 'structure' && (
                        <div className="ml-6 mt-2 flex flex-col gap-3 border-l-2 border-[#ececec] pl-4">
                          {entries.map((entry, ei) => (
                            <div key={entry.id} className="flex flex-wrap gap-2 items-end bg-gray-50 p-3 rounded-lg relative">
                              {/* ID */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">ID</label>
                                <input type="text" value={entry.id} readOnly className="w-[52px] bg-gray-100 border border-[#D0D5DD] p-2 rounded-[8px] text-[#5E5E5E] text-[12px] outline-none" />
                              </div>
                              {/* Stock Name with AsyncSelect + Add button */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">Stock Name</label>
                                <div className="flex gap-1 items-center">
                                  <AsyncSelect
                                    cacheOptions
                                    defaultOptions={false}
                                    loadOptions={(input, cb) => {
                                      if (!input || input.length < 1) { cb([]); return; }
                                      const src = isMutual ? mutualsnames : stocksnames;
                                      const filtered = src.filter(s => s.name?.toLowerCase().includes(input.toLowerCase())).slice(0, 100).map(s => ({ value: s.name, label: s.name }));
                                      cb(filtered);
                                    }}
                                    value={entry.stockName ? { value: entry.stockName, label: entry.stockName } : null}
                                    onChange={sel => handleCategoryFieldChange(cat, ei, 'stockName', sel?.value || '')}
                                    placeholder={isMutual ? 'Search Mutual Fund...' : 'Search Stock...'}
                                    noOptionsMessage={({ inputValue }) =>
                                      inputValue?.length > 0
                                        ? <span className="text-xs text-gray-500">No match — type to search or use "+" to add</span>
                                        : <span className="text-xs text-gray-400">Type to search…</span>
                                    }
                                    styles={{ control: (b) => ({ ...b, borderRadius: '8px', borderColor: '#D0D5DD', minHeight: '38px', width: '210px', fontSize: '13px' }) }}
                                  />
                                  {/* Task 2: Add stock button */}
                                  <button
                                    type="button"
                                    title="Add new stock name"
                                    onClick={() => {
                                      setAddStockModalCategory(isMutual ? 'mutual' : 'stocks');
                                      setPendingNewStockName(entry.stockName || '');
                                      addStockCallbackRef.current = (name: string) => {
                                        handleCategoryFieldChange(cat, ei, 'stockName', name);
                                      };
                                      setShowAddStockModal(true);
                                    }}
                                    className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 transition font-bold text-lg"
                                    style={{ flexShrink: 0 }}
                                  >
                                    +
                                  </button>
                                </div>
                                {entry.stockName && !(isMutual ? mutualsnames : stocksnames).some(s => s.name.toLowerCase() === entry.stockName.toLowerCase()) && (
                                  <span className="text-[10px] text-amber-600 mt-0.5 flex items-center gap-1">
                                    ⚠ Not in database —
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setAddStockModalCategory(isMutual ? 'mutual' : 'stocks');
                                        setPendingNewStockName(entry.stockName);
                                        addStockCallbackRef.current = (name: string) => handleCategoryFieldChange(cat, ei, 'stockName', name);
                                        setShowAddStockModal(true);
                                      }}
                                      className="underline text-blue-600 hover:text-blue-800"
                                    >
                                      Add to database?
                                    </button>
                                  </span>
                                )}
                              </div>
                              {/* Unit */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">Unit</label>
                                <input type="number" min={0} step="any" placeholder="Unit" value={entry.unit} onChange={e => handleCategoryFieldChange(cat, ei, 'unit', e.target.value)} className="w-[100px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
                              </div>
                              {/* Total Amount */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">Total Amount</label>
                                <input type="number" min={0} step="any" placeholder="Amount" value={entry.totalAmount} onChange={e => handleCategoryFieldChange(cat, ei, 'totalAmount', e.target.value)} className="w-[120px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
                              </div>
                              {/* Indirect Charges */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">Indirect Charges</label>
                                <input type="number" min={0} step="any" placeholder="Charges" value={entry.indirectCharges} onChange={e => handleCategoryFieldChange(cat, ei, 'indirectCharges', e.target.value)} className="w-[110px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
                              </div>
                              {/* Per Unit Charge */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">Per Unit Charge</label>
                                <input type="number" min={0} step="any" placeholder="Per unit" value={entry.perUnitCharge} onChange={e => handleCategoryFieldChange(cat, ei, 'perUnitCharge', e.target.value)} readOnly={entry.autoCalculated && !!entry.unit} className={`w-[110px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none ${entry.autoCalculated && !!entry.unit ? 'bg-gray-100' : ''}`} required />
                                {entry.autoCalculated && !!entry.unit && <span className="text-[10px] text-green-500">Auto-calc</span>}
                              </div>
                              {/* Remove */}
                              <button type="button" onClick={() => handleRemoveEntry(cat, ei)} className="text-red-400 hover:text-red-600 border border-red-200 bg-red-50 rounded px-2 py-1 text-xs h-[34px]">Remove</button>
                            </div>
                          ))}
                          <button type="button" onClick={() => handleAddEntry(cat)} className="text-sm text-blue-500 font-medium px-3 py-1 border border-blue-200 rounded bg-blue-50 w-fit hover:bg-blue-100 transition">+ Add row for {cat.category_name}</button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <button type="submit" className="mt-6 text-[16px] font-[500] text-white bg-gradient-to-r from-[#1CAC70] to-[#FF9500] py-2 rounded-[8px] px-8 hover:opacity-90 transition">Submit</button>
        </form>
      </div>

      {/* ══════════════════════════════════════════════════════════════════════════
          EXCEL / XML UPLOAD MODAL — STEP: SETUP
      ══════════════════════════════════════════════════════════════════════════ */}
      {excelUploadStep === 'setup' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] px-6 py-5">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl font-bold text-white">Upload Excel or XML Data</h2>
                  <p className="text-indigo-200 text-sm mt-0.5">Step 1 of 2 — Configure import settings</p>
                </div>
                <button onClick={() => { setExcelUploadStep('idle'); setExcelFiles([]); }} className="text-white/70 hover:text-white text-2xl">×</button>
              </div>
            </div>

            <div className="p-6 flex flex-col gap-4">
              {/* Party */}
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Party Name <span className="text-red-500">*</span></label>
                <select value={excelSetupPartyId} onChange={e => { setExcelSetupPartyId(e.target.value); setExcelSetupCategory(''); }} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400">
                  <option value="">Choose Party</option>
                  {partiesList.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
                </select>
              </div>
              {/* Category */}
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Category <span className="text-red-500">*</span></label>
                <select value={excelSetupCategory} onChange={e => setExcelSetupCategory(e.target.value)} disabled={!excelSetupPartyId} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400 disabled:bg-gray-100">
                  <option value="">Select Category</option>
                  {excelSetupPossibleCategories.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              {/* Date — hidden/optional when an XML file is present, since each
                  transaction in the XML already carries its own date. */}
              {!hasXmlFile && (
                <div>
                  <label className="text-sm font-semibold text-gray-700 block mb-1">Purchase Date <span className="text-red-500">*</span></label>
                  <input type="date" value={excelSetupDate} onChange={e => setExcelSetupDate(e.target.value)} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400" />
                </div>
              )}
              {hasXmlFile && (
                <div className="bg-indigo-50 border border-indigo-100 rounded-lg px-3 py-2 text-xs text-indigo-700">
                  📅 Dates will be read automatically from the XML file — no need to pick one here.
                </div>
              )}

              {/* File Upload */}
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-2">Excel or XML Files <span className="text-red-500">*</span></label>
                <div
                  className="border-2 border-dashed border-indigo-200 rounded-xl p-6 text-center cursor-pointer hover:border-indigo-400 hover:bg-indigo-50/50 transition"
                  onClick={() => excelFileInputRef.current?.click()}
                >
                  <div className="text-3xl mb-2">📊</div>
                  <p className="text-sm text-gray-600 font-medium">Click to browse or drop files here</p>
                  <p className="text-xs text-gray-400 mt-1">Supports .xlsx, .xls, and .xml — multiple files allowed, all sheets/rows imported</p>
                  <p className="text-xs text-indigo-500 mt-1 font-medium">Excel columns / XML fields: <code className="bg-indigo-50 px-1 rounded">stock_name</code>, <code className="bg-indigo-50 px-1 rounded">unit</code>, <code className="bg-indigo-50 px-1 rounded">total_amount</code></p>
                </div>
                <input ref={excelFileInputRef} type="file" accept=".xlsx,.xls,.xml" multiple className="hidden" onChange={handleExcelFilesChange} />
                {excelFiles.length > 0 && (
                  <div className="mt-3 flex flex-col gap-1.5">
                    {excelFiles.map((f, i) => (
                      <div key={i} className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
                        <div className="flex items-center gap-2">
                          <span className="text-green-500">{f.name.toLowerCase().endsWith('.xml') ? '🗂️' : '📄'}</span>
                          <span className="text-sm text-gray-700 font-medium">{f.name}</span>
                          <span className="text-xs text-gray-400">({(f.size / 1024).toFixed(1)} KB)</span>
                        </div>
                        <button type="button" onClick={() => removeExcelFile(i)} className="text-red-400 hover:text-red-600 text-lg leading-none">×</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {excelSetupError && (
                <div className="bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-xs text-red-700 whitespace-pre-line">
                  ⚠ {excelSetupError}
                </div>
              )}

              {/* Replace the proceed button section in setup modal */}
<div className="flex gap-3 mt-2">
  <button
    type="button"
    onClick={() => { setExcelUploadStep('idle'); setExcelFiles([]); setExcelSetupError(null); }}
    disabled={excelParsing}
    className="flex-1 border border-gray-300 text-gray-700 rounded-lg py-2.5 font-medium hover:bg-gray-50 transition disabled:opacity-50"
  >
    Cancel
  </button>
  <button
    type="button"
    onClick={handleExcelProceed}
    disabled={excelParsing}
    className="flex-1 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white rounded-lg py-2.5 font-medium hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
  >
    {excelParsing ? (
      <span className="flex items-center justify-center gap-2">
        <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
        </svg>
        Processing rows…
      </span>
    ) : 'Preview & Review →'}
  </button>
</div>

            </div>
          </div>
        </div>
      )}
     

      {/* ══════════════════════════════════════════════════════════════════════════
          EXCEL / XML UPLOAD MODAL — STEP: REVIEW
      ══════════════════════════════════════════════════════════════════════════ */}
      {excelUploadStep === 'review' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl mx-4 flex flex-col" style={{ maxHeight: '90vh' }}>
            {/* Header */}
            <div className="bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] px-6 py-5 rounded-t-2xl flex-shrink-0">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl font-bold text-white">Review Import Data</h2>
                  <p className="text-indigo-200 text-sm mt-0.5">Step 2 of 2 — Verify stock matches and resolve conflicts</p>
                </div>
                <button onClick={() => setExcelUploadStep('setup')} className="text-white/70 hover:text-white text-2xl">×</button>
              </div>
              {/* Summary bar */}
              <div className="flex gap-4 mt-3">
                {(() => {
                  let matched = 0, fuzzy = 0, unmatched = 0;
                  Object.values(processedRows).flat().forEach(r => {
                    if (r._matchStatus === 'matched') matched++;
                    else if (r._matchStatus === 'fuzzy') fuzzy++;
                    else unmatched++;
                  });
                  const total = matched + fuzzy + unmatched;
                  return (
                    <>
                      <div className="bg-white/20 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{total}</span> total rows</div>
                      <div className="bg-green-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{matched}</span> matched</div>
                      {fuzzy > 0 && <div className="bg-yellow-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{fuzzy}</span> fuzzy</div>}
                      {unmatched > 0 && <div className="bg-red-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{unmatched}</span> not found</div>}
                    </>
                  );
                })()}
              </div>
            </div>

            {/* Content */}
            <div className="overflow-y-auto flex-1 p-6">
              {Object.entries(processedRows).map(([sheetKey, rows]) => {
                const parts = sheetKey.split('__');
                const fileName = parts[1], sheetName = parts[2];
                return (
                  <div key={sheetKey} className="mb-8">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="bg-indigo-100 text-indigo-700 rounded-lg px-3 py-1 text-sm font-semibold">
                        {fileName?.toLowerCase().endsWith('.xml') ? '🗂️' : '📄'} {fileName}
                      </div>
                      <div className="bg-gray-100 text-gray-600 rounded-lg px-3 py-1 text-sm">Sheet: {sheetName}</div>
                      <div className="text-xs text-gray-400">{rows.length} rows</div>
                    </div>
                    <div className="border border-gray-200 rounded-xl overflow-hidden">
                      <table className="w-full text-sm">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">#</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Source Stock Name</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Status</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Final Name</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Date</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Unit</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Amount</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((row, ri) => (
                            <tr key={row._rowId} className={`border-t border-gray-100 ${row._matchStatus === 'matched' ? 'bg-green-50/30' : row._matchStatus === 'fuzzy' ? 'bg-yellow-50/30' : 'bg-red-50/30'}`}>
                              <td className="px-4 py-3 text-gray-500">{ri + 1}</td>
                              <td className="px-4 py-3 font-medium text-gray-800">
                                <input
                                  type="text"
                                  value={row.stock_name}
                                  onChange={e => updateProcessedRow(sheetKey, row._rowId, { stock_name: e.target.value })}
                                  className="border border-gray-200 rounded px-2 py-1 text-xs w-36 focus:outline-none focus:border-indigo-400 bg-transparent"
                                />
                              </td>
                              <td className="px-4 py-3">{renderMatchBadge(row._matchStatus)}</td>
                              <td className="px-4 py-3">
                                {row._addNew
                                  ? <input type="text" placeholder="New stock name" value={row._newStockName || ''} onChange={e => updateProcessedRow(sheetKey, row._rowId, { _newStockName: e.target.value })} className="border border-blue-300 rounded-lg px-2 py-1 text-xs w-40 focus:outline-none focus:border-blue-500" />
                                  : row._matchStatus === 'matched'
                                    ? <span className="text-green-700 font-medium">{row._matchedName}</span>
                                    : <select value={row._userChoice || ''} onChange={e => updateProcessedRow(sheetKey, row._rowId, { _userChoice: e.target.value })} className="border border-gray-300 rounded-lg px-2 py-1 text-xs w-44 focus:outline-none focus:border-indigo-400">
                                        <option value="">— select match —</option>
                                        {row._candidateMatches?.map(c => <option key={c} value={c}>{c}</option>)}
                                      </select>
                                }
                              </td>
                              <td className="px-4 py-3">
                                <input
                                  type="date"
                                  value={row.date || ''}
                                  onChange={e => updateProcessedRow(sheetKey, row._rowId, { date: e.target.value })}
                                  className="border border-gray-200 rounded px-2 py-1 text-xs w-36 focus:outline-none focus:border-indigo-400"
                                />
                              </td>
                              <td className="px-4 py-3">
                                <input
                                  type="number"
                                  value={row.unit}
                                  onChange={e => updateProcessedRow(sheetKey, row._rowId, { unit: e.target.value })}
                                  className="border border-gray-200 rounded px-2 py-1 text-xs w-20 focus:outline-none focus:border-indigo-400"
                                />
                              </td>
                              <td className="px-4 py-3">
                                <input
                                  type="number"
                                  value={row.total_amount}
                                  onChange={e => updateProcessedRow(sheetKey, row._rowId, { total_amount: e.target.value })}
                                  className="border border-gray-200 rounded px-2 py-1 text-xs w-24 focus:outline-none focus:border-indigo-400"
                                />
                              </td>
                              <td className="px-4 py-3">
                                {row._matchStatus !== 'matched' && (
                                  row._addNew
                                    ? <button type="button" onClick={() => updateProcessedRow(sheetKey, row._rowId, { _addNew: false, _newStockName: '', _userChoice: '' })} className="text-xs text-gray-500 hover:text-gray-700 underline">Cancel</button>
                                    : <button type="button" onClick={() => updateProcessedRow(sheetKey, row._rowId, { _addNew: true, _userChoice: '', _newStockName: row.stock_name })} className="text-xs bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 rounded px-2 py-1 transition">+ Add New</button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 rounded-b-2xl flex-shrink-0 flex items-center justify-between">
              <div className="text-sm text-gray-500">
                {!allRowsResolved
                  ? <span className="text-amber-600 font-medium">⚠ Some rows need attention (select a match, add new, or set a date)</span>
                  : <span className="text-green-600 font-medium">✓ All rows resolved — ready to import</span>
                }
              </div>
              <div className="flex gap-3">
                <button type="button" onClick={() => setExcelUploadStep('setup')} className="border border-gray-300 text-gray-700 rounded-lg px-5 py-2 text-sm font-medium hover:bg-gray-100 transition">← Back</button>
                <button
                  type="button"
                  disabled={!allRowsResolved || excelSubmitLoading}
                  onClick={handleExcelSubmit}
                  className="bg-gradient-to-r from-[#1CAC70] to-[#059669] text-white rounded-lg px-6 py-2 text-sm font-medium hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {excelSubmitLoading ? 'Importing...' : `Import ${Object.values(processedRows).flat().length} Rows`}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════════════════════
          ADD STOCK NAME MODAL (Task 2)
      ══════════════════════════════════════════════════════════════════════════ */}
      {showAddStockModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden">
            <div className="bg-gradient-to-r from-[#3B82F6] to-[#6366F1] px-6 py-4">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-bold text-white">Add New Stock Name</h3>
                <button onClick={() => { setShowAddStockModal(false); setPendingNewStockName(''); }} className="text-white/70 hover:text-white text-xl">×</button>
              </div>
              <p className="text-blue-200 text-xs mt-1">This will add the stock to the {addStockModalCategory === 'mutual' ? 'Mutual Funds' : 'Equity'} database</p>
            </div>
            <div className="p-6 flex flex-col gap-4">
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Stock Name</label>
                <input
                  type="text"
                  placeholder={addStockModalCategory === 'mutual' ? 'e.g. Axis Bluechip Fund' : 'e.g. INFY'}
                  value={pendingNewStockName}
                  onChange={e => setPendingNewStockName(e.target.value)}
                  className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-blue-400"
                  autoFocus
                  onKeyDown={e => e.key === 'Enter' && handleAddStockName()}
                />
              </div>
              <div className="bg-blue-50 rounded-lg p-3 text-xs text-blue-700">
                <strong>Adding to:</strong> {addStockModalCategory === 'mutual' ? 'Mutual Funds database (mutualfunds_stock_name)' : 'Equity/Stock database (stocknames)'}
              </div>
              <div className="flex gap-3">
                <button type="button" onClick={() => { setShowAddStockModal(false); setPendingNewStockName(''); }} className="flex-1 border border-gray-300 text-gray-700 rounded-lg py-2 font-medium hover:bg-gray-50 transition">Cancel</button>
                <button type="button" onClick={handleAddStockName} disabled={addStockLoading || !pendingNewStockName.trim()} className="flex-1 bg-gradient-to-r from-[#3B82F6] to-[#6366F1] text-white rounded-lg py-2 font-medium hover:opacity-90 transition disabled:opacity-50">
                  {addStockLoading ? 'Adding...' : 'Add Stock'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Addstock;